import $ from 'jquery';
import api from './../../service/apiService'
import { Service, Contract, BuildProduct, ContractConstants, FutureNotification, DOFlow, Save , EquipmentDiscounts, Pages} from './../../constants/actionType'
import { apiUrl } from './../../constants/apiUrl'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../../service/logService';
import {
    getCartHeader,
    getCartData,
    getCartProducts,
    getSelectedChannels,
    getCartDataDefault,
    getSelectedTv,
} from './../../util/change/cartUtility';
import { ModalWindow, CartServices, PAGEACTIVITY, OfferTypes } from './../../constants/actionType';
import * as modalAction from './../../action/change/modalWindow';
import * as prefetchAction from './../../action/change/prefetch';
import { redirectTo } from './../../action/redirection';
import { errorAction } from './error';
import { loaderActive } from './loder';
import { updateNonProduct } from './../../util/commonUtil';
import { updateSCTags, updateSCcustomEvent, tempSCData, addToCartSCEvent, scClickEventProduct, scUnselectEventProduct } from './../../service/change/dtmTag';
import { InHomeUtils } from './../../util/inhomeUtils'
import { logNRTime } from './../../util/commonUtil';
import { getNRCurrentTime } from './../../util/commonUtil';
import * as checkoutAction from './../checkout';
import { updatecartEvent, setPegaButtonStatus, addProductCurrent, updateVzdlSCCustomEvent } from './../../service/change/vzdl';
import * as tvrecommendedAction from './../../action/change/tvRecommender';
import * as cartActions from './../../action/change/cart'
import { store } from "../../../src/index"/**importing store for reducer values */
import * as buildProductAction from './../../action/change/buildProduct';
import { vzdlErrorUpdate ,updateSubFlowValue } from './../../service/vzdl';
import { getOffersFilter } from './../../action/buildProduct';
import { midniteProds } from '../../containers/midnight/cms/products';
import { gigSplOffers, splOffersAPIRes } from '../../constants/change/choiceOffersMockData';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
let kafkaPageLogs = apiUrl().kafkaPageLogs;

let statevalue = ""
let addonProducts= "";

const getRequest = (visitId, contract, serviceType, couponFlowType = null, isPegaFlow = false, isRouterUpgrade = false) => {
    let isPromo = true;
    if (serviceType === Service.voice) {
        isPromo = false
    }
    let intents = [];
    if (couponFlowType !== null) {
        if (couponFlowType === "Employee" || couponFlowType === "Retiree") {
            intents.push({ "key": "Employee", "value": "Y" })
        }
        else if (couponFlowType === "Affinity") {
            intents.push({ "key": "Affinity", "value": "Y" })
        }
    }
    let pageVerison = '';
    let skipMM3Payload = (contract === Contract.monthToMonth && (serviceType === 'Data' || serviceType === 'Video' || serviceType === 'Fios_Voice' )) ? true : false;
    let internetObj = store.getState().buildProduct?.internet;
    if(internetObj && internetObj.isMM3PageVersion && !skipMM3Payload){
        pageVerison = 'MM3';
    }
    let request = { 
        uid: visitId,
        idType: 'visit',
        contract: contract === 'MTM' ? 'MTM' : 'TWOYEAR',
        isPromoInclude: isPromo,
        serviceType: serviceType,
        "intents": intents,
        pageVersion: pageVerison,
        isPegaFlow: isPegaFlow ? true : false
    }
    if (isRouterUpgrade) {
        request.isRouterUpgradeCheck = true;
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getRequest', JSON.stringify(request)));
    logKafka("INFO", "BuildProduct", JSON.stringify(request), kafkaPageLogs, "applogs", visitId);
    return JSON.stringify(request);
}
export const GetCheckoutThrottle = (dispatch) => {
    try {
        const url = apiUrl().getMovesThrottle;
        return new Promise((resolve) => {
            api(url, 'GET', '').then((response) => {
                let data = response?.data?.throttleList || ""; 
                data = data.split("|")
                // if(data.indexOf("fios_co")!=-1){
                //     dispatch({type : 'ENABLE_NEW_CHECKOUT_FLOW', value : true})

                //     window.sessionStorage.setItem('urccheckout', 'true')
                // }
                // if(data.indexOf("fios_ec")!=-1){
                //     dispatch({type: 'SET_ECMIDNIGHT', value : true})
                //     dispatch({type : 'ENABLE_NEW_BPP_HEADER', value : true})
                //     window.sessionStorage.setItem('urcbpp', 'true')
                // }
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:GetCheckoutThrottle,errorMessage:${error.message}`;
              logKafka('ERROR', 'GetCheckoutThrottle_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('GetMovesThrottle', 'GetMovesThrottle', error);
    }
}
const getPremiumChannelRequest = (visitId, contract, serviceType, selectedProductId) => {
    let lstProductId = [];
    if (InHomeUtils.isNotNull(selectedProductId) && selectedProductId !== "")
        lstProductId.push(selectedProductId);
    let request = {
        uid: visitId,
        idType: 'visit',
        contract: contract,
        isPromoInclude: true,
        serviceType: serviceType,
        selectedProduct: lstProductId
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPremiumChannelRequest', JSON.stringify(request)));
    logKafka("INFO", "BuildProduct", JSON.stringify(request), kafkaPageLogs, "applogs", visitId);
    return JSON.stringify(request);
}

const getRequestChannel = (visitid, zipcode, tarcode) => {
    let request = {
        zipcode: zipcode,
        tarcode: tarcode,
        visitid: visitid
    }
    // if (serviceType === 'battery') {
    //     request = {
    //         uid: visitId,
    //         contract: contract
    //     }
    // }
    logOtherInfo(detailsInfo('BuildProduct', visitid, 'getRequestChannel', JSON.stringify(request)));
    return JSON.stringify(request);
}

const getRequestMultiUseoffer = (coupon) => {
    var someDate = new Date();
    var numberOfDaysToAdd = 7;
    someDate.setDate(someDate.getDate() + numberOfDaysToAdd)
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var y = someDate.getFullYear();
    var someFormattedDate = dd + '/' + mm + '/' + y;

    let request = {
        "code": coupon,
        "expirationDate": someFormattedDate,
        "leadListId": '',
        "type": "MUC"
    }
    return JSON.stringify(request);
};

const getRequestChatoffer = (product, specialOffer, contract) => {
    let request = {
        productId: specialOffer.Target,
        offerId: specialOffer.OfferId, //'36272';
        promoId: specialOffer.USOCIOSC, //'Q4645';
        productType: "OFFER",
        serviceType: specialOffer.BsOfferAttr === 'EQUIPMENT' ? "VIDEO" : "DATA",
        quantity: '1',
        contract: contract === 'TWOYEAR' ? 'TWOYEAR' : 'MTM',
        status: 'add',
        bundleId: product.bundleId, //'B0014';
        offerCombinationId: product.offerTileId, //'24#7603:,32369,7196,36104,36272,7199,32272,32588,36056,3435,4616,36076,36077';
        bundleKey: product.bundleKey,//'FTTP_1000M_1000M:Q2493:FVPRIMARY'; 
    }
    return JSON.stringify(request);
};

const getRequestSpecialoffer = (specialOffer, contract) => {
    let request = {
        productId: specialOffer.Target,
        offerId: specialOffer.OfferId, //'36272';
        promoId: specialOffer.USOCIOSC, //'Q4645';
        productType: "OFFER",
        serviceType: 'OFFER',
        quantity: '1',
        contract: (contract === 'TWOYEAR' || contract === '2YR') ? 'TWOYEAR' : 'MTM',
        status: 'add',
        //bundleId: product.bundleId, //'B0014';
        //offerCombinationId: product.offerTileId, //'24#7603:,32369,7196,36104,36272,7199,32272,32588,36056,3435,4616,36076,36077';
        //bundleKey: product.bundleKey,//'FTTP_1000M_1000M:Q2493:FVPRIMARY'; 
    }
    return JSON.stringify(request);
};

const getRequestfuturenotification = (visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress,
    contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd) => {
    let request = {
        "telNbr": telNbr,
        "addrId": addrId,
        "firstName": firstName,
        "lastName": lastName,
        "businessName": businessName,
        "addressLine1": addressLine1,
        "addressLine2": addressLine2,
        "city": city,
        "state": state,
        "zipCode": zipCode,
        "emailAddress": emailAddress,
        "contactPhone": contactPhone,
        "vzPhone": vzPhone,
        "notifyFios": notifyFios,
        "notifyFiosTv": notifyFiosTv,
        "appId": appId,
        "nsiInd": nsiInd
    }
    return JSON.stringify(request);
};

const validateReferralCode = (visitId, coupon) => {
    let request = {
        "visitId": visitId,
        "refCode": coupon,
        "refMode": "",
        "client": "VZCOM"
    }
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'validateReferralCode', JSON.stringify(request)));
    logKafka("INFO", "BuildProduct-validateReferralCode", JSON.stringify(request), kafkaPageLogs, "applogs", visitId);
    return JSON.stringify(request);
};

const getContractRequest = (contract) => {
    let request = {
        key: ContractConstants.contractChange,
        value: contract === ContractConstants.twoYear ? ContractConstants.twoYearInWords : ContractConstants.monthToMonth,
        action: "add"
    }
    return JSON.stringify(request)
}

export const spanishTab = (dispatch, status,index) => {
    dispatch({ type: 'SPANISH_TV', value: status});
}

const getStdRequest = (contract, prod, serviceType, isChecked, selectedCoreServices, voiceTn, routerProduct = null, isInternetOnProfile = false, isFiosTvOneSelected = false,isVecFlow, VecContractServices)  => {
    let baseType = serviceType;
    if (serviceType === Service.internet || serviceType === Service.fne || serviceType === Service.fneDeviceCount || serviceType === Service.streamServ || serviceType === Service.streamDev || serviceType === Service.streamDevCount) {
        serviceType = Service.data
    }

    if (serviceType === Service.tv || serviceType === Service.customTV || serviceType === Service.vRoom || serviceType === Service.recording || serviceType === Service.channel || serviceType === Service.dct || serviceType === Service.intrnlChnl ||serviceType === Service.fiosTvOne || serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle || serviceType === Service.dummyvRoom) {
        serviceType = Service.video
    }

    if (serviceType === Service.voice || serviceType === Service.intlPlans || serviceType === Service.listing || serviceType === Service.battery || serviceType === Service.batteryshipment || serviceType === Service.intlPlans || serviceType === Service.callingFeature || serviceType === Service.longDistance || serviceType === Service.wireMaintenance) {
        serviceType = Service.voice;
    }

    if (serviceType === Service.router || serviceType === Service.accessPoint) {
        if ((InHomeUtils.isNotNull(selectedCoreServices) && selectedCoreServices !== '' && selectedCoreServices.indexOf(Service.data) > -1) || isInternetOnProfile)
            serviceType = Service.data
        else if (InHomeUtils.isNotNull(selectedCoreServices) && selectedCoreServices !== '' && selectedCoreServices.indexOf(Service.video) > -1)
            serviceType = Service.video
        else
            serviceType = Service.data
    }

    if (serviceType === Service.techSure || serviceType === Service.cloud) {
        if(prod?.name === 'Home Security' || prod?.name === 'Home Security Plus'){
            serviceType = 'DATA';
            }else{
        serviceType = Service.vasService;
        prod.isprdOnProfile?isChecked=!prod.disconnect:isChecked
        }
       
    }

    if(prod?.prodType === 'VHSBILLER' || prod?.prodType === 'DHSBILLER'){
        serviceType = 'DATA';
    }

    let productId = ''
    let productType = ''
    if(prod && prod[0] && prod[0].name.indexOf('Your') > -1){
        productId = prod[0].id;
        productType = prod[0].prodType;
    }else{
        productId = prod.id || prod.prodId;
        productType = prod.prodType;
    }
    
    if(InHomeUtils.isNotNull(prod.rcType) && prod.rcType === Service.fneDeviceCount) {
        productType = prod.rcType;
    }
    let qty = ((productType === Service.streamDevCount||  productType == 'NETWORKEXTENDERMRC' || productType == Service.fneDeviceCount || productType === Service.ceAppsParity) && prod.unitCount) ? prod.unitCount : "1";

    if (productType === Service.streamDevCount) {
        productType = Service.streamDev;
    }

    if (productType == Service.fneDeviceCount) {
        productType = prod.rcType;
    }

    if (prod.prodType === Service.streamServ) {
        serviceType = Service.data
        contract = ContractConstants.monthToMonth;
    }

    // if (routerProduct !== null) {
    //     productId += "," + routerProduct.id;
    //     productType += "," + routerProduct.prodType;
    // }
    if(serviceType === Service.data && isVecFlow){
        if(VecContractServices.toLocaleLowerCase().indexOf('data') > -1)
            contract =  ContractConstants.twoYearInWords;
        else
            contract =  ContractConstants.monthToMonth;
    }
    
    const {VMSProductSelected, StreamTVProductSelected, vms41001100Eligible} = store.getState().buildProduct?.tv;
    if(serviceType == Service.video && prod.name?.indexOf("Video Media") > -1 && vms41001100Eligible){
        if(!VMSProductSelected){
            isChecked = true;
        }else {
            isChecked = false;
        }
    } 
    if(!StreamTVProductSelected && prod.name?.indexOf("Fios TV+")>-1){
        isChecked = true;
    }
    if(store.getState().pegaRecommendation?.pegafeedbackarray?.length > 1){
        contract = ContractConstants.monthToMonth
    }

    if((baseType == Service.channel || baseType == Service.intrnlChnl || baseType == Service.callingFeature || baseType == Service.recording) && prod.isprdOnProfile){
        if(prod.isprdRemoved){
            isChecked = false;
        }else{
            isChecked = true;
        }
    } 
    let productQuantity = store.getState().buildProduct?.accessoriesProductCount;
    let isMnHAuthenticated = store.getState().buildProduct?.internet?.mnhSignupIndicator;
    if(productQuantity > 0){
        qty = productQuantity;
        isChecked = false;
    }
    let apBuyCount = store.getState().buildProduct?.apBuyCount
    if(apBuyCount > 0){
        qty = apBuyCount;
        isChecked = false;
    }
    if(prod?.prodTypeValue == 'ACCESSORIES' && prod?.prodType === 'ACCESSPOINTBILLER'){
        qty = prod?.unitCount;
        serviceType = Service.data
    }
    let request = {
        contract: contract,
        productId: productId,
        productType: productType,
        quantity: qty,
        serviceType: serviceType,
        status: isChecked ? "remove" : "add",
        isMnHAuthenticated : isMnHAuthenticated,
        apitype : (prod?.prodTypeValue == 'ACCESSORIES') ? 'extender' : 'router',
    }

//store.getState().buildProduct?.accessoriesProductCount = 0;

    // if(productType=='NETWORKEXTENDERMRC'){
    //     request = {
    //         ...request,
    //     productId: "R0642:add,Q7757:add",
    //     productType: "NETWORKEXTENDERMRC,NETWORKEXTENDERMRC",
    //     quantity: "1"

    //     }
    // }
    if (serviceType === Service.voice) {
        request.tn = voiceTn
    }

    if (prod.prodType === Service.fiosTvOne) {
        request.productId = "",
        request.productType=""
    }

    if (((prod.prodType === Service.vRoom || prod.prodType === Service.recording) && isFiosTvOneSelected && !(prod.productId === "VMS1100" || prod.id === "VMS1100")) || (prod.prodType === Service.fiosTvOne)) {
        request.category= "FIOSTVONE"
    }

    if(prod.prodType === Service.fiosTvOne && prod.name == "Fios TV+"){
        request.category= "STREAMTV"
    }
    
    if (prod.productId === "VMS1100" || prod.id === "VMS1100") {
        request.productId = "",
        request.productType="",
        request.category= "VMS1100"

    }
    let {vms1100Eligible} =  store.getState().buildProduct.tv
    if(isFiosTvOneSelected &&vms1100Eligible && prod.prodType === Service.vRoom){
        request.category= "VMS1100"
    }

    if (prod.fiosFiveSelectedChannels && prod.fiosFiveSelectedChannels.length > 0) {
        updateFiosFiveCartReqObj(request, prod);
    }

    if (baseType ===  Service.intrnlChnl) {
        updateIntlPackageCartReqObj(request, prod);
    }

    return JSON.stringify(request)
}

const getBundleRequest = (contract, prod, serviceType, isChecked, voiceTn, selectedCoreServices, isLocalTVInCart, isFCPflow, isOptOut , isFiosTvOneSelected = false,isVecFlow,VecContractServices, pegaBundle = null) => {
    let baseType = serviceType;
    let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
    const isDisconnected = flowRouteValue === "FULLDISCONNECT";
    if (serviceType === Service.internet)
        serviceType = Service.data
    if (serviceType === Service.tv || serviceType === Service.customTV || serviceType === Service.intrnlChnl || serviceType === Service.vRoom || serviceType === Service.recording || serviceType === Service.channel || serviceType === Service.dct || serviceType === Service.fiosTvOne || serviceType === Service.ceAppsParity || serviceType === Service.ceAppsBundle || serviceType === Service.dummyvRoom)
        serviceType = Service.video
    if (serviceType === Service.voice || serviceType === Service.listing || serviceType === Service.battery)
        serviceType = Service.voice
    if (serviceType === Service.router) {
        if (InHomeUtils.isNotNull(selectedCoreServices) && selectedCoreServices !== '' && selectedCoreServices.indexOf(Service.data) > -1)
            serviceType = Service.data
        else
            serviceType = Service.video
    }
    if (serviceType === Service.fne)
        serviceType = Service.data
    if (isFCPflow) {
        contract = ContractConstants.monthToMonth;
    }
    // else if (isLocalTVInCart && !isChecked && prod.prodType === "BASIC" && prod.prodTypeValue !== "LOCLDGTL") {
    //     contract = ContractConstants.twoYearInWords;
    // }
    // else if (isLocalTVInCart) {
    //     contract = ContractConstants.monthToMonth;
    // }

    if (prod.prodType === Service.streamServ) {
        serviceType = Service.data
        contract = ContractConstants.monthToMonth;
    }

    if(serviceType === Service.data && isVecFlow){
        if(VecContractServices.toLocaleLowerCase().indexOf('data') > -1)
            contract =  ContractConstants.twoYearInWords;
        else
            contract =  ContractConstants.monthToMonth;
    }

    if(prod.offerTileId && prod.offerTileId.includes("24#")){
       contract = ContractConstants.twoYearInWords;
    } else{
       contract =  ContractConstants.monthToMonth;
    }

    let isMnHAuthenticated = store.getState().buildProduct?.internet?.mnhSignupIndicator;

    let request = {
        bundleId: prod.bundleId,
        bundleKey: pegaBundle && InHomeUtils.isNotNull(pegaBundle[0]) ? pegaBundle[0] : prod.bundleKey,
        contract: contract,
        offerCombinationId: pegaBundle && InHomeUtils.isNotNull(pegaBundle[1]) ? pegaBundle[1] : prod.offerTileId,
        productId: prod.id,
        productType: prod.prodType,
        quantity: "1",
        serviceType: serviceType,
        // status: isChecked ? "remove" : "add"
        status: isChecked ? "DELETE" : "add",
        isMnHAuthenticated : isMnHAuthenticated
    }

    if (serviceType === Service.voice) {
        request.tn = voiceTn
    }

    if ((serviceType === Service.video) && isOptOut) {
        request.addlInfo = [{
            "key": "optOut",
            "value": "true"
        }]
    }

    if (prod.prodTypeValue === "ULTIMATETESTDRIVE") {
        request.addlInfo = [{
            "key": "optOut",
            "value": "false"
        }]
    }

    if (prod.prodType === Service.fiosTvOne) {
        request.productId = "",
        request.productType=""
    }

    if (((prod.prodType === Service.vRoom || prod.prodType === Service.recording) && isFiosTvOneSelected && !(prod.productId === "VMS1100" || prod.id === "VMS1100")) || (prod.prodType === Service.fiosTvOne)) {
        request.category= "FIOSTVONE"
    }
    
    if (prod.productId === "VMS1100" || prod.id === "VMS1100") {
        request.productId = "",
        request.productType="",
        request.category= "VMS1100"

    }
    let {vms1100Eligible} =  store.getState().buildProduct.tv
    if(isFiosTvOneSelected &&vms1100Eligible && prod.prodType === Service.vRoom){
        request.category= "VMS1100"
    }


    if (prod.fiosFiveSelectedChannels && prod.fiosFiveSelectedChannels.length > 0) {
        updateFiosFiveCartReqObj(request, prod);
    }
    if (baseType ===  Service.intrnlChnl) {
        updateIntlPackageCartReqObj(request, prod);
    }
    if(serviceType === "MM3")
    {
        request.serviceType = "DATA"
    }
    
    return JSON.stringify(request)
}

const getClearCartRequest = (serviceType, selectedCoreServices, disconnect = 'N', refNumber, dispatch) => {
    let servType = (serviceType === Service.internet || serviceType === Service.mm3) ? Service.data : serviceType === Service.tv ? Service.video : serviceType === Service.fiosTvOne ? Service.video : 'FIOS_VOICE';

    if(disconnect === 'Y'){
        let signinResponse = (store && store.getState && store.getState().signIn && store.getState().signIn.response) ? store.getState().signIn.response : "";
        if(signinResponse && signinResponse !== "" && signinResponse.flowRoute && signinResponse.flowRoute === "FULLDISCONNECT" && !(signinResponse.userProfile && signinResponse.userProfile.isFcpInProfile) && !signinResponse.classicToFcp){
            servType = 'ALL';
            let buildProductStore = (store && store.getState && store.getState().buildProduct) ? store.getState().buildProduct : "";
            if(buildProductStore){
                let isDataOnProfile = buildProductStore.internet && buildProductStore.internet.m2mPlans && Array.isArray(buildProductStore.internet.m2mPlans) && buildProductStore.internet.m2mPlans.length>0 && buildProductStore.internet.m2mPlans.filter(item => (item.isprdOnProfile === true && !item.isprdRemoved )).length > 0 ? true : false;
                let isVideoOnProfile = buildProductStore.tv && buildProductStore.tv.m2mPlans && Array.isArray(buildProductStore.tv.m2mPlans) && buildProductStore.tv.m2mPlans.length>0 && buildProductStore.tv.m2mPlans.filter(item => item.isprdOnProfile === true).length > 0 ? true : false;
                let isVoiceOnProfile = buildProductStore.voice && buildProductStore.voice.plans && Array.isArray(buildProductStore.voice.plans) && buildProductStore.voice.plans.length>0 && buildProductStore.voice.plans.filter(item => item.isprdOnProfile === true).length > 0 ? true : false;
                if(isDataOnProfile){
                    dispatch({ type: 'UPDATEDISCONNECTINTERNET', value: true });
                }
                if(isVideoOnProfile){
                    dispatch({ type: 'UPDATEDISCONNECTTV', value: true });
                }
                if(isVoiceOnProfile){
                    dispatch({ type: 'UPDATEDISCONNECTVOICE', value: true });
                }
            }
            
        }
    }

    let request = {
        serviceType: servType,
        productType: 'All',
        disconnect: disconnect,
        referenceNumber: refNumber.replace(/-/g, '')
    }

    return JSON.stringify(request)
}

export const customRouterSetName = (name, dispatch) => {
    dispatch({ type: "SETCUSTOMROUTERNAME", value: name })
};
export const dataAccordionStatus = (status, dispatch) => {
    dispatch({ type: "DataAccordionOpen", value: status })
};

export const connectedTvSectionStatus = (status, dispatch) => {
    dispatch({ type: "SHOW_CONNECTED_APPS_EXP", value: status })    
};

export const enableVideoComparison = (status, dispatch) => {
    dispatch({ type: "SHOW_VIDEO_COMPARISON_EXP", value: status })    
};

export const enableComparisonView =  (status, dispatch) => {
    dispatch({ type: "UPDATE_COMPARISON_CONFIRM", value: status })    
};

export const connectionChoicesRequired = (status, dispatch) => {
    dispatch({ type: "SHOW_CONNECTIONS_CHOICES", value: status })    
};

export const buildprodLoaded = (status, dispatch) => {
    dispatch({ type: BuildProduct.buildprodLoaded, value: status });
};

/*const customTV = [{
    prodType: "CUSTOM",
    keyWord: "",
    onProfile: null,
    originalPrice: "",
    diffPrice: null,
    displayPrice: "$64.99",
    netPrice: 0,
    includedPromos: null,
    priceType: null,
    productTypeValue: "CUSTV",
    billingType: null,
    forDisplay: null,
    bundleId: null,
    offerTileId: null,
    bundleKey: null,
    specialOffer: null,
    speedCode: null,
    speedName: null,
    upSpeed: null,
    downSpeed: null,
    includedWithPlan: false,
    tosRequired: null,
    bundleItems: null,
    rank: null,
    isAlaCarte: false,
    priceWithPromo: null,
    productInSmartCart: false,
    id: "CUST",
    name: {
        description: "<p>7 plans to choose from",
        name: "Custom TV",
        websimpledesc: "155+ channels"
    }

}]*/

const setHtmlSymbols = (prodObj) => {
    if (prodObj.name) {
        prodObj.name = prodObj.name.replace(/&trade;/, String.fromCharCode(0x2122));
    }
    if (prodObj.description) {
        prodObj.description = prodObj.description.replace(/&trade;/, String.fromCharCode(0x2122));
    }
};

export const getFiosTvOneQualification = (dispatch, visitId,isPega) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFiosTvOneQualification', "Inside getFiosTvOneQualification"));
        logKafka("INFO", "BuildProduct", "getFiosTvOneQualification", kafkaPageLogs, "applogs", visitId);
        let QAMStreamTV = "";
        let QAMStreamTVLQ = "";
        let isQAMTV = (store && store.getState && store.getState().buildProduct && (store.getState().buildProduct.tv.streamTvEligible || store.getState().buildProduct.tv.AndriodUpgradeEligible))? true : false;
        console.log("isQAMTv",{isQAMTV,store})
        let url = apiUrl()?.fiosTvOneQual;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && (response==='VMS1100UPGRADE')) {
                dispatch({
                    type: 'VMS1100_ELIGIBLE',
                    value: true
                });
                dispatch({
                    type: 'STREAMTV_ELIGIBLE',
                    value: false
                });
            }
            else if (InHomeUtils.isNotNull(response) && (response==='VMS41001100')) {
                dispatch({
                    type: 'FIOS_TV_ONE_ELIGIBLE',
                    value: true
                });
                dispatch({
                    type: 'VMS1100_ELIGIBLE',
                    value: true
                });
                dispatch({
                    type: 'VMS41001100_ELIGIBLE',
                    value: true
                });
            }
           else if (InHomeUtils.isNotNull(response) && (response==='VMSEligible')) {
                dispatch({
                    type: 'FIOS_TV_ONE_ELIGIBLE',
                    value: true
                });
                dispatch({
                    type: 'STREAMTV_ELIGIBLE',
                    value: false
                });
            }
            else if (InHomeUtils.isNotNull(response) && (response==='StreamTV')){
                dispatch({
                    type: 'STREAMTV_ELIGIBLE',
                    value: true
                });
                dispatch({
                    type: 'VMS1100_ELIGIBLE',
                    value: false
                });
                dispatch({
                    type: 'FIOS_TV_ONE_ELIGIBLE',
                    value: false
                });
                isQAMTV=true;
            }
            else if (InHomeUtils.isNotNull(response) && (response==='AndroidEligible')){
                dispatch({
                    type: 'ANDROID_ELIGIBLE',
                    value: true
                 });
                 isQAMTV=true;
            }
            else if (InHomeUtils.isNotNull(response) && (response==='StreamTV:VMS4100')){
                 dispatch({
                    type: 'STREAMTV_ELIGIBLE',
                    value: true
                 });
                 isQAMTV=true;
            }
            else if (InHomeUtils.isNotNull(response) && (response==='QAM')){
                dispatch({
                   type: 'QAM_ELIGIBLE',
                   value: true
                });
           }
            else {
                if(isPega == false){
                    dispatch({
                        type: 'FIOS_TV_ONE_ELIGIBLE',
                        value: false
                     });
                     dispatch({
                        type: 'VMS1100_ELIGIBLE',
                        value: false
                     });
                     dispatch({
                        type: 'VMS41001100_ELIGIBLE',
                        value: false
                    });
                    dispatch({
                        type: 'STREAMTV_ELIGIBLE',
                        value: false
                     });
                    dispatch({
                        type: 'ANDROID_ELIGIBLE',
                        value: false
                     });
                    dispatch({
                        type: 'QAM_ELIGIBLE',
                        value: false
                    });
                }
            }
            if(isQAMTV)
            {
                QAMStreamTV = store.getState().buildProduct;
                QAMStreamTVLQ = store.getState().loopQual;
            }    
            fetchFiosTvOneOptions(dispatch, visitId,QAMStreamTV,QAMStreamTVLQ);
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFiosTvOneQualification', "Exception is: " + error.message));
                logKafka("ERROR", "BuildProduct", "Exception is: " + error.message, getErrorLogUrl, "applogs", visitId);

            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getFiosTvOneQualification', ex);
    }
}

export const setAccordionStatus = (service, dispatch) => {
    dispatch({ type: service.toUpperCase(), value: '' });
    if (service === 'toggle_phone_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,tv,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_tv_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,voice,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_internet_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_contract_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,sploffer,streamserv" })
    }
    if (service === 'toggle_splOffer_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,streamserv" })
    }
    if (service === 'toggle_streamingserv_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,sploffer" })
    }
}

export const focusAccordion = (service, dispatch) => {
    dispatch({ type: service.toUpperCase(), value: "Open" });
    if (service.indexOf('toggle_phone') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,tv,perks,contract,sploffer,streamserv" })
    }
    if (service.indexOf('toggle_tv') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet,voice,perks,contract,sploffer,streamserv" })
    }
    if (service.indexOf('toggle_internet') > -1) {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,perks,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_internet_perks_accor') { //toggle_perks_accor
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,contract,sploffer,streamserv" })
    }
    if (service === 'toggle_contract_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,perks,sploffer,streamserv" })
    }
    if (service === 'toggle_splOffer_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,perks,contract,streamserv" })
    }
    if (service === 'toggle_streamingserv_accor') {
        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,internet,perks,contract,sploffer" })
    }
}

export const accordionFocusAnimate = (dispatch) => {
    dispatch({ type: 'TOGGLE_FOCUS_ACCORDION' });
}

export const parentAccordionFocusAnimate = (dispatch) => {
    dispatch({ type: 'TOGGLE_FOCUS_PARENT_ACCORDION' });
}

export const focusAnimation = (offset) => {
    $('body').animate({
        scrollTop: offset + 500
    }, 750);
    // commented since scrollTo not supported by IE
    // document.getElementsByTagName('body')[0].scrollTo({
    //     top: offset - 12,
    //     left: 0,
    //     behavior: 'smooth'
    //   });
}

export const fetchDCT = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Inside fetchDCT"));
        logKafka("INFO", "BuildProduct", "Inside fetchDCT", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vcpestb')).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products)) {
                if (response.data.products.length > 0) {
                    response.data.products.forEach((prod) => setHtmlSymbols(prod));
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Products Found"));
                    let profileDctProduct = response.data.products.filter(v=>v.isprdOnProfile);
                    if (InHomeUtils.isNull(profileDctProduct) && profileDctProduct.length === 0) {
                        response.data.products.push({ id: 'NODCT', prodType: 'VCPESTB', name: "No Thanks, not right now" });
                    }
                    if(flowRouteValue ==  "VECREVIEWPLAN"){
                        dispatch({ type: 'FETCH_DCT', value: response.data.products.filter(q=> q.isprdOnProfile).map(p => p) });
                    }
                    else{
                        dispatch({ type: 'FETCH_DCT', value: response.data.products.map(p => p) });
                    }
                    if (InHomeUtils.isNotNull(response.data.products.map(p => p)) && response.data.products.map(p => p).length > 0) {
                        dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { DCT: true } });
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDCT', "DCT " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "DCT " + PAGEACTIVITY.MSG.productNotFound, kafkaPageLogs, "applogs", visitId);
                    dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDCT', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchDCT,errorMessage:Api Response is not success`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDCT', "Exception is: " + error.message));
                //    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchDCT,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchDCT', ex);
        dispatch({ type: 'SET_DCT_ELIGIBLE', value: false });
    }
};

export const fetchContractConfig = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Inside fetchContractConfig"));
        logKafka("INFO", "BuildProduct", "Inside fetchContractConfig", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().contractConfigUrl;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && response !== "") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Response is Success"));
                dispatch({ type: 'FETCH_CONTRACTCONFIG', value: response });
            }
            else {
                logKafka("INFO", "BuildProduct", PAGEACTIVITY.MSG.apiResponseFailed, kafkaPageLogs, "applogs", visitId);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchContractConfig', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchContractConfig', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchContractConfig,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchContractConfig', ex);
    }
};

export const fetchEligibleOffers = (dispatch, visitId, offertype) => {
    try {
        let offersEligible = '';
        let url = apiUrl().getProductEc + '/checkoffers/' + offertype;

        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data)
                && InHomeUtils.isNotNull(response.data.cacheValue) && response.data.cacheValue !== "") {
                offersEligible = response.data.cacheValue;
                dispatch({ type: 'FETCH_ELIGIBLE_OFFERS', value: offersEligible });
            } else {
                dispatch({ type: 'FETCH_ELIGIBLE_OFFERS', value: 'NONE' });
            }
            return offersEligible;
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchEligibleOffers,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                return offersEligible;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchEligibleOffers', ex);
    }
};

export const fetchCareFlowBundle = (dispatch, visitId, zip, state, tarCode, masterpackagesview, couponFlowType) => {
    try {
        let url = apiUrl().dobundle;
        logKafka("INFO", "BuildProduct", "fetchCareFlowBundle", kafkaPageLogs, "applogs", visitId);
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Inside fetchCareFlowBundle"));
        let intents = [];
        if (InHomeUtils.isNotNull(couponFlowType)) {
            if (couponFlowType === "Employee" || couponFlowType === "Retiree") {
                intents.push({ "key": "Employee", "value": "Y" })
            }
            else if (couponFlowType === "Affinity") {
                intents.push({ "key": "Affinity", "value": "Y" })
            }
        }
        let request = {
            "doKey": "",
            "uid": visitId,
            "intents": intents
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '404')) {
                    logKafka("ERROR", "BuildProduct", PAGEACTIVITY.MSG.error_404, getErrorLogUrl, "applogs", visitId);
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', PAGEACTIVITY.MSG.error_404, PAGEACTIVITY.UA));
                    errorAction("LBO", "BuildProduct", "careFlowBundle", "", visitId, dispatch, true, "Service-404");
                }
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Response is success"));
                    logKafka("INFO", "BuildProduct-fetchCareFlowBundle", "Response is success", kafkaPageLogs, "applogs", visitId);
                    let logmessage = `DoFlow-STATE:${statevalue}|CONTRACT:${response.data.contract}`
                    //couponFlowType is : ${couponFlowType} || Contract is : ${response.data.contract}`
                    if (InHomeUtils.isNotNull(response.data.productMap)) {

                        if (InHomeUtils.isNotNull(response.data.productMap.Data) && response.data.productMap.Data.length > 0) {
                            let prdString = ""
                            response.data.productMap.Data.forEach(p => {
                                prdString += p.downSpeed + ",";
                            })
                            logmessage = logmessage + "|" + "DATA:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response.data.productMap.Video) && response.data.productMap.Video.length > 0) {
                            let prdString = ""
                            response.data.productMap.Video.forEach(p => {
                                prdString += p.prodTypeValue + ",";
                            })
                            logmessage = logmessage + "|" + "VIDEO:" + prdString;
                        }
                        if (InHomeUtils.isNotNull(response.data.productMap.Fios_Voice) && response.data.productMap.Fios_Voice.length > 0) {
                            let prdString = ""
                            response.data.productMap.Fios_Voice.forEach(p => {
                                prdString += p.name + ",";
                            })
                            logmessage = logmessage + "|" + "VOICE:" + prdString;
                        }
                    }
                    logmessage = logmessage + "|" + "COUPONFLOWTYPE:" + couponFlowType
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', logmessage, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct-fetchCareFlowBundle", logmessage, kafkaPageLogs, "applogs", visitId);
                    dispatch({ type: 'FETCH_DOBUNDLE', value: response });
                }
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) { //If Getting DOBundle Response is Exception or null we will call default
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCareFlowBundle', "DoFlow : couponFlowType is : " + couponFlowType + " || " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchCareFlowBundle,errorMessage:API response error`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    let addlInfo = {
                        zip: zip,
                        state: state,
                        tarCode: tarCode,
                        masterpackageview: masterpackagesview,
                        selectedProductId: "",
                        couponFlowType: couponFlowType,
                        EquipmentState: null,
                        isFCPflow: true,// signInState.response.userProfile.isFcpInProfile
                        isAlaCarte: false
                    };
                    doPrefetch("INIT", dispatch, visitId, addlInfo, 'MTM', '', false, '', '', '')
                    dispatch({ type: DOFlow.onDOError, value: true });//Capturing DO Error for default prefetch hide the video section...
                    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCareFlowBundle', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchCareFlowBundle,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchCareFlowBundle', ex);
    }
};

export const DispatchBundles = (response, visitId, zip, tarCode, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Inside DispatchBundles"));
        logKafka("INFO", "BuildProduct", "DispatchBundles", kafkaPageLogs, "applogs", visitId);
        if (InHomeUtils.isNotNull(response)) {
            if (InHomeUtils.isNotNull(response.data.productMap.Data) && response.data.productMap.Data.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Dispatch DATA 2YR"));
                dispatch({ type: 'FETCH_DATA2Y', value: response.data.productMap.Data.map(p => p) });
                //For Getting Help me choose content with speed code 
                let speedCode = "";
                response.data.productMap.Data.forEach(p => {
                    speedCode += p.speedCode + ",";
                })
                dispatch({ type: 'SPEED_CODE', value: speedCode });
                if (response.data.productMap.Data.length == 1) {
                    logKafka("INFO", "BuildProduct", response.data.productMap.Data[0].downSpeed + " only available", kafkaPageLogs, "applogs", visitId);
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response.data.productMap.Data[0].downSpeed + " only available"));
                }
            }
            if (InHomeUtils.isNotNull(response.data.productMap.Video) && response.data.productMap.Video.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchBundles', "Dispatching Video products"));
                logKafka("INFO", "BuildProduct", "Dispatching Video products", kafkaPageLogs, "applogs", visitId);
                let tvPlans = response.data.productMap.Video.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1)
                let customTvPlans = response.data.productMap.Video.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC')
                let testdriveTvPlans = response.data.productMap.Video.filter(p => p.prodTypeValue === 'ULTIMATETESTDRIVE');
                let ultimateTv = response.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans.length > 0) {
                    dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                }
                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                }
                if (InHomeUtils.isNotNull(tvPlans)) {
                    dispatch({ type: 'FETCH_TV2Y', value: tvPlans.map(p => p) });
                }
                if (InHomeUtils.isNotNull(customTvPlans)) {
                    dispatch({
                        type: 'FETCH_CUSTOMTV',
                        value: customTvPlans.map(p => p)
                    });
                }
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'DispatchBundles', ex);
    }
}

export const DispatchStandalone = (response, visitId, zip, tarCode, dispatch, masterpackageview) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Inside DispatchStandalone"));
        logKafka("INFO", "BuildProduct", "Inside DispatchStandalone", kafkaPageLogs, "applogs", visitId);
        if (InHomeUtils.isNotNull(response)) {
            //Dispatch Data Response
            if (InHomeUtils.isNotNull(response.data.productMap.Data) && response.data.productMap.Data.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Dispatching Data M2M"));
                logKafka("INFO", "BuildProduct", "Dispatching Data M2M", kafkaPageLogs, "applogs", visitId);
                dispatch({ type: 'FETCH_DATAM2M', value: response.data.productMap.Data.map(p => p) });
                //For Getting Help me choose content with speed code 
                let speedCode = "";
                response.data.productMap.Data.forEach(p => {
                    speedCode += p.speedCode + ",";
                })
                dispatch({ type: 'SPEED_CODE', value: speedCode });
                if (response.data.productMap.Data.length == 1) {
                    logKafka("INFO", "BuildProduct", response.data.productMap.Data[0].downSpeed + " only available", kafkaPageLogs, "applogs", visitId);
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response.data.productMap.Data[0].downSpeed + " only available"));
                }
                fetchData2Y(dispatch, visitId);
            }
            else {
                //If the DObundle response returns the Null value for Video we will make the default prefetch call
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Fetching Data M2M"));
                logKafka("INFO", "BuildProduct", "Fetching Data M2M", kafkaPageLogs, "applogs", visitId);
                fetchDataMTM(dispatch, visitId);
                fetchPerksMTM(dispatch, visitId)
                dispatch({ type: 'UPDATE_DATA_CONTRACT', value: '2YR' });
            }
            //Dispatch TV Response 
            if (InHomeUtils.isNotNull(response.data.productMap.Video) && response.data.productMap.Video.length !== 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "Dispatching TV products"));
                logKafka("INFO", "BuildProduct", "Dispatching TV products", kafkaPageLogs, "applogs", visitId);
                let tvPlans = response.data.productMap.Video.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1)
                let testdriveTvPlans = response.data.productMap.Video.filter(p => p.prodTypeValue === 'ULTIMATETESTDRIVE');
                let ultimateTv = response.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans.length > 0) {
                    dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                }
                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                }
                dispatch({
                    type: 'FETCH_TVM2M',
                    value: tvPlans.map(p => p)
                });
                fetchTV2Y(dispatch, visitId, zip, tarCode, masterpackageview, true);
            }
            else {
                //If the DObundle response returns the Null value for Video we will make the default prefetch call           
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'DispatchStandalone', "fetching TV M2M"));
                logKafka("INFO", "BuildProduct", "fetching TV M2M", kafkaPageLogs, "applogs", visitId);
                fetchTVMTM(dispatch, visitId, zip, tarCode, masterpackageview, true);
                dispatch({ type: 'UPDATE_VIDEO_CONTRACT', value: 'MTM' });
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'DispatchStandalone', ex);
    }
}

export const fetchFreeRouter = (dispatch, visitId) => { //For DoFlow Only
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchFreeRouter', "Inside fetchFreeRouter"));
        logKafka("INFO", "BuildProduct", "Inside fetchFreeRouter", kafkaPageLogs, "applogs", visitId);
        let routerPlans = "";
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, 'MTM', 'router')).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products)) {
                    response.data.products.forEach((prod) => setHtmlSymbols(prod));
                    routerPlans = response.data.products.filter(p => p.prodTypeValue !== 'CUSTOMER_PROVIDED_ROUTER').sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                    response.data.products.filter(p => p.prodTypeValue === 'CUSTOMER_PROVIDED_ROUTER').map(p => routerPlans.push(p));
                    if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
                        dispatch({
                            type: 'FETCH_ROUTER',
                            value: routerPlans.filter(p => p.prodType !== 'ACCESSPOINTBILLER' && p.prodType !== 'ACCESSPOINTNRCBILLER' && p.prodTypeValue !== 'Customer_Provided_Router')
                        });
                        dispatch({
                            type: 'FETCH_ACCESSPOINT',
                            value: routerPlans.filter(p => p.prodType === 'ACCESSPOINTBILLER' || p.prodType === 'ACCESSPOINTNRCBILLER' || p.prodTypeValue === 'Customer_Provided_Router')
                        });
                    }
                    else if(flowRouteValue ==  "VECREVIEWPLAN"){
                        dispatch({
                            type: 'FETCH_ROUTER',
                            value: routerPlans.filter(q=> q.isprdOnProfile).map(p => p)
                        });
                    }
                    else{
                        dispatch({
                            type: 'FETCH_ROUTER',
                            value: routerPlans.map(p => p)
                        });
                    }
                    if (InHomeUtils.isNotNull(routerPlans)) {
                        updateSubProductCartonLoad(visitId, routerPlans[0], dispatch, 'MTM')
                        if (routerPlans.length > 0) {
                            dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Router: true } });
                        }
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchFreeRouter', "FREE Router " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:fetchFreeRouter,errorMessage:Router Plans null`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            }
        })
            .catch(error => {
                //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchFreeRouter,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchFreeRouter', ex);
    }
};

export const isGPONIONTEligible = (status, dispatch) => {
    dispatch({ type: BuildProduct.isGPONIONTEligible, value: status })
};
export const isBannerChecked = (status, dispatch) => {
    dispatch({ type: BuildProduct.isBannerChecked, value: status })
};
export const isBostonDMA = (status, dispatch) => {
    dispatch({ type: BuildProduct.isBostonDMA, value: status })
};
export const setIONTContractAccor = (status, dispatch) => {
    dispatch({ type: 'TOGGLE_CONTRACT_ACCOR_IONT', value: status })
};
export const setIONTContractAccorStatus = (status, dispatch) => {
    dispatch({ type: 'TOGGLE_CONTRACT_ACCOR_IONT_STATUS', value: status })
};

export const DispatchCollapsedView = (dispatch) => {
    dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: 'DOFlow' });
    dispatch({ type: 'TOGGLE_TV_ACCOR', value: 'DOFlow' });
};

export const ResumeCollapsedView = (dispatch) => {
    dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
};

export const DispatchDoStatus = (dostatus, dispatch, fetchtvres) => {
    dispatch({ type: DOFlow.onDOStatus, value: dostatus });
    if (!fetchtvres) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const DispatchSelectedCoreService = (response, dispatch) => {
    let selectedCoreService = response.servicesOrdered;
    if (InHomeUtils.isNotNull(selectedCoreService)) {
        //"DATA","VIDEO","DATA,VIDEO","DATA,FIOS_VOICE","VIDEO,FIOS_VOICE"
        dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService } });
    }
}

export const smartCartSelectedCoreService = (selectedCoreService, dispatch) => {
    if (InHomeUtils.isNotNull(selectedCoreService)) {
        dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService } });
    }
}

export const BindContractForDOFlow = (response, dispatch, couponFlowType) => {
    if (response.orderDetail.contract === "TWOYEAR") {
        updatecontractforSC("2YR", response.orderDetail.bundle, dispatch, couponFlowType)
    }
    else {
        updatecontractforSC("MTM", response.orderDetail.bundle, dispatch, couponFlowType)
    }
};

export const updateSubProductCartonLoad = (visitId, product, dispatch, contract) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Inside updateSubProductCartonLoad"));
        logKafka("INFO", "BuildProduct", "Inside updateSubProductCartonLoad", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = {
            contract: contract,
            productId: product.id,
            productType: product.prodType,
            quantity: "1",
            serviceType: "DATA",
            status: "add"
        }

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Response Success"));
                    logKafka("INFO", "BuildProduct", "Response Success", kafkaPageLogs, "applogs", visitId);
                    if (InHomeUtils.isNotNull(response.data)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                        && response.data.cartTierPricing.tierContent.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, kafkaPageLogs, "applogs", visitId);
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', "CART EMPTY", PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART EMPTY", kafkaPageLogs, "applogs", visitId);
                    }
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                            cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                        }
                    });
                    DispatchRouterFreeProduct(product, dispatch);
                }
                else { //error while updating cart
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateSubProductCartonLoad', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:updateSubProductCartonLoad,errorMessage:API Error while updating cart`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateSubProductCartonLoad', "Exception is: " + error.message));
                let errorMsg = `MethodName:updateSubProductCartonLoad,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSubProductCartonLoad', ex);
    }
}

export const DispatchRouterFreeProduct = (product, dispatch) => {
    let isChecked = true;
    dispatch({ type: 'SELECTROUTER_SELECTEDPROD', value: isChecked ? product : null });
}

export const setQueryParam = (dispatch, value) => {
    dispatch({type: 'SET_MIDNIGHT', value})
}

export const setAPEnabled = (dispatch, value) => {
    dispatch({type : 'SET_APENABLED', value})
}
export const setMnhToggle = (dispatch, value) => {
    dispatch({type : 'SET_MnhToggle', value})
}

export const setECQueryParam = (dispatch, value) => {
    dispatch({type: 'SET_ECMIDNIGHT', value})
    dispatch({type : 'ENABLE_NEW_BPP_HEADER', value})
}

export const setShowCloudModal = (dispatch, value) => {
    dispatch({type: 'SET_CLOUD_STEP_DOWN', value})
}

export const disableNewCheckoutPage = (dispatch, value) => {
    dispatch({type : 'ENABLE_NEW_CHECKOUT_FLOW', value})
}


export const fetchOfferInCart = (visitId, cartProducts, dispatch, specialOffer = null) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "Inside fetchOfferInCart"));
        logKafka("INFO", "BuildProduct", "Inside fetchOfferInCart", kafkaPageLogs, "applogs", visitId);
        if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "cart products available"));
            logKafka("INFO", "BuildProduct", "cart products available", kafkaPageLogs, "applogs", visitId);
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.rewardoffers)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchOfferInCart', "cart Promotions Available"));
                logKafka("INFO", "BuildProduct", "cart Promotions Available", kafkaPageLogs, "applogs", visitId);
                let promotions = cartProducts.CartSubProduct.SpecialOffers.rewardoffers;
                let contractOffers = cartProducts.CartSubProduct.Promotions.promotions;
                if (contractOffers && contractOffers.length > 0) {
                    contractOffers = contractOffers.map((promo, index) => {

                        if ((promo.OfferAttrValue && promo.OfferAttrValue.indexOf("FCP_DATALEAD") < 0) || (promo.offerAttrValue && promo.offerAttrValue.indexOf("FCP_DATALEAD") < 0)) {
                            if (promo.name) {
                                let promotext = (promo.price > 0) ? "$" + promo.price.replace(".00", "") + " " + promo.name : promo.name;
                                    promo.OfferText = promotext;
                            }
                            else if (promo.promoText) {
                                promo.OfferText = promo.promoText;   
                            }
                            return  promo                            
                        }
                        else {
                            return "";
                        }
                    })
                }
                
                let specialOffers = promotions?.filter(offer => (( offer?.offerAttrValue?.indexOf('FIOS200') > -1) || (offer?.offerAttr === 'VZREWARD' && offer?.offerAttrValue?.indexOf('SAMSUNG') > -1)));
                if(specialOffers && specialOffers.length > 0){
                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: specialOffers.length > 0 ? processOfferSection(specialOffers[0]) : null })
                }
                dispatch({ type: 'CONTRACTOFFER_SELECTEDPRODID', value: contractOffers.length > 0 ? processOfferSection(contractOffers) : null })                
                let flashOffers = promotions.filter(offer => (offer.offerAttr === 'ACQBLACKFRIDAY2018' > -1))
                dispatch({ type: 'FLASHOFFER_SELECTEDPRODID', value: flashOffers.length > 0 ? processOfferSection(flashOffers[0]) : null })
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchOfferInCart', "CART PROMOTIONS" + PAGEACTIVITY.MSG.notAvailable, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "CART PROMOTIONS" + PAGEACTIVITY.MSG.notAvailable, kafkaPageLogs, "applogs", visitId);
            }
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchOfferInCart', "CART PRODUCTS " + PAGEACTIVITY.MSG.notAvailable, PAGEACTIVITY.UA));
            logKafka("INFO", "BuildProduct", "CART PROMOTIONS" + PAGEACTIVITY.MSG.notAvailable, kafkaPageLogs, "applogs", visitId);
            dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: null })
            dispatch({ type: 'CONTRACTOFFER_SELECTEDPRODID', value: null })
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchOfferInCart', ex);
    }
}

export const PreselectCartProducts = (cartProducts, lqState, dispatch, visitId, isDoFlow, doresponse, buildProduct, signInState, cart, isUpsell = false, couponFlowType = null, accordionProdSelected = false) => {
    try {
        let classicAccount=false            
        let ISFCPINCSR = (InHomeUtils.isNotNull(signInState)) ? signInState.response.userProfile.isFcpInProfile : false;
        let ISFCPQualified = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response) && InHomeUtils.isNotNull(signInState.response.classicToFcp)) ? signInState.response.classicToFcp : false;
        let userState = signInState && signInState.response ? signInState.response.state : null;
        if (!ISFCPINCSR && !ISFCPQualified){
            classicAccount=true
        }else{
            classicAccount=false
        }
        let isPegaFlow = store.getState().pega.isPegaFlow
        let productsContract = store.getState().cart && store.getState().cart.cartResponse && store.getState().cart.cartResponse.tierContent && store.getState().cart.cartResponse.tierContent[0] && store.getState().cart.cartResponse.tierContent[0].contract

        let enableMixmatch2 = (ISFCPINCSR || ISFCPQualified) ? true : false;
        accordionProdSelected = accordionProdSelected ? accordionProdSelected : ((signInState.response && signInState.response.userProfile.isFcpInProfile) || classicAccount)? false : true
        let smartCartFound = false;
        if(InHomeUtils.isNotNull(signInState.isECSmartcart) && signInState.isECSmartcart == true){
            smartCartFound = true;
        }
    
        if (accordionProdSelected || smartCartFound || signInState.response.source === "PegaNoThanksLink")  {
            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Inside PreselectCartProducts"));
            logKafka("INFO", "BuildProduct", "Inside PreselectCartProducts", kafkaPageLogs, "applogs", visitId);
            return new Promise((resolve, reject) => {
                let isChecked = true;
                let inetPlanPreSelected = false;
                let tvPlanPreSelected = false;
                if (InHomeUtils.isNotNull(cartProducts)) {
                    if (InHomeUtils.isNotNull(cartProducts.Bundle)) {
                        for (let preselcount = 0; preselcount < cartProducts.Bundle.bundleProd.length; preselcount++) {
                            if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.dataPlans) {

                                dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null,preSelect:true });
                                fetchRouter(dispatch, visitId)
                                fetchInternetSubProducts(dispatch, visitId);
                                fetchStreamingServices(visitId, dispatch);
                            }
                            else if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.tvPlans) {
                                if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap)
                                    && InHomeUtils.isNotNull(doresponse.data.productMap.Video)) {
                                    for (let videocount = 0; videocount < doresponse.data.productMap.Video.length; videocount++) {
                                        if (doresponse.data.productMap.Video[videocount].id === cartProducts.Bundle.bundleProd[preselcount].prodId) {
                                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Video Id's -Bundle"));
                                            logKafka("INFO", "BuildProduct", "Matched Cart And Do Response Video Id's -Bundle", kafkaPageLogs, "applogs", visitId);
                                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Video[videocount] : null ,preSelect:true});
                                             fetchTVSubProducts(dispatch, visitId,couponFlowType,doresponse.data.productMap.Video[videocount].id);

                                            let testdriveTvPlans = doresponse.data.productMap.Video[videocount].prodTypeValue === "ULTIMATETESTDRIVE"
                                            if (testdriveTvPlans) {
                                                let ultimateTv = doresponse.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                                                if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                                                    fetchTVSubProducts(dispatch, visitId, couponFlowType, ultimateTv[0].id, userState);
                                                }
                                            }
                                            else {
                                                fetchTVSubProducts(dispatch, visitId, couponFlowType, doresponse.data.productMap.Video[videocount].id, userState);
                                            }
                                        }
                                    }
                                }
                                else {
                                    //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VIDEONOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                                    if (InHomeUtils.isNotNull(cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) && cartProducts.Bundle.bundleProd[preselcount].prodTypeVal.startsWith("CUSTOM_") && cartProducts.Bundle.bundleProd[preselcount].prodTypeVal !== Service.customGeneric) {
                                        dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) : null,preSelect:true });

                                        if (buildProduct.tv.customTV.plans.length === 0) {
                                            let tvPromise = cart.cartOrderDetail.contract === 'MTM'
                                                ? fetchTVMTM(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview, false, '')
                                                : fetchTV2Y(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview);
                                            Promise.all([tvPromise]).then(function (values) {
                                                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric) : null ,preSelect:true});
                                                dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? getProductsFromPlans(values[0].products, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) : null,preSelect:true });
                                            });
                                        } else {
                                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.tv, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric) : null,preSelect:true });
                                            dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) : null,preSelect:true });
                                        }
                                    } else if (InHomeUtils.isNotNull(cartProducts.Bundle.bundleProd[preselcount].prodTypeVal) && cartProducts.Bundle.bundleProd[preselcount].prodTypeVal === BuildProduct.utdProductTypeValue) {
                                        //Only if Ultimate Test Drive available in Cart, to trigger channel with Ultimate TV usoc
                                        let tvPromise = cart.cartOrderDetail.contract === 'MTM'
                                            ? fetchTVMTM(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview, false, '')
                                            : fetchTV2Y(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview);
                                        Promise.all([tvPromise]).then(function (values) {
                                            let ultimateTvProduct = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, BuildProduct.ultimateProductTypeValue);
                                            let tvProductInCart = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, cartProducts.Bundle.bundleProd[preselcount].prodTypeVal);
                                            if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                                                dispatch({ type: 'ULTIMATE_USOC', value: ultimateTvProduct.id ,preSelect:true});
                                            }
                                            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvProductInCart : null,preSelect:true });
                                            fetchChannel(dispatch, visitId, ultimateTvProduct.id);
                                        }
                                        );
                                    } else {
                                        //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VIDEONOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                                        dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null,preSelect:true });
                                    }

                                    // for no free dct case
                                    if (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.selectedState) && signInState.selectedState.state === "MD") {
                                        let noFreeDctProd = getNoDCT(cartProducts, visitId);
                                        if (InHomeUtils.isNotNull(noFreeDctProd)) {
                                            dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null,preSelect:true });
                                        }
                                    }
                                }
                            }
                            else if (cartProducts.Bundle.bundleProd[preselcount].editLink === CartServices.voicePlans) {
                                if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Fios_Voice)) {
                                    for (let voicecount = 0; voicecount < doresponse.data.productMap.Fios_Voice.length; voicecount++) {
                                        if (doresponse.data.productMap.Fios_Voice[voicecount].id === cartProducts.Bundle.bundleProd[preselcount].prodId) {
                                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Voice Id's - Bundle"));
                                            logKafka("INFO", "BuildProduct", "Matched Cart And Do Response Voice Id's - Bundle", kafkaPageLogs, "applogs", visitId);
                                            dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Fios_Voice[voicecount] : null,preSelect:true });
                                            fetchVoiceSubProducts(dispatch, visitId, enableMixmatch2);
                                        }
                                    }
                                }
                                else {
                                    //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB,visitId,'PreselectCartProducts',"VOICENOTFOUND-DORESPONSE-BUNDLE",PAGEACTIVITY.UA));
                                    dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.Bundle.bundleProd[preselcount] : null ,preSelect:true});
                                }
                            }
                        }
                    }
                    if(store && store.getState && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.selectedProduct && InHomeUtils.isNotNull(store.getState().buildProduct.internet.selectedProduct)){
                        inetPlanPreSelected = true;
                    }
                    if((store && store.getState && store.getState().buildProduct && store.getState().buildProduct.tv && store.getState().buildProduct.tv.selectedProduct && InHomeUtils.isNotNull(store.getState().buildProduct.tv.selectedProduct))||
                         (store && store.getState && store.getState().buildProduct && store.getState().buildProduct.tv && store.getState().buildProduct.tv.customTV && store.getState().buildProduct.tv.customTV.selectedProduct && InHomeUtils.isNotNull(store.getState().buildProduct.tv.customTV.selectedProduct))||
                         (store && store.getState && store.getState().buildProduct && store.getState().buildProduct.dct && store.getState().buildProduct.dct.selectedProduct && InHomeUtils.isNotNull(store.getState().buildProduct.dct.selectedProduct))){
                        tvPlanPreSelected = true;
                    }
                    if (!inetPlanPreSelected && InHomeUtils.isNotNull(cartProducts.DataProduct)) { //Getting the Standalone Data //dataProd
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Data)) {
                            for (let datacounts = 0; datacounts < doresponse.data.productMap.Data.length; datacounts++) {
                                if (doresponse.data.productMap.Data[datacounts].id === cartProducts.DataProduct.dataProd[0].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Data Id's -Standalone"));
                                    logKafka("INFO", "BuildProduct", "Matched Cart And Do Response Data Id's -Standalone", kafkaPageLogs, "applogs", visitId);
                                    dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Data[datacounts] : null,preSelect:true });
                                    fetchStreamingServices(visitId, dispatch);
                                }
                            }
                        }
                        else {
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'PreselectCartProducts', "DATANOTFOUND-DORESPONSE-STANDALONE", PAGEACTIVITY.UA));
                            //if (cartProducts.DataProduct.dataProd[0].prodName !== undefined && cartProducts.DataProduct.dataProd[0].prodName !== null && cartProducts.DataProduct.dataProd[0].prodName.indexOf('300') > -1) {
                            if (buildProduct.internet.m2mPlans.length === 0 && cart) {
                                let dataPromise = fetchDataMTM(dispatch, visitId)
                                Promise.all([dataPromise]).then(function (values) {
                                    if (signInState.isECSmartcart && store.getState().buildProduct.isDataPerksSetForSCFlow) {                                
                                    }
                                    else {
                                        setTimeout(() => {
                                        if(getProductsFromPlans(values[0].products, 'id', cart.cartOrderDetail && cart.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId) !== null){
                                            dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked || InHomeUtils.isNotNull(cartProducts?.DataProduct?.dataProd[0]?.prodId) ? getProductsFromPlans(values[0].products, 'id', cart?.cartOrderDetail && cart?.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId) : null,preSelect:true });
                                            dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                                            //dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
                                        }
                                        }, 5000);
                                    } 
                                });
                            } else if(cart) {
                                dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked || InHomeUtils.isNotNull(cartProducts?.DataProduct?.dataProd[0]?.prodId) ? getProductsFromPlans(buildProduct.internet.m2mPlans, 'id', cart?.cartOrderDetail && cart?.cartOrderDetail.contract, cartProducts.DataProduct.dataProd[0].prodId) : null,preSelect:true });
                                dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                                //dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
                            } else if(isPegaFlow && store.getState().cart) {
                                dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked || InHomeUtils.isNotNull(cartProducts?.DataProduct?.dataProd[0]?.prodId) ? getProductsFromPlans(buildProduct.internet.m2mPlans, 'id', productsContract , cartProducts.DataProduct.dataProd[0].prodId) : null,preSelect:true });
                                dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                            } 
                            else{
                                if(cartProducts.DataProduct && cartProducts.DataProduct.dataProd && !['STREAMING','GAMING','COMPLETE'].includes(cartProducts.DataProduct?.dataProd[0]?.prodTypeVal)){
                                    dispatch({ type: Service.internet + '_SELECTEDPROD', value: isChecked ? cartProducts.DataProduct.dataProd[0] : null });
                                    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                                }
                            }
                        }
                        if (InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd[0].prodName) && isDoFlow) {
                            if (cartProducts.DataProduct.dataProd[0].prodName.indexOf('Gigabit') > -1) {
                                //let is1GinCart = true;
                                //BindAllSubProductsDOFLOW(dispatch, visitId, is1GinCart);
                                fetchFreeRouter(dispatch, visitId);
                            }
                            else {
                                fetchRouter(dispatch, visitId);
                            }
                            fetchInternetSubProducts(dispatch, visitId);
                        }

                        //For DATA + Video (Local TV) AlaCarte case
                        if (InHomeUtils.isNotNull(cartProducts.TvProduct)) {
                            preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, signInState, cart, isChecked);
                            setTimeout(()=>{
                                dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice,tv,contract,sploffer,streamserv" });
                            },3000)
                        }
                    }  
                    if (!tvPlanPreSelected && InHomeUtils.isNotNull(cartProducts.TvProduct)) { //Getting the Standalone TV //tvProd
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Video)) {
                            for (let videocounts = 0; videocounts < doresponse.data.productMap.Video.length; videocounts++) {
                                if (doresponse.data.productMap.Video[videocounts].id === cartProducts.TvProduct.tvProd[0].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Video Id's -Standalone"));
                                    logKafka("INFO", "BuildProduct", "Matched Cart And Do Response Video Id's -Standalone", kafkaPageLogs, "applogs", visitId);
                                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Video[videocounts] : null,preSelect:true });
                                     fetchTVSubProducts(dispatch, visitId,couponFlowType,doresponse.data.productMap.Video[videocounts].id);
                                    let testdriveTvPlans = doresponse.data.productMap.Video[videocounts].prodTypeValue === "ULTIMATETESTDRIVE"
                                    if (testdriveTvPlans) {
                                        let ultimateTv = doresponse.data.productMap.Video.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                                        if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                                            dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id ,preSelect:true});
                                            fetchTVSubProducts(dispatch, visitId, couponFlowType, ultimateTv[0].id, userState);
                                        }
                                    }
                                    else {
                                        fetchTVSubProducts(dispatch, visitId, couponFlowType, doresponse.data.productMap.Video[videocounts].id, userState);
                                    }
                                }
                            }
                        }
                        else {
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'PreselectCartProducts', "VIDEONOTFOUND-DORESPONSE-STANDALONE", PAGEACTIVITY.UA));
                            //Triggers video preselection
                            preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, signInState, cart, isChecked);
                            // for no free dct case
                            if (signInState.selectedState && signInState.selectedState.state === "MD") {
                                let noFreeDctProd = getNoDCT(cartProducts, visitId);
                                if (InHomeUtils.isNotNull(noFreeDctProd)) {
                                    dispatch({ type: Service.dct + '_SELECTEDPROD', value: isChecked ? noFreeDctProd : null,preSelect:true });
                                }
                            }else if(signInState.response.source === "PegaNoThanksLink"){
                                fetchTVSubProducts(dispatch, visitId, couponFlowType, cartProducts.TvProduct.tvProd[0].prodId, userState);
                                fetchRouter(dispatch, visitId);
                                fetchIntrChannel(dispatch, visitId, cartProducts.TvProduct.tvProd[0].prodId)
                            }
                        }
                    }
                    if (InHomeUtils.isNotNull(cartProducts.VoiceProduct)) { //Getting the Standalone Voice //voiceProd
                        if (InHomeUtils.isNotNull(doresponse) && InHomeUtils.isNotNull(doresponse.data) && InHomeUtils.isNotNull(doresponse.data.productMap) && InHomeUtils.isNotNull(doresponse.data.productMap.Voice)) {
                            for (let datacounts = 0; datacounts < doresponse.data.productMap.Voice.length; datacounts++) {
                                if (doresponse.data.productMap.Voice[datacounts].id === cartProducts.DataProduct.voiceProd[0].prodId) {
                                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Matched Cart And Do Response Data Id's -Standalone"));
                                    logKafka("INFO", "BuildProduct", "Matched Cart And Do Response Data Id's -Standalone", kafkaPageLogs, "applogs", visitId);
                                    dispatch({ type: Service.voice + '_SELECTEDPROD', value: isChecked ? doresponse.data.productMap.Voice[datacounts] : null,preSelect:true });
                                    fetchStreamingServices(visitId, dispatch);
                                }
                            }
                        }
                        else {
                            if (InHomeUtils.isNull(buildProduct.voice.plans) && cart) {
                                let dataPromise = fetchVoiceMTM(dispatch, visitId)
                                Promise.all([dataPromise]).then(function (values) {
                                    dispatch({ type: 'EC_' + Service.voice + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(values[0].products, 'id', cart?.cartOrderDetail && cart?.cartOrderDetail.contract, cartProducts.VoiceProduct.voiceProd[0].prodId) : null,preSelect:true });
                                    //dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow' });
                                });
                            } else if(cart) {
                                dispatch({ type: 'EC_' + Service.voice + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.voice.plans, 'id', cart?.cartOrderDetail && cart?.cartOrderDetail.contract, cartProducts.VoiceProduct.voiceProd[0].prodId) : null,preSelect:true });
                                //dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: 'ResumeFlow',preSelect:true });
                            }
                        }
                        if (InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0].prodName)) {
                            fetchVoiceSubProducts(dispatch, visitId, enableMixmatch2);
                            fetchExistingVoiceSubProducts(dispatch, visitId);
                            // dispatch({ type: 'EC_' + Service.voice + '_SELECTEDPROD', value: isChecked ? cartProducts.VoiceProduct.voiceProd[0] : null});
                            dispatch({ type: 'EC_' + Service.voice + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.voice.plans, 'id', cart?.cartOrderDetail && cart?.cartOrderDetail.contract, cartProducts.VoiceProduct.voiceProd[0].prodId) : null,preSelect:true });
                        }

                        //For DATA + Video (Local TV) AlaCarte case
                        if (InHomeUtils.isNotNull(cartProducts.TvProduct)) {
                            preselectVideoForSC(dispatch, visitId, cartProducts, buildProduct, signInState, cart, isChecked);
                        }
                    }
                    if (!isDoFlow) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Non Do Flow - Fetch Listing,channel and techsure"));
                        logKafka("INFO", "BuildProduct", "Non Do Flow - Fetch Listing,channel and techsure", kafkaPageLogs, "applogs", visitId);
                        if (InHomeUtils.isNotNull(cartProducts.Listing) && (cartProducts.Listing.listingProd[0].prodType === "FVLISTMAIN" || cartProducts.Listing.listingProd[0].prodType === "FVNONPUB")) { //Getting the Standalone TV //tvProd
                            dispatch({ type: Service.listing + '_SELECTEDPROD', value: isChecked ? cartProducts.Listing.listingProd[0] : null,preSelect:true });
                        }
                        /* else if (!isUpsell) {
                             let listingProd = {
                                 displayPrice: "$0",
                                 id: "FVLIST",
                                 name: "List my number",
                                 prodType: "FVLISTMAIN"
                             }
                             dispatch({ type: Service.listing + '_SELECTEDPROD', value: isChecked ? listingProd : null });
                         }*/
                        if (InHomeUtils.isNotNull(cartProducts.Channels)) { //Getting the Standalone TV //tvProd
                            dispatch({ type: Service.channel + '_SELECTEDPROD', value: isChecked ? cartProducts.Channels.channelProd : null,preSelect:true });
                        }
                        if (InHomeUtils.isNotNull(cartProducts.Techsure) && InHomeUtils.isNotNull(cartProducts.Techsure.VasProduct)) {//Getting the Equipments 
                            dispatch({ type: Service.techSure + "_SELECTEDPROD", value: isChecked ? cartProducts.Techsure.VasProduct : null,preSelect:true });
                        }
                        if (InHomeUtils.isNotNull(cartProducts.TechsureCloud) && InHomeUtils.isNotNull(cartProducts.TechsureCloud.VasProduct)) {//Getting the Equipments 
                            dispatch({ type: Service.cloud + "_SELECTEDPROD", value: isChecked ? cartProducts.TechsureCloud.VasProduct[0] : null,preSelect:true });
                        }
                        if (InHomeUtils.isNotNull(cartProducts.Fne)) {//Getting the Equipments 
                            dispatch({ type: Service.fne + "_SELECTEDPROD", value: isChecked ? cartProducts.Fne.VasProduct[0] : null,preSelect:true });
                        }
                    }
                    if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment)) {//Getting the Equipments 
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has Equipments"));
                            logKafka("INFO", "BuildProduct", "Cart has Equipments", kafkaPageLogs, "applogs", visitId);
                            for (let spCount = 0; spCount < cartProducts.CartSubProduct.Equipment.equipment.length; spCount++) {
                                let productType = cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink !== null ? cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink.toUpperCase() : "";
                                if(productType === 'SELECTACCESSPOINT'){
                                    dispatch({
                                        type: "EC_AccessPoint_SELECTEDPROD",
                                        value: isChecked ? cartProducts.CartSubProduct.Equipment.equipment[spCount] : null,preSelect:true
                                    });     
                                }else{
                                    dispatch({
                                        type: productType + "_SELECTEDPROD",
                                        value: isChecked ? cartProducts.CartSubProduct.Equipment.equipment[spCount] : null,preSelect:true
                                    });    
                                }
                                //Smartcart changes for EC flow
                                let prdtype = cartProducts.CartSubProduct.Equipment.equipment[spCount].prodType;
                                if (prdtype === "NETWORKEXTENDERMRC") {
                                    dispatch({
                                        type: Service.fne + "_SELECTEDPROD",
                                        value: isChecked ? cartProducts.CartSubProduct.Equipment.equipment[spCount] : null,preSelect:true
                                    });
                                }
                            }
                        }
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges)) {//Getting the Equipments 
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has OneTime Charges"));
                            logKafka("INFO", "BuildProduct", "Cart has OneTime Charges", kafkaPageLogs, "applogs", visitId);
                            for (let tpCount = 0; tpCount < cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.length; tpCount++) {
                                let prType = cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount].editLink !== null ? cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount].editLink.toUpperCase() : "";
                                let prdtype = cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount].prodType;
                                let price = cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount].price;
                                if (prType === "BATTERY") {
                                    cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount]["keyword"] = price.indexOf("0.0") === -1 ? "CHARGED" : "";
                                }
                                else if (prdtype === "SLABATTERYSHIPMENT" || prdtype === "DCELLTRAYSHIPMENT") {
                                    prType = "BBUSHIPMENT";
                                }
                                else if (prdtype === "OTTEQUIPNRC") {
                                    dispatch({ type: Service.streamDev + '_SELECTEDPROD', value: isChecked ? cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount] : null ,preSelect:true});
                                    dispatch({ type: Service.streamDevCountResume + '_SELECTEDPROD', value: isChecked ? cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount].quantity : null,preSelect:true });
                                }
                                if (prType !== "") {
                                    dispatch({
                                        type: prType + "_SELECTEDPROD",
                                        value: isChecked ? cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount] : null,preSelect:true
                                    });
                                }
                                //Smartcart changes for EC flow
                                if (prdtype === "NETWORKEXTENDERNRC") {
                                    dispatch({
                                        type: Service.fne + "_SELECTEDPROD",
                                        value: isChecked ? cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge[tpCount] : null,preSelect:true
                                    });
                                }  
                            }
                        }
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers)) {
                            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.SpecialOffers.specialoffers)
                                && cartProducts.CartSubProduct.SpecialOffers.specialoffers.length > 0) {
                                for (let sploffercount = 0; sploffercount < cartProducts.CartSubProduct.SpecialOffers.specialoffers.length; sploffercount++) {
                                    dispatch({ type: Service.streamServ + '_SELECTEDPROD', value: isChecked ? cartProducts.CartSubProduct.SpecialOffers.specialoffers[sploffercount] : null ,preSelect:true});
                                }
                            }
                        }
                        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.StreamingDeviceProduct)) {
                            for (let streamdevcount = 0; streamdevcount < cartProducts.CartSubProduct.StreamingDeviceProduct.streamDeviceProduct.length; streamdevcount++) {
                                dispatch({ type: Service.streamDev + '_SELECTEDPROD', value: isChecked ? cartProducts.CartSubProduct.StreamingDeviceProduct.streamDeviceProduct[streamdevcount] : null ,preSelect:true});
                                dispatch({ type: Service.streamDevCountResume + '_SELECTEDPROD', value: isChecked ? cartProducts.CartSubProduct.StreamingDeviceProduct.streamDeviceProduct[streamdevcount].quantity : null,preSelect:true });
                            }
                        }
                    }                    
                    if (InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartData) && cart.cartData.length > 0) {
                        if (InHomeUtils.isNotNull(cart.cartData[0].streamService) && InHomeUtils.isNotNull(cart.cartData[0].streamService.streamServiceProds)) {
                            dispatch({ type: Service.streamServ + '_SELECTEDPROD', value: isChecked ? cart.cartData[0].streamService.streamServiceProds[0] : null,preSelect:true });
                        }
                    }
                      //Smartcart changes for EC flow
                    else if(InHomeUtils.isNotNull(cartProducts.StreamService) && InHomeUtils.isNotNull(cartProducts.StreamService.streamServiceProds)){
                        for(let streamServCount = 0; streamServCount < cartProducts.StreamService.streamServiceProds.length; streamServCount++){
                            dispatch({ type: Service.streamServ + '_SELECTEDPROD', value: isChecked ? cartProducts.StreamService.streamServiceProds[streamServCount] : null,preSelect:true });
                        }
                    }
                      
                    //dispatch({ type: 'COLLAPSE_ALL_ACCORDION', value: '' });
                    
                    // GetShoppingCartProducts((visitId, dispatch, signInState, buildProduct, cart))
                    // if (signInState.response.classicToFcp)
                    // dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
                    // dispatch({ type: 'SET_DEFAULT_ACCORDION', value:''  });


  

                   
                    
                    resolve(true);
                }
                else {
                    resolve(false)
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        } else {
            //suppress the call
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'PreselectCartProducts', ex);
    }
};

const getNoDCT = (cartProducts, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getNoDCT', "Inside getNoDCT"));
        logKafka("INFO", "BuildProduct", "Inside getNoDCT", kafkaPageLogs, "applogs", visitId);
        let noFreeDctProd = {
            id: "NODCT",
            name: "No Thanks, not right now",
            prodType: "VCPESTB"
        }
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment)) {//Getting the Equipments 
                for (let spCount = 0; spCount < cartProducts.CartSubProduct.Equipment.equipment.length; spCount++) {
                    let productType = InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink) ? cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink.toUpperCase() : "";
                    if (productType === "DIGITALADAPTER") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getNoDCT', "NODCT " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "NODCT " + PAGEACTIVITY.MSG.productNotFound, kafkaPageLogs, "applogs", visitId);
                        return null;
                    }
                }
            }
        }
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getNoDCT', "return DCT Product"));
        logKafka("INFO", "BuildProduct", "return DCT Product", kafkaPageLogs, "applogs", visitId);
        return noFreeDctProd;
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getNoDCT', ex);
    }
}

const preselectVideoForSC = (dispatch, visitId, cartProducts, buildProduct, signInState, cart, isChecked) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'preselectVideoForSC', "Inside preselectVideoForSC"));
        logKafka("INFO", "BuildProduct", "Inside preselectVideoForSC", kafkaPageLogs, "applogs", visitId);
        let isLocalTVInCart = false;
        let isDCTinCart = false;
        if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal.startsWith("CUSTOM_") && cartProducts.TvProduct.tvProd[0].prodTypeVal !== Service.customGeneric) {
            if (buildProduct.tv.customTV.plans.length === 0) {
                let tvPromise = fetchTVMTM(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview)
                Promise.all([tvPromise]).then(function (values) {
                    dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric) : null });
                    dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? getProductsFromPlans(values[0].products, 'prodTypeValue', null, cartProducts.TvProduct.tvProd[0].prodTypeVal) : null });
                }
                );
            } else {
                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.tv, 'prodTypeValue', cart.cartOrderDetail.contract, Service.customGeneric) : null });
                dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: isChecked ? getProductsFromPlans(buildProduct.tv.customTV.plans, 'prodTypeValue', null, cartProducts.TvProduct.tvProd[0].prodTypeVal) : null });
            }

        } else if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === BuildProduct.utdProductTypeValue) {
            //Only if Ultimate Test Drive available in Cart, to trigger channel with Ultimate TV usoc
            let tvPromise = fetchTVMTM(dispatch, visitId, signInState.response.zipCode, signInState.response.tarCode, buildProduct.masterpackageview)
            Promise.all([tvPromise]).then(function (values) {
                let tvProductInCart = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, cartProducts.TvProduct.tvProd[0].prodTypeVal);
                dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? tvProductInCart : null });
                let ultimateTvProduct = getProductsFromPlans(values[0].products, 'prodTypeValue', cart.cartOrderDetail.contract, BuildProduct.ultimateProductTypeValue);
                if (InHomeUtils.isNotNull(ultimateTvProduct)) {
                    dispatch({ type: 'ULTIMATE_USOC', value: ultimateTvProduct.id });
                }
                fetchChannel(dispatch, visitId, ultimateTvProduct.id);
            }
            );
        } else {
            if (InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") {
                isLocalTVInCart = true;
            }
            if (isLocalTVInCart || isDCTinCart) {
                fetchVRoom(dispatch, visitId, isLocalTVInCart, isDCTinCart);
            }
            /*if(signInState.response.source === "PegaNoThanksLink"){
                fetchTVSubProducts(dispatch, visitId, null, cartProducts.TvProduct.tvProd[0].prodId);
                fetchRouter(dispatch, visitId);
                fetchIntrChannel(dispatch, visitId, cartProducts.TvProduct.tvProd[0].prodId)
            }*/
            dispatch({ type: Service.tv + '_SELECTEDPROD', value: isChecked ? cartProducts.TvProduct.tvProd[0].prodType == 'BASIC' ? cartProducts.TvProduct.tvProd[0] : null : null });
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'preselectVideoForSC', ex);
    }
}

const processOfferSection = product => {
    if (InHomeUtils.isNotNull(product.specialOffers) && product.specialOffers.length > 0) {
        product.specialOffers.map(o => {
            o['id'] = o.USOCIOSC;
            o['prodType'] = 'SPLOFFER';
            o['prodTypeVal'] = o['prodTypeValue'] = '';
            o['OfferText'] = o.OfferText;
        })
    }
    else if (InHomeUtils.isNotNull(product.promoId)) {
        product['id'] = product.promoId;
        product['prodType'] = 'SPLOFFER';
        product['prodTypeVal'] = product['prodTypeValue'] = '';
        product['OfferText'] = product.promoText;
    }
    else {
        if (InHomeUtils.isNotNull(product.offer2YR) && product.offer2YR.length > 0) {
            product.offer2YR.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'SPLOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
        if (InHomeUtils.isNotNull(product.offersMTM) && product.offersMTM.length > 0) {
            product.offersMTM.map(o => {
                o['id'] = o.USOCIOSC;
                o['prodType'] = 'SPLOFFER';
                o['prodTypeVal'] = o['prodTypeValue'] = '';
                o['OfferText'] = o.OfferText;
            })
        }
    }
    return product;
}



export const fetchHoaDefaults = (dispatch, visitId,reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Inside fetchDataMTM"));
        logKafka("INFO", "BuildProduct", "Inside fetchHoaDefaults", getErrorLogUrl, "applogs", visitId);
        let request = {
            uid: visitId,
        }
        let url = apiUrl().getVoiceProductEc + '/vecdefaults';
        return new Promise((resolve, reject) => {
            loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Vec Contracted Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST',JSON.stringify(request)).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                    InHomeUtils.isNotNull(response.data) ) {
                   if(response.data.defaultUSocs){
                     dispatch({ type: 'FETCH_HOABUNDLE', value: response.data });
                     if(response.data.defaultMap && response.data.defaultMap.internet && (typeof response.data.defaultMap.internet === 'string')){
                        setTimeout(()=>{
                            let notificationMssg =  `As a Verizon Enhanced Communities Value Program customer, your offer includes ${response.data.defaultMap.internet}`;
                            updateVzdlSCCustomEvent("service overview", "pageViewOmni", "notification", false, "", false, notificationMssg);
                        },1000)
                     }
                    }
                    else{
                        dispatch({ type: 'FETCH_HOABUNDLE', value:"NO_USOCS" });
                        errorAction("LBO", "BuildProduct", "HOA", "", visitId, dispatch, true, "hoa");
                   }
                }
                else if (reAttemptCount < 3) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "HOA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchHoaDefaults(dispatch, visitId,  (reAttemptCount + 1))
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    // errorAction("LBO", "HOA", "ProductNotReturned-DataMTM", "", visitId, dispatch, true, "ProductNotReturned-DataMTM");
                    let errorMsg = `MethodName:fetchHoaDefaults,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct-Hoa", errorMsg, getErrorLogUrl, "applogs", visitId);
                    errorAction("LBO", "BuildProduct", "HOA", "", visitId, dispatch, true, "hoa");

                }
            }).catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchHoaDefaults', "Exception is: " + error.message));
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchHoaDefaults,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchHoaDefaults', ex);
    }
};

export const fetchDataMTM = (dispatch, visitId, couponFlowType = null, reAttemptCount = 0, exploreNewTile = '') => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Inside fetchDataMTM"));
        logKafka("INFO", "BuildProduct", "Inside fetchDataMTM", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Data', couponFlowType)).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                    InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    dispatch({ type: "SET_IWM_ELIGIBLE", value: response?.data?.isiwmEligible });
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.downSpeed + ",";
                    })
                    if(store.getState().buildProduct?.showMockChoiceOffersEC) {
                    response.data.products.forEach(p => {
                            let choiceOffersCount = 0;
                            let choiceName = '';
                            let choiceOfferRank = 999;
                        if(p.downSpeed==="1024M" || p.downSpeed === "2048M") {
                            let gigSPlOffersTypeCheck = Array.isArray(gigSplOffers) ? gigSplOffers : (typeof gigSplOffers === 'object') ? gigSplOffers?.a : [];
                            const combinedOffers = p?.specialOffers?.concat(gigSPlOffersTypeCheck);
                                    (store.getState().buildProduct?.internet?.choiceOffersCount < 2) && combinedOffers?.forEach(offer => {
                                        offer?.extendedAttributes?.split(',')?.forEach(item => {
                                            const [key, value] = item?.split(':');
                                            if (key === 'ISCHOICE' && value.toUpperCase() === 'YES') {
                                                choiceOffersCount++;
                                            }
                                        });
                                        if (offer?.extendedAttributes?.includes("ISCHOICE:YES") && choiceOfferRank > parseInt(offer?.Rank)) {
                                            choiceOfferRank = parseInt(offer?.Rank)
                                            choiceName = offer?.OfferText
                                        }
                                        dispatch({ type: 'SET_CHOICE_OFFER_NAME', value: choiceName });
                                    });
                                !store.getState().buildProduct?.internet?.choiceOffersCount && dispatch({ type: 'SET_CHOICE_OFFERS_COUNT', value: choiceOffersCount });
                            }
                        })
                    }
                    let msg = `DATA ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|DATA:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', msg, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                    if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
                        dispatch({
                            type: 'FETCH_DATAM2M', value: response.data.products.filter(item => item.isprdOnProfile).map(p => {
                                return processOfferSection(p);
                            })
                        })
                    }else{
                        dispatch({
                            type: 'FETCH_DATAM2M', value: response.data.products.map(p => {
                                return processOfferSection(p);
                            })
                        });
                    }
                    
                    if(response.data && response.data.mnhResponse){
                        dispatch({type : 'EC_MNH_RESPONSE',value : response.data.mnhResponse});
                    }
                    if(response.data && response.data.mm3Qualified && response.data.mm3Qualified == true)
                    {
                        dispatch({type : 'MM3QUALIFIED',value : true});
      	            }else{
                        dispatch({type : 'MM3QUALIFIED',value : false});
                    }
                    if(response.data && response.data.isMM3PlansAvailable && response.data.isMM3PlansAvailable == true){
                        dispatch({type : 'MM3_PLANS_AVAILABLE',value : true});
                    }else{
                        dispatch({type : 'MM3_PLANS_AVAILABLE',value : false});
                    }
                    if(response.data && response.data.isMM2PlansAvailable && response.data.isMM2PlansAvailable == true){
                        dispatch({type : 'MM2_PLANS_AVAILABLE',value : true});
                    }else{
                        dispatch({type : 'MM2_PLANS_AVAILABLE',value : false});
                    }
                    if(response.data && response.data?.serviceOnProfile && response.data?.serviceOnProfile == true){
                        dispatch({type : 'IS_DATA_ON_PROFILE',value : true});
                    }
                    if(response.data){
                        dispatch({type : 'LEGACY_STB_LEAD_LIST_CUSTOMERS',value : response.data.legSTBLeadLstCust});
                    }
                    if(response.data && response.data.strikePrice)
                    {
                        dispatch({type : 'STRIKE_PRICE_INDICATOR',value : response.data.strikePrice});
                    
                    }
                    // if(response.data && response.data.)
                    if((response.data && response.data.typeofDiscount && response.data.typeOfDiscountScenario))
                    {
                        
                        dispatch({type : 'STRIKE_PRICE_INDICATOR1',value : response.data.typeofDiscount});
                        dispatch({type : 'STRIKE_PRICE_INDICATOR2',value : response.data.typeOfDiscountScenario});
                    
                    }
                    if(exploreNewTile == 'exploreNewTile'){
                        cartActions.clearcart(visitId, dispatch, store.getState().loopQual, true);
                    }else if(exploreNewTile == 'goBackToExploreNewTile'){
                        cartActions.clearcart(visitId, dispatch, store.getState().loopQual, 'goBackToMM2');
                    }
                    if(response.data && response.data.mnhSignupIndicator)
                        {
                            if(response.data.mnhSignupIndicator !== '' && response.data.mnhSignupIndicator !== 'N'){
                                dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnhSignupIndicator});
                            } 
                        }
                    let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                    if (productOnProfile.length > 0) {
                        dispatch({ type: 'ONPROFILESTATUS', value: { internet: true } });
                        fetchStreamingServices(visitId, dispatch);
                    }
                    if (response.data.products.length == 1) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'DataTiles', response.data.products[0].downSpeed + " only available"));
                        logKafka("INFO", "BuildProduct", response.data.products[0].downSpeed + " only available", getErrorLogUrl, "applogs", visitId);
                    }

                    if(response.data && response.data.skipFDVWithNGPON2 == true){
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : true});
                    }
                    else{
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : false});
                    }
                    if(response.data && response.data.nflactiveOnProfile == true){
                        dispatch({type : 'NFL_ACTIVE_ON_PROFILE',value : true});
                    }else{
                        dispatch({type : 'NFL_ACTIVE_ON_PROFILE',value : false});
                    }

                    if(response.data.acpqualified){
                        dispatch({ type: 'SET_ACP_STATUS', value: true });
                        dispatch({ type: 'SET_EC_BANNER_MESSAGE', value: 'You qualify for the Affordable Connectivity Program discount. In order for it to be applied to your account, you must checkout.' })
                    }
                    else if(response.data.vfwdqualified){
                        let  isInDiscountOffer = response.data?.products[0]?.discountOffers;
                        let checkDiscount= isInDiscountOffer?.filter(p=>
                          p.BsOfferAttrValue === "VZP_NEWFIOSFORWARDSTANDALONE_DISCOUNT" || p.BsOfferAttrValue === "VZ_FORWARDBILLCREDIT_DISCOUNT"
                        )
                          if((checkDiscount=== undefined || checkDiscount==="" || checkDiscount.length<=0  || isInDiscountOffer?.length <=0)  && reAttemptCount<=0){
                              fetchDataMTM(dispatch, visitId, couponFlowType, (reAttemptCount + 1), exploreNewTile)
                              
                          }
                        dispatch({ type: 'SET_VZF_STATUS', value: true });
                    }
                    let speedCode = "";
                    let isocInfo = [];
                    let showFccLabelkey = store && store.getState() && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey?.ShowFccLabelInfo == 'Y' ? true : false;
                    
                    let disneyPromoEligible = false;
                    let  netmaxEligible = false 
                    response?.data?.products?.forEach(p => {
                        speedCode += p.speedCode + ",";
                        const selectedSpeed = store && store?.getState()?.buildProduct?.internet?.selectedProduct;
                        /* Update only for initial load.. after speed selection, disney eligibility depends on updateCart response.
                        */
                       // if(selectedSpeed == null) {
                            if(p?.specialOffers && p?.specialOffers?.length > 0) {
                                const disney = p.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT');
                                const netmax = p.specialOffers?.find(offer => offer?.BsOfferAttrValue === 'NETMAX_PERK_DISCOUNT');
                                if(disney) {
                                    disneyPromoEligible = true;
                                }
                                if(netmax) {
                                    netmaxEligible = true; 
                                }
                            }
                            dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                            dispatch({ type: 'NETMAX_PROMO_PRESENT', value: netmaxEligible }); // netmax 
                      //  }
                    });

                    response.data.products.map((item)=>item.planPerks.map((it)=>{
                        if(it.id!==null){
                            isocInfo.push(it.id)
                        }
                    }))
                    response.data.products.map((item)=> {
                        if(item.id!=null){
                            isocInfo.push(item.id)
                        }
                    })
                    dispatch({ type: 'ISOC_INFO', value: isocInfo });
                    if(showFccLabelkey && flowRouteValue !== 'FULLDISCONNECT'){
                        FCCLabelData(dispatch, isocInfo, productOnProfile.length>0 ? productOnProfile[0].id : null)
                    }
                    dispatch({ type: 'SPEED_CODE', value: speedCode });
                    dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchDataMTM(dispatch, visitId, couponFlowType, (reAttemptCount + 1))
                }
                else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                    InHomeUtils.clearMemory();
                    InHomeUtils.redirectToHomePage("LQ=N");
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-DataMTM", "", visitId, dispatch, true, "ProductNotReturned-DataMTM");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchDataMTM,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            }).catch(error => {
                if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchDataMTM(dispatch, visitId, couponFlowType, (reAttemptCount + 1));
                } else {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Exception is: " + error.message));
                    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                    let errorMsg = `MethodName:fetchDataMTM,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchDataMTM', ex);
    }
};

export const fetchData2Y = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDataMTM', "Inside fetchData2Y"));
        logKafka("INFO", "BuildProduct", "Inside fetchData2Y", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Data')).then(response => {
            loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                dispatch({ type: "SET_IWM_ELIGIBLE", value: response?.data?.isiwmEligible });
                let prdString = ""
                response.data.products.forEach(p => {
                    prdString += p.downSpeed + ",";
                })
                if(store.getState().buildProduct?.showMockChoiceOffersEC) {
                    response.data.products.forEach(p => {
                        let choiceOffersCount = 0;
                        let choiceName = '';
                        let choiceOfferRank = 999;
                        if(p.downSpeed==="1024M" || p.downSpeed === "2048M") {
                            let gigSPlOffersTypeCheck = Array.isArray(gigSplOffers) ? gigSplOffers : (typeof gigSplOffers === 'object') ? gigSplOffers?.a : [];
                            const combinedOffers = p?.specialOffers?.concat(gigSPlOffersTypeCheck);
                                (store.getState().buildProduct?.internet?.choiceOffersCount < 2) && combinedOffers?.forEach(offer => {
                                    offer?.extendedAttributes?.split(',')?.forEach(item => {
                                        const [key, value] = item?.split(':');
                                        if (key === 'ISCHOICE' && value.toUpperCase() === 'YES') {
                                            choiceOffersCount++;
                                        }
                                    });
                                    if (offer?.extendedAttributes?.includes("ISCHOICE:YES") && choiceOfferRank > parseInt(offer?.Rank)) {
                                        choiceOfferRank = parseInt(offer?.Rank)
                                        choiceName = offer?.OfferText
                                    }
                                    dispatch({ type: 'SET_CHOICE_OFFER_NAME', value: choiceName });
                                });
                            !store.getState().buildProduct?.internet?.choiceOffersCount && dispatch({ type: 'SET_CHOICE_OFFERS_COUNT', value: choiceOffersCount });
                        }
                    })
                }
                if(response.data && response.data.mnhSignupIndicator)
                    {
                        if(response.data.mnhSignupIndicator !== '' && response.data.mnhSignupIndicator !== 'N')
                        updateSubFlowValue(' | M+H', 'm+h');
                        dispatch({type : 'MNHSIGNUPINDICATOR',value : response.data.mnhSignupIndicator});
                        let emberVal = {};
                        emberVal.isEmberFlow = true;
                        dispatch({ type: "SET_EMBER_INFO", value: emberVal });
                    }
                let msg = `DATA ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|DATA:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', msg, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                if(flowRouteValue == "FULLDISCONNECT" || flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_DATA2Y', value: response.data.products.filter(item => item.isprdOnProfile).map(p => {
                            return processOfferSection(p);
                        })
                    });
                }else{
                    dispatch({
                        type: 'FETCH_DATA2Y', value: response.data.products.map(p => {
                            return processOfferSection(p);
                        })
                    });
                }
                if(response.data){
                    dispatch({type : 'LEGACY_STB_LEAD_LIST_CUSTOMERS',value : response.data.legSTBLeadLstCust});
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { internet: true } });
                }
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                fetchData2Y(dispatch, visitId, (reAttemptCount += 1))
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', "DATA " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Data2Y", "", visitId, dispatch, true, "ProductNotReturned-Data2Y");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchData2Y,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchData2Y', "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "DATA " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchData2Y(dispatch, visitId, (reAttemptCount += 1))
                } else {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchData2Y', "Exception is: " + error.message));
                    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                    let errorMsg = `MethodName:fetchData2Y,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchData2Y', ex);
    }
};

export const fetchRouter = (dispatch, visitId, reAttemptCount = 0, isRouterUpgrade = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Inside fetchRouter"));
        logKafka("INFO", "BuildProduct", "Inside fetchRouter", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCountEC ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCountEC) : 0;
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'router', null, false, isRouterUpgrade)).then(response => {
            //loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (window.nrTimeState && window.nrTimeState.fromTime) {
                logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Router Products Found"));
                logKafka("INFO", "BuildProduct", "Router Products Found", kafkaPageLogs, "applogs", visitId);
                response.data.products.forEach((prod) => setHtmlSymbols(prod));
                let routerPlans = response.data.products.filter(p => p.prodTypeValue !== 'CUSTOMER_PROVIDED_ROUTER' && p.name.indexOf('G3100') < 0).sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                response.data.products.filter(p => p.prodTypeValue === 'CUSTOMER_PROVIDED_ROUTER').map(p => routerPlans.push(p));
                if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: routerPlans.filter(p => p.prodType !== 'ACCESSPOINTBILLER' && p.prodType !== 'ACCESSPOINTNRCBILLER' && p.prodTypeValue !== 'Customer_Provided_Router')
                    });
                    dispatch({
                        type: 'FETCH_ACCESSPOINT',
                        value: routerPlans.filter(p => p.prodType === 'ACCESSPOINTBILLER' || p.prodType === 'ACCESSPOINTNRCBILLER' || p.prodTypeValue === 'Customer_Provided_Router')
                    });
                }
                else if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: routerPlans.filter(q=> q.isprdOnProfile).map(p => p)
                    });
                }
                else{
                    dispatch({
                        type: 'FETCH_ROUTER',
                        value: routerPlans.map(p => p)
                    });
                }
                if (InHomeUtils.isNotNull(routerPlans)) {
                    //DispatchRouterFreeProduct(routerPlans[0], dispatch);
                    if (routerPlans.length > 0) {
                        dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Router: true } });
                    }
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { router: true } });
                }

                let WHWProduct = response.data.products.filter(e => e.id=='R0641' && e.isprdOnProfile);
                if (WHWProduct.length > 0) {
                    dispatch({ type: 'SET_WHOLE_WIFI_STATUS', value: true });
                }

                let WHWPlusProduct = response.data.products.filter(e => (e.id=='R1739' || e.id=='R1749') && e.isprdOnProfile && !e.isprdRemoved);
                if (WHWPlusProduct.length > 0) {
                    dispatch({ type: 'SET_WHOLE_WIFIPLUS_STATUS', value: true });
                }

                let WHWPlus2 = response.data.products.filter(e => (e.id=='R1730' || e.id=='R1767') && e.isprdOnProfile);
                if (WHWPlus2.length > 0) {
                    dispatch({ type: 'SET_WHOLE_WIFIPLUS2_STATUS', value: true });
                }
                
                /* if (InHomeUtils.isNotNull(routerPlans) && routerPlans.length > 0) {
                      dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Router: true } });
                  } */
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Router " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchRouter(dispatch, visitId, (reAttemptCount + 1))
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRouter', "Router" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Router", "", visitId, dispatch, true, "ProductNotReturned-Router");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchRouter,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRouter', "Exception is: " + error.message));
                //loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchRouter,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchRouter', ex);
    }
};

export const doSmartCartSave = (dispatch, visitId, mtn, eMailID) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'doSmartCartSave', "Inside doSmartCartSave"));
        logKafka("INFO", "BuildProduct", "Inside doSmartCartSave", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().smartSave;
        let request = {
            email: eMailID,
            mtn: mtn,
            saveType: 'autogen',
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({
                    type: 'DO_SMARTCART',
                    value: true
                });
            }
            else {
                let errorMsg = `MethodName:doSmartCartSave,errorMessage:API response error`;
                logKafka("ERROR", "doSmartCartSave", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:doSmartCartSave,errorMessage:${error.message}`;
                logKafka("ERROR", "doSmartCartSave", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'doSmartCartSave', ex);
    }
};

export const fetchTechSure = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Inside fetchTechSure"));
        logKafka("INFO", "BuildProduct", "Inside fetchTechSure", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vas')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Vas Products Found"));
                logKafka("INFO", "BuildProduct", "Vas Products Found", kafkaPageLogs, "applogs", visitId);
                const homeSecurityfromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.HomeSecurityEnable
                if(homeSecurityfromAEM && homeSecurityfromAEM ==='Y'){
                fetchVHSBiller(dispatch,visitId);
                fetchDHSBiller(dispatch,visitId);
                }
                var hnmStatusCode  =  response?.data?.hnm_status_code
                var containerManagementNeeded =  response?.data?.containerManagementNeeded
                var containerOption =  response?.data?.containerOption
                var techsurePrd = response.data.products.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", "")));
                var vasipProd =  techsurePrd.filter(p => p.prodType === "PPP").reverse();
                // var homeAdvisorProd = techsurePrd.filter(p => p.prodType === "PPP" && p.name.indexOf('Advisor') > -1);
                var vasip = [], jindex = 0;
                // if(homeAdvisorProd.length > 0) {
                    // for ( var index = 0; index < vasipProd.length + 1; index++) {
                    //     // if(index === 1) {
                    //     //     vasip[index] = homeAdvisorProd[0];
                    //     // }
                    // }
                // } else {
                //     vasip = vasipProd;
                // }
                try{
                vasipProd.map((each,i)=>each.index=i)
                let homeAwarenessPlusProd = vasipProd.filter(each=>each.name.indexOf("Home Awareness Plus")>-1)[0]
                 var homeAdvisorProd = techsurePrd.filter(p => p.name.indexOf('Advisor') > -1)[0];
                if(InHomeUtils.isNotNull(homeAdvisorProd)){
                    homeAdvisorProd.index=1

                } 
                
                if(InHomeUtils.isNotNull(homeAwarenessPlusProd)){
                    homeAwarenessPlusProd.index=5
                }
                }catch(error){
                    console.log("error",error)
                }
                vasip =  vasipProd
                vasip =  vasip.sort((a, b) => a.index > b.index && 1 || -1)

                dispatch({
                    type: 'EC_FETCH_TECHSURE',
                    value: vasip //default vz protect home at first
                });

                var techsurecloudPrd = response.data.products.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", "")));
                var techsurecloudPrdOnProfile = techsurecloudPrd && techsurecloudPrd.length > 0 ? techsurecloudPrd.filter(p => p.prodType === "PPPCLOUD" && p.isprdOnProfile): null;
                
                dispatch({
                    type: 'FETCH_TECHSURE_CLOUD',
                    value: techsurecloudPrd.filter(p => p.prodType === "PPPCLOUD")
                });


                dispatch({
                    type: "FETCH_CONTAINER_OPTION",
                    value: containerOption // HMA CONTAINER OPTIONS 
                });

                
                dispatch({
                    type: "FETCH_CONTAINER_MANGEMENT",
                    value: containerManagementNeeded // HMA CONTAINER_MANAGEMENT NEED BOOLEAN VALUE 
                });

                dispatch({
                    type: "FETCH_HNM_STATUS_CODE",
                    value: hnmStatusCode // HMA STATUS CODE 
                });


                if(techsurecloudPrdOnProfile && techsurecloudPrdOnProfile.length > 0) {
                    dispatch({
                        type: 'UPDATE_PROFILE_CLOUD',
                        value: techsurecloudPrdOnProfile[0]
                    });

                }

                
                if (InHomeUtils.isNotNull(techsurePrd.map(p => p)) && techsurePrd.map(p => p).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { TechSure: true } });
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { techsure: true } });
                }
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTechSure', "VAS " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "VAS " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchTechSure(dispatch, visitId, reAttemptCount + 1)
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTechSure',"VAS " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTechSure', "VAS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchTechSure,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
            vasProductsViewInTile(dispatch,vasip)             
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTechSure', "Exception is:" + error.message));
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchTechSure,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTechSure', ex);
    }
};

export const fetchFne = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchFne', "Inside fetchFne"));
        logKafka("INFO", "BuildProduct", "Inside fetchFne", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'extender')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            // }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {

                let products = response.data.products;
                if (products.find(item => item.isprdOnProfile == true && item.displayPrice.indexOf('$0') == -1)) {
                    const clonedProducts = JSON.parse(JSON.stringify(products));
                    let profileProduct = clonedProducts.filter(item => item.isprdOnProfile == true);
                    profileProduct[0].id = 0;
                    products.forEach(x => x.isprdOnProfile = false);
                    products.push(profileProduct[0]);
                }

                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchFne', "Fne Products Found"));
                logKafka("INFO", "BuildProduct", "Fne Products Found", kafkaPageLogs, "applogs", visitId);
                products.forEach((prod) => setHtmlSymbols(prod));
                let fnePrd = products.sort((a, b) => parseFloat(a.displayPrice.replace("$", "")) - parseFloat(b.displayPrice.replace("$", "")));
                dispatch({
                    type: 'FETCH_FNE',
                    value: fnePrd.map(p => ({...p,apitype:"extender"}))
                });
                let CHRWhwFne = fnePrd && fnePrd.length > 0 ? fnePrd.filter(v=>v.id === 'R0840') : null;
                if (InHomeUtils.isNotNull(fnePrd) && fnePrd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Fne: true } });
                }
                if (CHRWhwFne && CHRWhwFne.length > 0) {
                    dispatch({ type: 'CHR_FNE_QUALIFIED', value: true });
                }
                else {
                    dispatch({ type: 'CHR_FNE_QUALIFIED', value: false });
                }
                let productOnProfile = products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { fne: true } });
                }
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchFne', "Fne " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Fne " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchFne(dispatch, visitId, reAttemptCount + 1)
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchFne', "Fne " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchFne', "Fne" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                if(response.data && response.data.ponType && response.data.ponType !== "NGPON2" && response.data.products.length == 0){
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-Fne", "", visitId, dispatch, true, "ProductNotReturned-Fne");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                }
                let errorMsg = `MethodName:fetchFne,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchFne', "Exception is: " + error.message));
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchFne,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchFne', ex);
    }
};

export const fetchVHSBiller = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVHSBiller', "Inside fetchVHSBiller"));
        logKafka("INFO", "BuildProduct", "Inside fetchVHSBiller", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vhsbiller')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            // }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {

                let products = response.data.products;
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVHSBiller', "Home Security Products Found"));
                logKafka("INFO", "BuildProduct", "Home Security Products Found", kafkaPageLogs, "applogs", visitId);
               // let homeSecurity =  products?.filter(p => (p.name === "Home Security"));
                //let homeSecurityplus =  products?.filter(p => (p.name === "Home Security Plus"));

                let bundleoneproduct = products?.filter(p => (p.id === "R3903"));
                let bundletwoproduct = products?.filter(p => (p.id === "R3904"));
                let bundlePrice = parseFloat(bundleoneproduct[0]?.displayPrice?.replace("$", "")) + parseFloat(bundletwoproduct[0]?.displayPrice?.replace("$", ""))
                dispatch({type: 'HOME_SECURITY_BUNDLE_PRICE',
                    value: bundlePrice
                })
               // parseFloat(a.displayPrice.replace("$", ""))
                let techSureObj = store.getState().buildProduct?.techsure?.techsureProducts;
                let vhsBillertechSureObj = techSureObj?.filter((product)=>(product?.id==="R3900"))
                if(vhsBillertechSureObj === null || vhsBillertechSureObj?.length === 0){
                /*if(homeSecurity && homeSecurity[0]?.isprdOnProfile === true){

                    dispatch({type: 'HOME_SECURITY',
                        value: true
                    })
                }
                if(homeSecurityplus && homeSecurityplus[0]?.isprdOnProfile === true){
                    dispatch({type: 'HOME_SECURITY_PLUS',
                        value: true
                    })
                }*/

                var accessories = products?.filter(p => (p.name !== "Home Security"  && p.name !== "Home Security Plus"));
                //let homeSecurity = products?.filter(each=>each.name.indexOf("Home Security")>-1)[0]

               // products.forEach((prod) => setHtmlSymbols(prod));
              let temp = products[5];
               products[5] = products[6];
               products[6] = temp;
                dispatch({
                    type: 'FETCH_VHSBILLER',
                    value: products
                });
                dispatch({
                    type: 'FETCH_ACESSORIES',
                    value: accessories
                });

                if (InHomeUtils.isNotNull(products) && products.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { vhsBiller: true } });
                }

                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { vhsBiller: true } });
                }
            }
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'vhsbiller', "vhsbiller " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "vhsbiller " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchVHSBiller(dispatch, visitId, reAttemptCount + 1)
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'vhsbiller', "vhsbiller " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'vhsbiller', "vhsbiller" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                
                let errorMsg = `MethodName:fetchFne,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'vhsbiller', "Exception is: " + error.message));
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:vhsbiller,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'vhsbiller', ex);
    }
};

export const fetchDHSBiller = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchDHSBiller', "Inside fetchDHSBiller"));
        logKafka("INFO", "BuildProduct", "Inside fetchDHSBiller", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'dhsbiller')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            // }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {

                let products = response.data.products;
                //console.log("dhsbiller_products",products);
                dispatch({
                    type: 'FETCH_DHSBILLER',
                    value: products
                });
               
                
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { dhsBiller: true } });
                }

                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_DHSBILLER',
                        value: productOnProfile.map(p=>p)
                    });
                }
            
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'dhsbiller', "dhsbiller " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "dhsbiller " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchDHSBiller(dispatch, visitId, reAttemptCount + 1)
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'dhsbiller', "dhsbiller " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'dhsbiller', "dhsbiller" + PAGEACTIVITY.MSG.productNotFound + "- ReAttempt", PAGEACTIVITY.UA));
                
                let errorMsg = `MethodName:fetchFne,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'dhsbiller', "Exception is: " + error.message));
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:dhsbiller,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'dhsbiller', ex);
    }
};


const fetchrowMasterTvList = (masterpackagesviewRows, currentPackageid) => {
    for (let i = 0; i < masterpackagesviewRows.length; i++) {
        if (masterpackagesviewRows[i].packageusoc === currentPackageid) {
            return masterpackagesviewRows[i];
        }
    }
}

export const updateVideoPlans = (tvPlans, dispatch) => {
    dispatch({
        type: 'FETCH_TVM2M', 
        value: tvPlans.map(p => p)
    });  
}

export const fetchPerksMTM = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPerksMTM', "Inside fetchPerksMTM"));
        logKafka("INFO", "BuildProduct", "Inside fetchPerksMTM", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
       
        let url = apiUrl().getProductEc + '/perks';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, "MTM", 'perks')).then(response => {  
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            // if (window.nrTimeState && window.nrTimeState.fromTime) {
            //     logNRTime(window.nrTimeState, dispatch, 'BuildProducts');
            // }
            let prdString = ""
            response?.data?.product?.forEach(p => {
                prdString += p?.name + ",";
            })
            if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
                dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
            }

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.product) && response.data.product.length > 0) {
                let perksPlans =  response?.data?.product;
                let isDisneyTrioInPlans =   perksPlans?.findIndex(p => p?.productId === "R4438") > -1;
                dispatch({ type: 'SET_DISNEY_TRIO', value: isDisneyTrioInPlans });

                dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
                let msg = `PERKS ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|PERKS:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', msg, PAGEACTIVITY.UA));
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', "PERKS " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchPerksMTM(dispatch, visitId, (reAttemptCount + 1));
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerksMTM', "PERKS " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                  errorAction("LBO", "BuildProduct", "ProductNotReturned-PerksMTM", "", visitId, dispatch, true, "ProductNotReturned-PerksMTM");
                  window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchPerksMTM,errorMessage:ProductNotReturned`;
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-PerksMTM");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                // perkStub.then(response=>{
                //     dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
                // })
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPerksMTM', "Exception is: " + error.message));
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchPerksMTM,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        // perkStub.then(response=>{
        //     dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
        // })
        catchJSException('BuildProduct', visitId, 'fetchPerksMTM', ex);
    }
};
export const fetchPerks2Y = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPerks2Y', "Inside fetchPerks2Y"));
        logKafka("INFO", "BuildProduct", "Inside fetchPerks2Y", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
       
        let url = apiUrl().getProductEc + '/perks';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        api(url, 'POST', getRequest(visitId, "TWOYEAR", 'perks')).then(response => {  
            if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
                dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
            }

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.product) && response.data.product.length > 0) {
                dispatch({ type: 'FETCH_PERKS', value: response.data.product.map(p => p) });
                let msg = `PERKS ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|PERKS:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerks2Y', msg, PAGEACTIVITY.UA));
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerks2Y', "PERKS " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchPerks2Y(dispatch, visitId, (reAttemptCount + 1));
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPerks2Y', "PERKS " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                  errorAction("LBO", "BuildProduct", "ProductNotReturned-PerksMTM", "", visitId, dispatch, true, "ProductNotReturned-PerksMTM");
                  window.localStorage.setItem('isLboTriggered', true);
                }
                let errorMsg = `MethodName:fetchPerks2Y,errorMessage:ProductNotReturned`;
                vzdlErrorUpdate(response.meta.code, "ProductNotReturned-PerksMTM");
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPerks2Y', "Exception is: " + error.message));
                let errorMsg = `MethodName:fetchPerks2Y,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchPerks2Y', ex);
    }
};
export const fetchTVMTM = (dispatch, visitId, zip, tarCode, channelLineUpTvPackages, isDoflow, couponFlowType = null, reAttemptCount = 0, isPegaFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "Inside fetchTVMTM"));
        logKafka("INFO", "BuildProduct", "Inside fetchTVMTM", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Video', couponFlowType, isPegaFlow)).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.prodTypeValue + ",";
                    })
                    let msg = `TV ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|VIDEO:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', msg, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                    if(response.data && response.data?.serviceOnProfile && response.data?.serviceOnProfile == true){
                        dispatch({type : 'IS_TV_ON_PROFILE',value : true});
                    }
                    //let customGenericTV = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC')
                    response.data.products.map(p => {
                        return processOfferSection(p);
                    });
                    let tvPlans = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1 || (p.prodTypeValue.indexOf('CUSTOM') > -1 && (p.isprdOnProfile || p.isChecked)));
                    let customTvPlans = response.data.products.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC');
                    //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
                    if (InHomeUtils.isNotNull(customTvPlans) && customTvPlans.length > 0) {
                        let onProfileCustomTV = customTvPlans.filter(p => p.isprdOnProfile);
                        if (InHomeUtils.isNotNull(onProfileCustomTV) && onProfileCustomTV.length > 0) {
                            tvPlans = tvPlans.filter(p => p.prodTypeValue !== 'CUSTOM_GENERIC');
                        }

                    }
                    if (response.data && response.data.premiumQualified && response.data.premiumQualified == true) {
                        dispatch({ type: 'PREMIUMOFFERQUALIFIED', value: true });
                    }

                   // Video comparison tool changes
                    let isShowVideoComparison = store.getState().buildProduct.showComparisonView;
                    if (isShowVideoComparison) {
                        let videoRecommendedPackages = store.getState().tvRecommender && store.getState().tvRecommender.sspusageinfo && store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack &&
                        store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack.recommendedPackages ? store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack.recommendedPackages : null;  
                        let videoOtherPkg = store.getState().tvRecommender && store.getState().tvRecommender.sspusageinfo && store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack &&
                        store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack.otherPackages ? store.getState().tvRecommender.sspusageinfo.videoUsageRecommendaitonPack.otherPackages : null;                      
                        if (videoRecommendedPackages && videoRecommendedPackages.length > 0) {
                            tvPlans.map((plan, index) => {
                                let planusoc = plan.id;            
                                plan.isRecommended = false
                                plan.istopRecommended = false           
                                if (videoRecommendedPackages !== null) {             
                                   {videoRecommendedPackages.map((recommProduct, index) => {
                                        if (recommProduct.basePackageIosc === planusoc) {
                                            let watchedChannels = recommProduct.watchedChannelList && recommProduct.watchedChannelList.length > 0? recommProduct.watchedChannelList : [] ;
                                            let notIncludedChannelCount = '';
                                            if (watchedChannels) {
                                                var notIncludedChannels = watchedChannels.filter(v=>v.isIncluded === 'N');
                                                notIncludedChannelCount = (notIncludedChannels && notIncludedChannels.length && notIncludedChannels.length > 0 )? notIncludedChannels.length : 0;

                                            }
                                            if (index === 0){
                                                plan.istopRecommended = true;
                                            }  
                                            plan.isRecommended = true;    
                                            // if (plan.prodTypeValue.indexOf('Fios_Five') === -1 ) {                                    
                                                plan.watchedChannelList = recommProduct.watchedChannelList? recommProduct.watchedChannelList : [] ;
                                                plan.comparisonText = 'This plan will remove' + ' ' + notIncludedChannelCount + ' ' + 'of your top 30 channels.';
                                            // }
                                            plan.notIncludedChannels = notIncludedChannels                  
                                            
                                        }                                        
                                    }
                                )} 
                            }
                            if(videoOtherPkg && videoOtherPkg.length && videoOtherPkg.length > 0 ){
                                {videoOtherPkg.map((otherProduct, index) => {
                                  if (otherProduct.basePackageIosc === planusoc) {
                                      let watchedChannels = otherProduct.watchedChannelList && otherProduct.watchedChannelList.length > 0? otherProduct.watchedChannelList : [] ;
                                      let notIncludedChannelCount = '';
                                      if (watchedChannels) {
                                          var notIncludedChannels = watchedChannels.filter(v=>v.isIncluded === 'N');
                                          notIncludedChannelCount = (notIncludedChannels && notIncludedChannels.length && notIncludedChannels.length > 0 )? notIncludedChannels.length  : 0;
                    
                                      }
                                    //   if (plan.prodTypeValue.indexOf('Fios_Five') === -1 ) {                                      
                                        plan.comparisonText = 'This plan will remove' + ' ' + notIncludedChannelCount + ' ' + 'of your top 30 channels.';
                                    //   }                 
                                    }
                                  }
                                )}
                              }
                        })                                    
                        if (store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.classicToFcp ) {
                            let profileClassicTV = store.getState().ecProfileCart && store.getState().ecProfileCart.ProfileTVProduct ? store.getState().ecProfileCart.ProfileTVProduct: null;
                            if (profileClassicTV) {
                                tvPlans.push({ id: profileClassicTV.prodId, isprdOnProfile: true, prodType: 'BASIC', prodTypeValue: 'CLASSICTV',  unitCount: "none", name: profileClassicTV.prodName});
                            }
                        }
                        tvPlans.push({ id: 'DONTWANTTV', isprdOnProfile: false, prodType: 'BASIC', prodTypeValue: 'DONTWANTTV', unitCount: "none", name: "I dont want live TV" });                   
                        }
                    }

                    let testdriveTvPlans = response.data.products.filter(p => p.prodTypeValue === 'ULTIMATETESTDRIVE');
                    let ultimateTv = response.data.products.filter(p => p.prodType === 'BASIC' && p.prodTypeValue === 'ULTIMATE');
                    let masterpackagesviewRows = null;
                    let tv_package_name = '';
                    if (InHomeUtils.isNotNull(testdriveTvPlans) && testdriveTvPlans.length > 0) {
                        dispatch({ type: 'ULTIMATE_DRIVE_AVL', value: true });
                        response.data.products.map(p => {
                            if(p.utdNewRecommMsg) {
                                tv_package_name = p.prodTypeValue ? p.prodTypeValue : '' ;                                
                                dispatch({ type: 'UTD_NEWRECOMM_MSG', value: tv_package_name });
                            }
                        })
                        tvrecommendedAction.tvrecommeted(visitId, dispatch);
                    }
                    if (InHomeUtils.isNotNull(ultimateTv) && ultimateTv.length > 0) {
                        dispatch({ type: 'ULTIMATE_USOC', value: ultimateTv[0].id });
                    }

                    masterpackagesviewRows = channelLineUpTvPackages;
                    if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "TV M2M - Fetching TV Results"));
                        logKafka("INFO", "BuildProduct", "TV M2M - Fetching TV Results", getErrorLogUrl, "applogs", visitId);
                        fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'N', testdriveTvPlans);
                    }
                    else {
                        let channelpackageUrl = apiUrl().channelLineupPackagesUrl;
                        api(channelpackageUrl, 'POST', getRequestChannel(visitId, zip, tarCode)).then(response => {
                            if (InHomeUtils.isNotNull(response)) {
                                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "TV M2M - ChannelLineup - Success"));
                                logKafka("INFO", "BuildProduct", "TV M2M - ChannelLineup - Success", getErrorLogUrl, "applogs", visitId);
                                masterpackagesviewRows = response.masterpackagesview;
                                dispatch({
                                    type: 'CHANNEL_MASTERPACKAGEVIEW',
                                    value: masterpackagesviewRows
                                });
                            }
                            fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'N', testdriveTvPlans);
                        })
                            .catch(error => {
                                let errorMsg = `MethodName:fetchTVMTM-Channelineup,errorMessage:${error.message}`;
                                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            });
                    }
                    let productOnProfile = tvPlans.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                    if (productOnProfile.length > 0) {
                        dispatch({ type: 'ONPROFILESTATUS', value: { tv: true } });
                    }
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchTVMTM(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, isDoflow, couponFlowType, (reAttemptCount + 1))
                }
                else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV "+ PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                    InHomeUtils.clearMemory();
                    InHomeUtils.redirectToHomePage("LQ=N");
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-TVMTM", "", visitId, dispatch, true, "ProductNotReturned-TVMTM");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchTVMTM,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
                if (isDoflow) {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            })
                .catch(error => {
                    if (reAttemptCount < retryCountFromAEM) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTVMTM', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                        fetchTVMTM(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, isDoflow, couponFlowType, (reAttemptCount + 1))
                    } else {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVMTM', "Exception is: " + error.message));
                        loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                        let errorMsg = `MethodName:fetchTVMTM,errorMessage:${error.message}`;
                        logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    }
                });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTVMTM', ex);
    }
};

const fetchTVResults = (dispatch, customTvPlans, tvPlans, masterpackagesviewRows, Tv2Year) => {
    let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
    for (let i = 0; i < tvPlans.length; i++) {
        if (tvPlans[i].prodTypeValue === "CUSTOM_GENERIC") {
            tvPlans[i].description = "155+ channels  (7 plans to choose from)";
            continue;
        }
        if (tvPlans[i].prodTypeValue !== "CUSTOM_GENERIC" && (tvPlans[i].prodTypeValue.indexOf('CUSTOM') > -1 && tvPlans[i].isprdOnProfile)) {
            tvPlans[i].name = (tvPlans[i].name === "Custom TV" ? "Custom TV" : "Custom TV"  + ' ' + tvPlans[i].name);
            continue;
        }
        if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
            let singlerowtv = fetchrowMasterTvList(masterpackagesviewRows, tvPlans[i].id);
            if (InHomeUtils.isNotNull(singlerowtv)) {
                tvPlans[i].description = singlerowtv.totalchannelcount + "+ channels (" + singlerowtv.hdchannelcount + "+ in HD)";
            }
        }
    }
    if (Tv2Year === 'N') {
        if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
            dispatch({
                type: 'FETCH_TVM2M',
                value: tvPlans.filter(q=> q.isprdOnProfile).map(p => p)
            });
        }else{
            dispatch({
                type: 'FETCH_TVM2M',
                value: tvPlans.map(p => p)
            });
        }
        
    }
    else {
        if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
            dispatch({
                type: 'FETCH_TV2Y',
                value: tvPlans.filter(q=> q.isprdOnProfile).map(p => p)
            });
        }else{
            dispatch({
                type: 'FETCH_TV2Y',
                value: tvPlans.map(p => p)
            });
        }
    }
    // else {
    //     doProcessBasicDiff(dispatch, tvPlansBasicDiff, tvPlans);
    // }
    dispatch({
        type: 'FETCH_CUSTOMTV',
        value: customTvPlans.map(p => p)
    });
}

export const updateStateBuildPrdPage = (val) => {
    statevalue = val;
}

export const fetchTV2Y = (dispatch, visitId, zip, tarCode, channelLineUpTvPackages, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "Inside fetchTV2Y"));
        logKafka("INFO", "BuildProduct", "Inside fetchTV2Y", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Video')).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.prodTypeValue + ",";
                    })
                    let msg = `TV ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|VIDEO:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', msg, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                    //let customGenericTV = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC')
                    response.data.products.map(p => {
                        return processOfferSection(p);
                    });
                    //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
                    let tvPlans = response.data.products.filter(p => p.prodTypeValue === 'CUSTOM_GENERIC' || p.prodTypeValue.indexOf('CUSTOM') === -1 || (p.prodTypeValue.indexOf('CUSTOM') > -1 && (p.isprdOnProfile || p.isChecked)))
                    let customTvPlans = response.data.products.filter(p => p.prodTypeValue.indexOf('CUSTOM') > -1 && p.prodTypeValue !== 'CUSTOM_GENERIC')
                    let masterpackagesviewRows = null;
                    if (InHomeUtils.isNotNull(customTvPlans) && customTvPlans.length > 0) {
                        let onProfileCustomTV = customTvPlans.filter(p => p.isprdOnProfile);
                        if (InHomeUtils.isNotNull(onProfileCustomTV) && onProfileCustomTV.length > 0) {
                            tvPlans = tvPlans.filter(p => p.prodTypeValue !== 'CUSTOM_GENERIC');
                        }

                    }

                    masterpackagesviewRows = channelLineUpTvPackages;
                    if (InHomeUtils.isNotNull(masterpackagesviewRows)) {
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "TV 2YR - Fetching Tv Results"));
                        logKafka("INFO", "BuildProduct", "TV 2YR - Fetching Tv Results", getErrorLogUrl, "applogs", visitId);
                        fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'Y');
                    }
                    else {
                        let channelpackageUrl = apiUrl().channelLineupPackagesUrl;
                        api(channelpackageUrl, 'POST', getRequestChannel(visitId, zip, tarCode)).then(response => {
                            if (InHomeUtils.isNotNull(response)) {
                                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTV2Y', "TV 2YR - channellineup Success"));
                                logKafka("INFO", "BuildProduct", "TV 2YR - channellineup Success", getErrorLogUrl, "applogs", visitId);
                                masterpackagesviewRows = response.masterpackagesview;
                                dispatch({
                                    type: 'CHANNEL_MASTERPACKAGEVIEW',
                                    value: masterpackagesviewRows
                                });
                                fetchTVResults(dispatch, customTvPlans, tvPlans, masterpackagesviewRows, 'Y');
                            }

                        })
                            .catch(error => {

                                let errorMsg = `MethodName:fetchTV2Y-Channelineup,errorMessage:${error.message}`;
                                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            });
                    }
                    let productOnProfile = tvPlans.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                    if (productOnProfile.length > 0) {
                        dispatch({ type: 'ONPROFILESTATUS', value: { tv: true } });
                    }
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                    fetchTV2Y(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, reAttemptCount + 1)
                }
                else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                    InHomeUtils.clearMemory();
                    InHomeUtils.redirectToHomePage("LQ=N");
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-TV2Y", "", visitId, dispatch, true, "ProductNotReturned-TV2Y");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchTV2Y,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }

            })
                .catch(error => {
                    if (reAttemptCount < retryCountFromAEM) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchTV2Y', "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "TV " + PAGEACTIVITY.MSG.productNotFound + "- Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                        fetchTV2Y(dispatch, visitId, zip, tarCode, channelLineUpTvPackages, reAttemptCount + 1)
                    } else {
                        loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                        let errorMsg = `MethodName:fetchTV2Y,errorMessage:${error.message}`;
                        logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    }
                });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchTV2Y', ex);
    }
};
export const fetchVoiceMTM = (dispatch, visitId, reAttemptCount = 0, isPegaFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoiceMTM', "Inside fetchVoiceMTM"));
        logKafka("INFO", "BuildProduct", "Inside fetchVoiceMTM", getErrorLogUrl, "applogs", visitId);
        let allowVoiceWithMultiGig = store.getState() && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.AllowVoiceWithMultiGIG == "Y" ? true : false;
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        console.log('flowRouteValue',flowRouteValue);
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        return new Promise((resolve, reject) => {
            loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
            api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Fios_Voice',null ,isPegaFlow)).then(response => {
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    let prdString = ""
                    response.data.products.forEach(p => {
                        prdString += p.name + ",";
                    })
                    if(response.data && response.data?.serviceOnProfile && response.data?.serviceOnProfile == true){
                        dispatch({type : 'IS_VOICE_ON_PROFILE',value : true});
                    }
                    let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                    if (productOnProfile.length > 0) {
                        dispatch({ type: 'ONPROFILESTATUS', value: { voice: true } });
                        fetchExistingVoiceSubProducts(dispatch, visitId)
                    }
                    let msg = `VOICE ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.m2m}|VOICE:${prdString}`
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchDataMTM', msg, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                    if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
                        dispatch({
                            type: 'FETCH_VOICE', value: response.data.products.filter(item => item.isprdOnProfile).map(p => {
                                return processOfferSection(p);
                            })
                        })
                    }else{
                        dispatch({
                            type: 'FETCH_VOICE',
                            value: response.data.products.map(p => {
                                return processOfferSection(p);
                            })
                        });
                    }
                    let sortedResponse = InHomeUtils.isNotNull(response.data.voiceUsageRatesList) && response.data.voiceUsageRatesList.sort(function (a, b) {return (a.countryName < b.countryName) ? -1 : (a.countryName > b.countryName) ? 1 : 0;});
                    // const defaultPlan = {
                    //     pricingPlanCode: "",
                    //     countryName: "None at this time",
                    //     usageCap: ""
                    // };
                    // InHomeUtils.isNotNull(sortedResponse) && sortedResponse.push(defaultPlan);
                    InHomeUtils.isNotNull(sortedResponse) && dispatch({
                        type: 'EC_FETCH_INTLCALLING',
                        value: sortedResponse
                    });                     
                    
                    resolve(response.data);
                }
                else if (reAttemptCount < retryCountFromAEM) {
                    {/*if(!allowVoiceWithMultiGig && response.data && response.data.ponType && response.data.ponType == "NGPON2"){
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : true});
                    } */}
                    if(response.data && response.data.skipFDVWithNGPON2 == true){
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : true});
                    }
                    else{
                        dispatch({type : 'DISABLE_VOICE_ACCOR_NGPON2',value : false});
                    }
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchVoiceMTM(dispatch, visitId, (reAttemptCount + 1));
                }
                else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                    InHomeUtils.clearMemory();
                    InHomeUtils.redirectToHomePage("LQ=N");
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.m2m, PAGEACTIVITY.UA));
                    let multiGigProfile = [];
                    multiGigProfile = store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.m2mPlans && store.getState().buildProduct.internet.m2mPlans.filter((item)=>item.speedCode == "947" && item.isprdOnProfile)
                    if(allowVoiceWithMultiGig && multiGigProfile.length != 1 && (response.data && response.data.ponType && response.data.ponType != "NGPON2")){
                        if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                            errorAction("LBO", "BuildProduct", "ProductNotReturned-VoiceMTM", "", visitId, dispatch, true, "ProductNotReturned-VoiceMTM");
                            window.localStorage.setItem('isLboTriggered', true);    
                        }
                    }
                    let errorMsg = `MethodName:fetchVoiceMTM,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            })
                .catch(error => {
                    if (reAttemptCount < retryCountFromAEM) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoiceMTM', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                        fetchVoiceMTM(dispatch, visitId, (reAttemptCount + 1));
                    } else {
                        loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                        let errorMsg = `MethodName:fetchVoiceMTM,errorMessage:${error.message}`;
                        logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    }
                });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVoiceMTM', ex);
    }
};

export const fetchVoice2Y = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoice2Y', "Inside fetchVoice2Y"));
        logKafka("INFO", "BuildProduct", "Inside fetchVoice2Y", getErrorLogUrl, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        let url = apiUrl().getProductEc + '/plans';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        let retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if (typeof retryCountFromAEM !== "number" || retryCountFromAEM < 1) {
            retryCountFromAEM = 1;
        }
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.twoYear, 'Fios_Voice')).then(response => {
            loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                let prdString = ""
                response.data.products.forEach(p => {
                    prdString += p.downSpeed + ",";
                })
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { voice: true } });
                    fetchExistingVoiceSubProducts(dispatch, visitId)
                }
                let msg = `VOICE ${PAGEACTIVITY.MSG.productFound}|STATE:${statevalue}|CONTRACT:${PAGEACTIVITY.MSG.twoyear}|VOICE:${prdString}`
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', msg, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", msg, getErrorLogUrl, "applogs", visitId);
                if(flowRouteValue == 'FULLDISCONNECT' || flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_VOICE', value: response.data.products.filter(item => item.isprdOnProfile).map(p => {
                            return processOfferSection(p);
                        })
                    })
                }else{
                    dispatch({
                        type: 'FETCH_VOICE',
                        value: response.data.products.map(p => {
                            return processOfferSection(p);
                        })
                    });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                fetchVoice2Y(dispatch, visitId, (reAttemptCount + 1));
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.productNotFound + "|STATE:" + statevalue + "|CONTRACT:" + PAGEACTIVITY.MSG.twoyear, PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Voice2Y", "", visitId, dispatch, true, "ProductNotReturned-Voice2Y");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchVoice2Y,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                if (reAttemptCount < retryCountFromAEM) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVoice2Y', "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "VOICE " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, getErrorLogUrl, "applogs", visitId);
                    fetchVoice2Y(dispatch, visitId, (reAttemptCount + 1));
                } else {
                    loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                    let errorMsg = `MethodName:fetchVoice2Y,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVoice2Y', ex);
    }
};

export const fetchVRoom = (dispatch, visitId, isLocalTVInCart, isDCTinCart, profileCeAppCount = 0, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVRoom', "Inside fetchVRoom"));
        logKafka("INFO", "BuildProduct", "Inside fetchVRoom", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCountEC ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCountEC) : 0;
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vroom')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVRoom', "VRoom Products Found"));
                logKafka("INFO", "BuildProduct", "VRoom Products Found", kafkaPageLogs, "applogs", visitId);
                if(response?.data?.profileMake){
                    let isSercommFlow = response?.data?.profileMake === "sercomm" ? true : false;
                    dispatch({
                        type: 'SET_SERRCOM_PROFILE',
                        value: isSercommFlow
                    });
                }
                response.data.products.forEach((prod) => setHtmlSymbols(prod));
                {/*if (isLocalTVInCart || isDCTinCart) {
                    response.data.products.push({ id: 'NOVROOM', prodType: 'vroom', unitCount: "none", name: "No TVs" });
                }*/}
                response.data.products.sort((a, b) => (a.unitCount > b.unitCount) ? 1 : ((b.unitCount > a.unitCount) ? -1 : 0));
                let tvConnections = JSON.parse(JSON.stringify(response.data.products))
                tvConnections = tvConnections.map(p=> {p['prodType'] = 'DUMMYVROOM'; return p;});
                dispatch({
                    type: 'FETCH_VROOM',
                    value: response.data.products.map(p => p)
                });

                if (InHomeUtils.isNotNull(response.data.products.map(p => p)) && response.data.products.map(p => p).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Vroom: true } });
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { vRoom: true } });
                    // CeApp OnProfile Scenario
                    if (profileCeAppCount > 0) {
                        tvConnections = tvConnections.map(p=> {p['isprdOnProfile'] = false; return p;});
                        let profileSetUpBoxCount = productOnProfile[0].unitCount;
                        let profileCeDeviceCount = profileCeAppCount;
                        let profileDummyVRoomCount = profileSetUpBoxCount - profileCeDeviceCount;
                        for (let count = 0; count < tvConnections.length; count++) {
                            if (parseInt(tvConnections[count].unitCount) === profileDummyVRoomCount) {
                                tvConnections[count].isprdOnProfile = true;
                                dispatch({ type: 'SET_PROFILE_DUMMY_VROOM', value: tvConnections[count] });
                                break;
                            }
                        }
                    }
                    //
                    let  displayTVConnectionsProducts = tvConnections.filter(p => p && p.unitCount && parseInt(p.unitCount) <= parseInt(productOnProfile[0].unitCount));
                    dispatch({ type: 'UPDATE_TVCONNECTIONS', value: (displayTVConnectionsProducts && displayTVConnectionsProducts.length >0)? displayTVConnectionsProducts: null });
                }
                dispatch({
                    type: 'FETCH_TVCONNECTIONS',
                    value: tvConnections
                });
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_VROOM',
                        value: productOnProfile.map(p => p)
                    });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVRoom', "VRoom " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "VRoom " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchVRoom(dispatch, visitId, isLocalTVInCart, isDCTinCart, profileCeAppCount, (reAttemptCount + 1));
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,   'fetchVRoom', "VRoom " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchVRoom', "VRoom " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-VRoom", "", visitId, dispatch, true, "ProductNotReturned-VRoom");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchVRoom,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchVRoom,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchVRoom', ex);
    }
};

export const fetchRecording = (dispatch, visitId, couponFlowType, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRecording', "Inside fetchRecording"));
        logKafka("INFO", "BuildProduct", "Inside fetchRecording", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCountEC ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCountEC) : 0;
        if(reAttemptCount > 0 && reAttemptCount <= retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'vfeature', couponFlowType)).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchRecording', "Recording Products Found"));
                logKafka("INFO", "BuildProduct", "Recording Products Found", kafkaPageLogs, "applogs", visitId);
                let product = [{ id: 'NORECORD', prodType: 'VFEATURE', name: "I don't want to record on any TV's." }];
                let recordingProduct = response.data.products.map(p => p);
                product.map(p => recordingProduct.push(p));
                dispatch({
                    type: 'FETCH_RECORDING',
                    value: recordingProduct
                });
                if (InHomeUtils.isNotNull(recordingProduct) && recordingProduct.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Recording: true } });
                }
                let productOnProfile = recordingProduct.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { recording: true } });
                }
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_RECORDING',
                        value: productOnProfile.map(p=>p)
                    });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRecording', "Recording " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Recording " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchRecording(dispatch, visitId, couponFlowType, (reAttemptCount + 1))
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchRecording', "Recording " + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchRecording', "Recording " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Rcording", "", visitId, dispatch, true, "ProductNotReturned-Recording");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchRecording,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchRecording,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchRecording', ex);
    }
};

export const fetchChannel = (dispatch, visitId, selectedProductId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchChannel', "Inside fetchChannel"));
        logKafka("INFO", "BuildProduct", "Inside fetchChannel", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getPremiumChannelRequest(visitId, Contract.monthToMonth, 'MOVIE', selectedProductId)).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchChannel', "Channel Products Found"));
                logKafka("INFO", "BuildProduct", "Channel Products Found", kafkaPageLogs, "applogs", visitId);
                dispatch({
                    type: 'FETCH_CHANNEL',
                    value: response.data.products.filter(p => p.includedWithPlan === false)
                });
                if (InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Channel: true } });
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { channel: true } });
                }
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_CHANNEL',
                        value: productOnProfile.map(p=>p)
                    });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchChannel(dispatch, visitId, selectedProductId, (reAttemptCount + 1))
            }
            // else {
            //     if (!isLboOccurred) {
            //         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt 1", PAGEACTIVITY.UA));
            //         fetchChannel(dispatch, visitId, selectedProductId, true)
            //     } else {
            //         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchChannel', "Channel " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
            //         errorAction("LBO", "BuildProduct", "ProductNotReturned-Channel", "", visitId, dispatch, true, "ProductNotReturned-Channel");
            //         let errorMsg = `MethodName:fetchChannel,errorMessage:ProductNotReturned`;
            //         logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            //     }
            // }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchChannel,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchChannel', ex);
    }
};

export const loadTN = (visitId, dispatch, isHoaFlow = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'loadTN', "Inside loadTN"));
        logKafka("ERROR", "BuildProduct", "Inside loadTN", getErrorLogUrl, "applogs", visitId, "try");
        let url = apiUrl().voicetn + '/requesttn?nooftns=1';
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '201') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data.requestedTnsOnly) && response.data.requestedTnsOnly.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'loadTN', "loadTN Success"));
                logKafka("ERROR", "BuildProduct", "loadTN Success", getErrorLogUrl, "applogs", visitId, "try");
                dispatch({
                    type: 'LOAD_TN',
                    value: response.data.requestedTnsOnly[0]
                });
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500')) {
                dispatch({
                    type: 'LOAD_TN',
                    value: "1000000001"
                });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'loadTN', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", PAGEACTIVITY.MSG.apiResponseFailed, getErrorLogUrl, "applogs", visitId);
                if(InHomeUtils.isNotNull(isHoaFlow) && isHoaFlow) {
                    errorAction("LBO", "BuildProduct", "TNFailed", "", visitId, dispatch, true, "TNFailed");
                } 
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:loadTN,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'loadTN', ex);
    }
};

export const fetchListing = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchListing', "Inside fetchListing"));
        logKafka("INFO", "BuildProduct", "Inside fetchListing", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'listing')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchListing', "Listing Products Found"));
                logKafka("INFO", "BuildProduct", "Listing Products Found", kafkaPageLogs, "applogs", visitId);
                let listingProd = response.data.products.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    listingProd = listingProd.filter(q=> q.isprdOnProfile).map(p => p)
                }
                dispatch({
                    type: 'FETCH_LISTING',
                    value: listingProd
                });
                if (InHomeUtils.isNotNull(listingProd) && listingProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Listing: true } });
                }

                let PYOACProducts = response.data.products.filter(p => p.prodType === "FVPREMIUM" && (p.keyword !== null && p.keyword.indexOf("PYOAC") > -1))
                dispatch({
                    type: 'FETCH_PYOAC',
                    value: PYOACProducts
                })
                if (InHomeUtils.isNotNull(PYOACProducts) && PYOACProducts.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Pyoac: true } });
                }
                let productOnProfile = listingProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { listing: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchListing', "Listing " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Listing " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchListing(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === 3 && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchListing', "Listing "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchListing', "Listing " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-Listing", "", visitId, dispatch, true, "ProductNotReturned-Listing");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchListing,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchListing,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchListing', ex);
    }
};

export const fetchExistingListing = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchExistingListing', "Inside fetchExistingListing"));
        logKafka("INFO", "BuildProduct", "Inside fetchExistingListing", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'EXISTING_LISTING')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchExistingListing', "Listing Products Found"));
                logKafka("INFO", "BuildProduct", "Listing Products Found", kafkaPageLogs, "applogs", visitId);
                let listingProd = response.data.products.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);

                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    listingProd = listingProd.filter(q=> q.isprdOnProfile).map(p => p)
                }
                dispatch({
                    type: 'FETCH_EXISTING_LISTING',
                    value: listingProd
                });
                if (InHomeUtils.isNotNull(listingProd) && listingProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Listing: true } });
                }

                let PYOACProducts = response.data.products.filter(p => p.prodType === "FVPREMIUM" && (p.keyword !== null && p.keyword.indexOf("PYOAC") > -1))
                dispatch({
                    type: 'FETCH_PYOAC',
                    value: PYOACProducts
                })
                if (InHomeUtils.isNotNull(PYOACProducts) && PYOACProducts.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Pyoac: true } });
                }
                let productOnProfile = listingProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { listing: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchExistingListing', "ExistingListing " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "ExistingListing " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchExistingListing(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === retryCountFromAEM && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchExistingListing', "ExistingListing "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchExistingListing', "ExistingListing " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                    errorAction("LBO", "BuildProduct", "ProductNotReturned-ExistingListing", "", visitId, dispatch, true, "ProductNotReturned-ExistingListing");
                    window.localStorage.setItem('isLboTriggered', true);    
                }
                let errorMsg = `MethodName:fetchExistingListing,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchExistingListing,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchExistingListing', ex);
    }
};

export const fetchBackup = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchBackup', "Inside fetchBackup"));
        logKafka("INFO", "BuildProduct", "Inside fetchBackup", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        let fttpAvailabilityDetailsAGR = store && store.getState && store.getState().loopQual && store.getState().loopQual.ecLQResponse && store.getState().loopQual.ecLQResponse.getLoopAvailabilityResponseMsg && store.getState().loopQual.ecLQResponse.getLoopAvailabilityResponseMsg.fttpAvailabilityDetailsAGR;
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'battery')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchBackup', "BBU Products Found"));
                logKafka("INFO", "BuildProduct", "BBU Products Found", kafkaPageLogs, "applogs", visitId);
                //let bbuPrds = response.data.service[0].packages[0].products.filter(p => (p.keyWord === "|FDV_BTRY_CHARGED|" || p.keyWord === "|FDV_DCELL_TRAY_CHARGED|" || p.keyWord === "|FDV_BTRY_ZRATED_DEC|" || p.keyWord === "|FDV_DCELL_TRAY_ZRATED_DEC|"))
                let bbProds = response.data.products.filter(p => p.prodType.indexOf('SHIPMENT') === -1)
                let bbShipProds = response.data.products.filter(p => p.prodType.indexOf('SHIPMENT') > -1).sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    bbProds = bbProds.filter(q=> q.isprdOnProfile).map(p => p)
                    bbShipProds = bbShipProds.filter(q=> q.isprdOnProfile).map(p => p)
                }
                dispatch({
                    type: 'FETCH_BATTERY',
                    //value: bbuPrds
                    value: bbProds
                });
                dispatch({
                    type: 'FETCH_BATTERY_SHIPMENT',
                    value: bbShipProds
                });
                if (InHomeUtils.isNotNull(bbProds) && bbProds.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Backup: true } });
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { batteryBackup: true } });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchBackup', "BBU " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "BBU " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchBackup(dispatch, visitId, (reAttemptCount + 1));
            }
            else {
                if(fttpAvailabilityDetailsAGR && fttpAvailabilityDetailsAGR.ontAGR && fttpAvailabilityDetailsAGR.ontAGR.length > 0 && fttpAvailabilityDetailsAGR.ontAGR[0].ontType !== 'SOHO'){
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchBackup', "BBU " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                    if(!JSON.parse(window.localStorage.getItem("isLboTriggered"))){
                        errorAction("LBO", "BuildProduct", "ProductNotReturned-BatteryBackup", "", visitId, dispatch, true, "ProductNotReturned-BatteryBackup");
                        window.localStorage.setItem('isLboTriggered', true);    
                    }
                    let errorMsg = `MethodName:fetchBackup,errorMessage:ProductNotReturned`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                }else{
                    dispatch({ type: 'UPDATE_BATTERY_ACCOR_STATUS', value: 'optional' });
                }  
            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchBackup,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchBackup', ex);
    }
};

export const fetchCallingFeatures = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCallingFeatures', "Inside fetchCallingFeatures"));
        logKafka("INFO", "BuildProduct", "Inside fetchCallingFeatures", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().getVoiceProductEc + '/voice/callingfeatures';
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'FVMAIL')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) &&
                InHomeUtils.isNotNull(response.data.service) && response.data.service.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages) && response.data.service[0].packages.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages[0].voiceProducts)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCallingFeatures', "Calling Features Products Found"));
                logKafka("INFO", "BuildProduct", "Calling Features Products Found", kafkaPageLogs, "applogs", visitId);
                let callingFeaturesProd = response.data.service[0].packages[0].voiceProducts.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_CALLING_FEATURES',
                    value: callingFeaturesProd
                });
                if (InHomeUtils.isNotNull(callingFeaturesProd) && callingFeaturesProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { CallingFeatures: true } });
                }

                let productOnProfile = callingFeaturesProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { callingFeatures: true } });
                }
            }
            else if (reAttemptCount < 3) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCallingFeatures', "Calling Features " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Calling Features " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchCallingFeatures(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === 3 && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchCallingFeatures', "Calling Features "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchCallingFeatures', "Calling Features " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                // errorAction("LBO", "BuildProduct", "ProductNotReturned-Calling Features", "", visitId, dispatch, true, "ProductNotReturned-Calling Features");
                let errorMsg = `MethodName:fetchCallingFeatures, errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchCallingFeatures,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchCallingFeatures', ex);
    }
};

export const fetchIntlPlans = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntlPlans', "Inside fetchIntlPlans"));
        logKafka("INFO", "BuildProduct", "Inside fetchIntlPlans", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().getVoiceProductEc + '/voice/intlplans';
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'intlplans')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) &&
                InHomeUtils.isNotNull(response.data.service) && response.data.service.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages) && response.data.service[0].packages.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages[0].voiceProducts)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntlPlans', "International Plans Products Found"));
                logKafka("INFO", "BuildProduct", "International Plans Products Found", kafkaPageLogs, "applogs", visitId);
                let intlPlansProd = response.data.service[0].packages[0].voiceProducts.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_INTERNATIONAL_PLANS',
                    value: intlPlansProd
                });
                if (InHomeUtils.isNotNull(intlPlansProd) && intlPlansProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { IntlPlans: true } });
                }

                let productOnProfile = intlPlansProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { IntlPlans: true } });
                }
            }
            else if (reAttemptCount < 3) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntlPlans', "International Plans " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "International Plans " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchIntlPlans(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === 3 && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,   'fetchIntlPlans', "International Plans "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntlPlans', "International Plans " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                //errorAction("LBO", "BuildProduct", "ProductNotReturned-International Plans", "", visitId, dispatch, true, "ProductNotReturned-International Plans");
                let errorMsg = `MethodName:fetchIntlPlans, errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchIntlPlans,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchIntlPlans', ex);
    }
};

export const fetchLongDistance = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchLongDistance', "Inside fetchLongDistance"));
        logKafka("INFO", "BuildProduct", "Inside fetchLongDistance", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().getVoiceProductEc + '/voice/longdistance';
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'Long Distance')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) &&
                InHomeUtils.isNotNull(response.data.service) && response.data.service.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages) && response.data.service[0].packages.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages[0].voiceProducts)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchLongDistance', "Long Distance Products Found"));
                logKafka("INFO", "BuildProduct", "Long Distance Products Found", kafkaPageLogs, "applogs", visitId);
                let longDistanceProd = response.data.service[0].packages[0].voiceProducts.filter(p => (p.prodType !== "FVPREMIUM" && p.prodType !== "FVNONPUB" && p.prodType !== "FVNONLIST")).sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_LONG_DISTANCE',
                    value: longDistanceProd
                });
                if (InHomeUtils.isNotNull(longDistanceProd) && longDistanceProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { LongDistance: true } });
                }

                let productOnProfile = longDistanceProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { LongDistance: true } });
                }
            }
            else if (reAttemptCount < 3) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchLongDistance', "Long Distance " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Long Distance " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchLongDistance(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === 3 && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,   'fetchLongDistance', "Long Distance "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchLongDistance', "Long Distance " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                // errorAction("LBO", "BuildProduct", "ProductNotReturned-Long Distance", "", visitId, dispatch, true, "ProductNotReturned-Long Distance");
                let errorMsg = `MethodName:fetchLongDistance, errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchLongDistance,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchLongDistance', ex);
    }
};

export const fetchWireMaintenance = (dispatch, visitId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchWireMaintenance', "Inside fetchWireMaintenance"));
        logKafka("INFO", "BuildProduct", "Inside fetchWireMaintenance", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().getVoiceProductEc + '/voice/wiremaintenance';
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'FVIWMP')).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) &&
                InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) &&
                InHomeUtils.isNotNull(response.data.service) && response.data.service.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages) && response.data.service[0].packages.length > 0 &&
                InHomeUtils.isNotNull(response.data.service[0].packages[0].voiceProducts)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchWireMaintenance', "Wire Maintenance Products Found"));
                logKafka("INFO", "BuildProduct", "Wire Maintenance Products Found", kafkaPageLogs, "applogs", visitId);
                let wiremaintenanceProd = response.data.service[0].packages[0].voiceProducts.filter(p => p.prodType !== "FVPREMIUM").sort((a, b) => a.originalPrice > b.originalPrice ? 1 : -1);
                dispatch({
                    type: 'FETCH_WIRE_MAINTENANCE',
                    value: wiremaintenanceProd
                });
                if (InHomeUtils.isNotNull(wiremaintenanceProd) && wiremaintenanceProd.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { WIREMAINTENANCE: true } });
                }

                let productOnProfile = wiremaintenanceProd.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { WIREMAINTENANCE: true } });
                }
            }
            else if (reAttemptCount < 3) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchWireMaintenance', "Wire Maintenance " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "Wire Maintenance " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchWireMaintenance(dispatch, visitId, reAttemptCount + 1);
            }
            else if (reAttemptCount === 3 && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.status) && InHomeUtils.getIndexOf(response.status, '412')) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId,  'fetchWireMaintenance', "Wire Maintenance "  + PAGEACTIVITY.MSG.error_412, PAGEACTIVITY.UA));
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage("LQ=N");
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchWireMaintenance', "Wire Maintenance " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                // errorAction("LBO", "BuildProduct", "ProductNotReturned-Wire Maintenance", "", visitId, dispatch, true, "ProductNotReturned-Wire Maintenance");
                let errorMsg = `MethodName:fetchWireMaintenance, errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {
                // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
                let errorMsg = `MethodName:fetchWireMaintenance,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchWireMaintenance', ex);
    }
};

export const updateCartTNPorted = (visitId, isDoFlow, product, dispatch, portedTN, wbProd, isChecked = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartTNPorted', "Inside updateCartTNPorted"));
        logKafka("ERROR", "BuildProduct", "Inside updateCartTNPorted", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().updateCartAcc + '/' + visitId;
        let request = JSON.stringify({ "tn": portedTN, "productId": product[0].id, "productType": product[0].prodType, "serviceType": Service.voice, "status": isChecked ? "remove" : "add", "quantity": "1", "contract": Contract.monthToMonth })
        updateSCTags("add to cart")
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartTNPorted', `Winback TN ${!isChecked ? "Removed from" : "Added to"} cart`));
                addToCartSCEvent(visitId, product, "WINBACKADDED", response, isDoFlow, !isChecked);
                if (isChecked) {
                    updateRequestTNForFDV(visitId, portedTN, dispatch);
                }
                dispatch({ type: 'UPDATE_PORTEDTN', value: !isChecked ? portedTN : "" });
                dispatch({ type: ModalWindow.onModalWindowClose, value: 'WINBACKYES' })
                dispatch({ type: 'WINBACK_SELECTEDPROD', value: !isChecked || (InHomeUtils.isNotNull(wbProd) && wbProd.id === "WINBACKNO") ? wbProd : null });
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartTNPorted', `Winback - TN Not ${!isChecked ? "Removed from" : "Added to"} cart`, PAGEACTIVITY.UA));
            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartTNPorted', ex);
    }
}

export const updateFutureNotificationIntialStatus = (visitId, dispatch) => {
    dispatch({
        type: FutureNotification.intialstatusbackendcall,
        value: false
    });
}

export const updateFutureNotification = (visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress, contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Inside updateFutureNotification"));
        logKafka("INFO", "BuildProduct", "Inside updateFutureNotification", kafkaPageLogs, "applogs", visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Updating your details", isLoaderImg: "loader" }
        });
        let url = apiUrl().futurenotification;

        api(url, 'POST', getRequestfuturenotification(visitId, telNbr, addrId, firstName, lastName, businessName, addressLine1, addressLine2, city, state, zipCode, emailAddress, contactPhone, vzPhone, notifyFios, notifyFiosTv, appId, nsiInd)).then(response => {
            if (InHomeUtils.isNull(response)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Failure"));
                dispatch({
                    type: FutureNotification.validationfailure,
                    value: true
                });
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Success"));
                logKafka("INFO", "BuildProduct", "Future Notification Validation Success", kafkaPageLogs, "applogs", visitId);
                dispatch({
                    type: FutureNotification.validationsucess,
                    value: true
                });
                //dispatch({ type: ModalWindow.onModalWindowClose, value: ModalWindow.ids.notification })  
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '400') && response.meta.description === "Email validation failed") {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Email Validation Failed"));
                logKafka("ERROR", "BuildProduct", "Future Notification Email Validation Failed", getErrorLogUrl, "applogs", visitId);
                dispatch({ type: FutureNotification.emailErr, value: true })
                //lqAction.emailErr(true, this.props.dispatch)
                //dispatch({ type: ModalWindow.onModalWindowClose, value: ModalWindow.ids.notification })  
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateFutureNotification', "Future Notification Validation Failed"));
                logKafka("ERROR", "BuildProduct", "Future Notification Validation Failed", getErrorLogUrl, "applogs", visitId);
                dispatch({
                    type: FutureNotification.validationfailure,
                    value: true
                });
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                let errorMsg = `MethodName:updateFutureNotification,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateFutureNotification', ex);
    }
}

export const referFrinedValidation = (visitId, isDoFlow, coupon, dispatch) => {
    try {
        /*    dispatch({
               type: 'LOADER_ACTIVE',
               value: { isLoaderActive: true, isLoaderText: "adding refer a friend coupon", isLoaderImg: "loader" }
           }); */
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'referFrinedValidation', "Inside referFrinedValidation"));
        dispatch({ type: 'REFERAFRIENDBACKENDCALSTART', value: true });

        let url = apiUrl().referFrinedValidation;

        api(url, 'POST', validateReferralCode(visitId, coupon)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.transactions) && response.transactions.length > 0 && response.transactions[0].code !== 999) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'referFrinedValidation', " transaction is success"));
                //dispatch({ type: ModalWindow.onModalWindowClose, value:  ModalWindow.ids.coupon }) 
                tempSCData.pageName = "urc landing page";   
                tempSCData.detailPageName = "ec| services overview| raf code redeem success";
                updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONSUCESS', value: true })

            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'referFrinedValidation', "TRANSACTION FAILED", PAGEACTIVITY.UA));
                tempSCData.pageName = "urc landing page";
                tempSCData.detailPageName = "ec| services overview| raf code redeem error";
                updateSCcustomEvent("rafRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONFAILURE', value: true })
            }
            dispatch({ type: 'REFERAFRIENDBACKENDCALSTART', value: false });
        })
            .catch(error => {
                dispatch({ type: 'REFERAFRIENDCOUPONVALIDATIONRESULT', value: "couponValidation failures" })
                let errorMsg = `MethodName:referFrinedValidation,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({
                    type: 'REFERAFRIENDBACKENDCALSTART', value: false
                }
                );
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'referFrinedValidation', ex);
    }
}

export const updateCartChatOffer = (visitId, equipments, promodetails, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "Inside updateCartChatOffer"));
        logKafka("INFO", "BuildProduct", "Inside updateCartChatOffer", kafkaPageLogs, "applogs", visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });
        let url = apiUrl().productOffersUrl;
        let productpromo = '';
        let specialOfferpromo = '';
        let contractPromo = '';

        // let bsOfferId = 'OF10038167';
        //let bsPromoId = 'PR10006366';
        //PR10006365-OF10038167|PR10006366-OF10038167 
        if (promodetails === "PR10006366-OF10038167")
            promodetails = "PR10006365-OF10038167|PR10006366-OF10038167";
        let promoArray = promodetails.split("|");
        //promoArray.forEach(PromoItem => { 
        //let bsOfferId = PromoItem.split("-")[0];
        //let bsPromoId = PromoItem.split("-")[1];

        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "productOffersUrl - Success"));
                logKafka("INFO", "BuildProduct", "productOffersUrl - Success", kafkaPageLogs, "applogs", visitId);
                response.data.service.forEach(s => {
                    if (s.type === "Promo") {
                        s.packages.forEach(pack => {
                            pack.products.forEach(prod => {
                                prod.specialOffer.forEach(spoffer => {
                                    promoArray.forEach(PromoItem => {
                                        let bsPromoId = PromoItem.split("-")[0];
                                        let bsOfferId = PromoItem.split("-")[1];
                                        if (spoffer.bsPromoId === bsPromoId && spoffer.bsOfferId === bsOfferId) {
                                            specialOfferpromo = spoffer;
                                            productpromo = prod;
                                            contractPromo = pack.contract;
                                        }
                                    })
                                })
                            })
                        })
                    }
                })
                dispatch({
                    type: 'LOADER_ACTIVE',
                    value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
                });
                //based on response we will find the promoidofferid Find the details 
                if (InHomeUtils.isNotEmpty(productpromo)) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "update Cart - Starts"));
                    logKafka("INFO", "BuildProduct", "update Cart - Starts", kafkaPageLogs, "applogs", visitId);
                    let url = apiUrl().updateCartAcc + '/' + visitId;
                    //(product, contract,specialOffer)
                    api(url, 'POST', getRequestChatoffer(productpromo, specialOfferpromo, contractPromo)).then(response => {
                        if (response.meta.code === 200) {
                            logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOffer', "update Cart - Success"));
                            logKafka("INFO", "BuildProduct", "update Cart - Success", kafkaPageLogs, "applogs", visitId);
                            if (specialOfferpromo.BsOfferAttr === "EQUIPMENT") {
                                //based on response we will find the promoidofferid Find the details 
                                let product = equipments.filter(p => p.id === specialOfferpromo.Target);
                                dispatch({ type: 'RECORDING_SELECTEDPROD', value: product[0] });
                            }
                            dispatch({
                                type: "UPDATE_CART",
                                value: {
                                    cartResponse: response.data.cartTierPricing,
                                    cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                                    cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                                    cartOrderDetail: response.data.orderDetail
                                }
                            });
                        }
                        else {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartChatOffer', "UPDATECARTCHATOFFER - FAIL", PAGEACTIVITY.UA));
                            logKafka("ERROR", "BuildProduct", "UPDATECARTCHATOFFER - FAIL", getErrorLogUrl, "applogs", visitId);
                        }
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    })
                        .catch(error => {
                            let errorMsg = `MethodName:updateCartChatOffer-cartUpdate,errorMessage:${error.message}`;
                            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        });
                }

            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCartChatOffer-products,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        //})
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartChatOffer', ex);
    }
}

export const updateCartSpecialOffer = (visitId, specialOfferpromo, contract, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartSpecialOffer', "Inside updateCartSpecialOffer"));
        logKafka("ERROR", "BuildProduct", "Inside updateCartSpecialOffer", getErrorLogUrl, "applogs", visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });

        if (InHomeUtils.isNotEmpty(specialOfferpromo)) {
            let url = apiUrl().updateCartAcc + '/' + visitId;
            //(product, contract,specialOffer)
            api(url, 'POST', getRequestSpecialoffer(specialOfferpromo, contract)).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartSpecialOffer', "update Cart - Success"));
                    logKafka("ERROR", "BuildProduct", "update Cart - Success", getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: specialOfferpromo });

                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail
                        }
                    });
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartSpecialOffer', "UPDATECARTSPECIALOFFER - FAIL", PAGEACTIVITY.UA));
                    logKafka("ERROR", "BuildProduct", "UPDATECARTSPECIALOFFER - FAIL", getErrorLogUrl, "applogs", visitId);
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
                .catch(error => {
                    let errorMsg = `MethodName:updateCartSpecialOffer-cartUpdate,errorMessage:${error.message}`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
        }
        else {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        //})
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartSpecialOffer', ex);
    }finally{
        dispatch({ type: 'SPLOFFER_ACCORDION_CLOSE', value: false });
    }
}


const getCouponMultiuseRequest = () => {
    let request = {
        key: "REFRESHCART",
        value: "COUPON",
        action: "add"
    }
    return JSON.stringify(request)
}

export const updateCouponMultiuse = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId) => {
    try {
        /* dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding to cart", isLoaderImg: "loader" }
        }); */
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "Inside updateCouponMultiuse"));
        logKafka("ERROR", "BuildProduct", "Inside updateCouponMultiuse", getErrorLogUrl, "applogs", visitId);
        let url = apiUrl().updateintentcartAccEc + '/' + visitId;
        let request = getCouponMultiuseRequest();
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCouponMultiuse', "update Cart - Success"));
                logKafka("ERROR", "BuildProduct", "update Cart - Success", getErrorLogUrl, "applogs", visitId);
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
                let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                let addlInfo = {
                    zip: zip,
                    state: '',
                    tarCode: tarCode,
                    masterpackageview: masterpackageview,
                    selectedProductId: selectedProdId,
                    couponFlowType: '',
                    EquipmentState: null,
                    isAlaCarte: false
                };
                doPrefetch('', dispatch, visitId, addlInfo, contract, selectedCoreServices, true, '', '', '', false, servicesInCart);
                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCouponMultiuse', "UPDATECOUPONMULTIUSE - FAIL", PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", "update Cart - Fail", getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCouponMultiuse,errorMessage:${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCouponMultiuse', ex);
    }
}

//"UpdatePromationFromChatNC('DNRD-9594-9431')" 
export const updateCartChatOfferCoupon = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId, promodetails) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOfferCoupon', "Inside updateCartChatOfferCoupon"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding Promotions", isLoaderImg: "loader" }
        });
        let url = apiUrl().refreshPromotionsUrl
        api(url, 'POST', getRequestMultiUseoffer(promodetails)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCartChatOfferCoupon', "refres Promos - Success"));
                updateCouponMultiuse(visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCartChatOfferCoupon', "refresh Promos - Fail", PAGEACTIVITY.UA));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCartChatOfferCoupon,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCartChatOfferCoupon', ex);
    }
}

export const updateIntentForNewCeapps = (req,visitId,dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "Inside updateContract"));
        logKafka("INFO", "BuildProduct", "Inside updateContract", kafkaPageLogs, "applogs", visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding to cart", isLoaderImg: "loader" }
        });
        dispatch({
            type: 'SET_CART_DIRTY',
            value: true
        });
        let url = apiUrl().updateintentcartAccEc + '/' + visitId;
        let request = req
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "update cart - success"));
                logKafka("INFO", "BuildProduct", "update cart - success", kafkaPageLogs, "applogs", visitId);
                //Process response and do prefetch
                
                let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                // getSpecialOffers(visitId, contract, dispatch);
                fetchOfferInCart(visitId, cartProducts, dispatch);
                // let addlInfo = {
                //     zip: zip,
                //     state: '',
                //     tarCode: tarCode,
                //     masterpackageview: masterpackageview,
                //     selectedProductId: selectedProdId,
                //     couponFlowType: '',
                //     EquipmentState: null,
                //     isAlaCarte: false
                // };
                // doPrefetch('', dispatch, visitId, addlInfo, contract, selectedCoreServices, true, '', '', '', true, servicesInCart);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if(JSON.parse(request).value == "optin" && JSON.parse(request).action == "add"){
                    dispatch({ type: 'TOGGLE_TV_SETTOPBOX_ACCOR', value: null })
                }

                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
                
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateContract', "UPDATECONTRACT - Fail", PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", "UPDATECONTRACT - Fail", getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateContract,errorMessage:${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateContract', ex);
    }
}

export const updateContract = (visitId, contract, dispatch, zip, tarCode, selectedCoreServices, masterpackageview, selectedProdId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "Inside updateContract"));
        logKafka("INFO", "BuildProduct", "Inside updateContract", kafkaPageLogs, "applogs", visitId);
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Adding to cart", isLoaderImg: "loader" }
        });
        dispatch({
            type: 'SET_CART_DIRTY',
            value: true
        });
        let url = apiUrl().updateintentcartAccEc + '/' + visitId;
        let request = getContractRequest(contract);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateContract', "update cart - success"));
                logKafka("INFO", "BuildProduct", "update cart - success", kafkaPageLogs, "applogs", visitId);
                //Process response and do prefetch
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail
                    }
                });
                let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                getSpecialOffers(visitId, contract, dispatch);
                fetchOfferInCart(visitId, cartProducts, dispatch);
                let addlInfo = {
                    zip: zip,
                    state: '',
                    tarCode: tarCode,
                    masterpackageview: masterpackageview,
                    selectedProductId: selectedProdId,
                    couponFlowType: '',
                    EquipmentState: null,
                    isAlaCarte: false
                };
                doPrefetch('', dispatch, visitId, addlInfo, contract, selectedCoreServices, true, '', '', '', true, servicesInCart);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateContract', "UPDATECONTRACT - Fail", PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", "UPDATECONTRACT - Fail", getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateContract,errorMessage:${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateContract', ex);
    }
}

export const getSpecialOffers = (visitId, contract, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Inside getSpecialOffers"));
        logKafka("INFO", "BuildProduct", "Inside getSpecialOffers", kafkaPageLogs, "applogs", visitId);
        // dispatch({
        //     type: 'LOADER_ACTIVE',
        //     value: { isLoaderActive: true, isLoaderText: "Fetching Promotions", isLoaderImg: "loader" }
        // });
        let url = apiUrl().getProductEc + '/sploffers';
        api(url, 'POST', getRequest(visitId, contract, "")).then(response => {
            if(store.getState().buildProduct?.showMockChoiceOffersEC) {
                response=splOffersAPIRes
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && (InHomeUtils.isNotNull(response.data.offersMTM) || InHomeUtils.isNotNull(response.data.offer2YR))) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getSpecialOffers', "Special Offers Found"));
                logKafka("INFO", "BuildProduct", "Special Offers Found", kafkaPageLogs, "applogs", visitId);
                processOfferSection(response.data)
                let specialDataMTMOffers = InHomeUtils.isNotNull(response.data.offersMTM) ? response.data.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null
                let specialData2YROffers = InHomeUtils.isNotNull(response.data.offer2YR) ? response.data.offer2YR.filter((offer, index) => getOffersFilter(offer, Service.data, index)) : null
                let dataOfferCount = specialDataMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.data)).length;

                let specialTVMTMOffers = InHomeUtils.isNotNull(response.data.offersMTM) ? response.data.offersMTM.filter((offer, index) => getOffersFilter(offer, Service.video, index)) : null
                let specialTV2YROffers = InHomeUtils.isNotNull(response.data.offer2YR) ? response.data.offer2YR.filter(offer => getOffersFilter(offer, Service.video)) : null
                let tvOfferCount = specialTVMTMOffers.filter(offer => (offer.offerFor.toUpperCase() === Service.video)).length;

                let classicMTMOffers = null;
                if (specialTVMTMOffers && specialTVMTMOffers) {
                    classicMTMOffers = [...specialDataMTMOffers, ...specialTVMTMOffers].filter(o => o);
                }
                else {
                    classicMTMOffers = specialDataMTMOffers || specialTVMTMOffers;
                }
                let classic2YROffers = null;
                if (specialData2YROffers && specialTV2YROffers) {
                    classic2YROffers = [...specialData2YROffers, ...specialTV2YROffers].filter(o => o);
                }
                else {
                    classic2YROffers = specialData2YROffers || specialTV2YROffers;
                }
                dispatch({ type: 'FETCH_SPLOFFER', value: { offersMTM: classicMTMOffers, offer2YR: classic2YROffers, isDataOffer: dataOfferCount > 1, isTVOffer: tvOfferCount > 1, dataOffersMTM: specialDataMTMOffers, tvOffersMTM: specialTVMTMOffers } })
                dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: null });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getSpecialOffers', "SPECIALOFFERS " + PAGEACTIVITY.MSG.productNotFound, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "SPECIALOFFERS " + PAGEACTIVITY.MSG.productNotFound, kafkaPageLogs, "applogs", visitId);
                dispatch({ type: 'FETCH_SPLOFFER', value: null })
            }
            //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:getSpecialOffers,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getSpecialOffers', ex);
    }finally{
        setTimeout(()=>{
            dispatch({ type: 'SPLOFFER_ACCORDION_CLOSE', value: true });
        },4000)
    }
}

export const fetchStreamingServices = (visitId, dispatch) => {
    try {
        logKafka("INFO", "BuildProduct", "Fetch Streaming Services", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        // loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, "OTT")).then(response => {
            // loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {

                let streamingServices = response.data.products.filter(p => p.prodType != "OTTEQUIPNRC");
                streamingServices.forEach(x => x.prodType = 'OTTBASIC');

                dispatch({ type: 'FETCH_STREAMSERV', value: streamingServices })

                let streamDev = response.data.products.filter(p => p.prodType === "OTTEQUIPNRC");
                if (InHomeUtils.isNotNull(streamDev) && streamDev.length > 0) {
                    dispatch({ type: 'FETCH_STREAMDEV', value: response.data.products.filter(p => p.prodType === "OTTEQUIPNRC") })
                }

                if (response.data.products && response.data.products.length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { OTT: true } });
                }

                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    dispatch({ type: 'ONPROFILESTATUS', value: { streaming: true } });
                    if (productOnProfile.filter(v => v.prodTypeValue === 'YOUTUBE').length > 0) {
                        dispatch({ type: 'IS_YOUTUBE_ONCSR', value: true });
                    }
                    if (productOnProfile.filter(v => v.prodTypeValue.toLowerCase().indexOf('sling') > -1).length > 0) {
                        dispatch({ type: 'IS_SLING_ONCSR', value: true });
                    }

                }
                //dispatch({ type: 'SET_DEFAULT_ACCORDION', value: '' });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchStreamingServices,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchStreamingServices', ex);
    }
}

export const updateIntlCallingPlan = (visitId, dispatch, callingPlan) => {
    try {
        let url = apiUrl().updateintentcartAcc + '/' + visitId;
        let request = getIntlCallingRequest(callingPlan.pricingPlanCode);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {                
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent,visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent,visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                tempSCData.pageName = "urc landing page";
                tempSCData.detailPageName = "ec| services overview| phone| add international calling";
                updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName");
            }
            else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.CART,'CART Intent Error',PAGEACTIVITY.UA));
            } 
        })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:updateInstallation,errorMessage:${error.message}`;
                vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct',visitId,'updateInstallation',ex);
    }
}

const getIntlCallingRequest = (planCodeType) => {
    let request = {
        key: "pricingPlanCode",
        value: planCodeType,
        action: "add"
    }
    return JSON.stringify(request)
}

export const setIntlCallingProductForSCFlow = (cart, visitId, buildProductState, dispatch ) => {
    try {
        let cartProducts = getCartProducts(cart, visitId);
        if (InHomeUtils.isNotNull(cartProducts) && InHomeUtils.isNotNull(cartProducts.VoiceProduct) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd) && cartProducts.VoiceProduct.voiceProd.length > 0 && 
            InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0]) && InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0].prodType) && cartProducts.VoiceProduct.voiceProd[0].prodType === 'FVPRIMARY' && 
            InHomeUtils.isNotNull(cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode) && InHomeUtils.isNotEmpty(cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode)) {
            let productInfo = InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.intlCalling) && InHomeUtils.isNotNull(buildProductState.intlCalling.intlCallingProducts) && buildProductState.intlCalling.intlCallingProducts.length > 0 && buildProductState.intlCalling.intlCallingProducts.filter(p => p.pricingPlanCode === cartProducts.VoiceProduct.voiceProd[0].pricingPlanCode);
            if (InHomeUtils.isNotNull(productInfo) && productInfo.length > 0) {
                let intlCallingProduct = {
                    countryName: productInfo[0].countryName,
                    pricingPlanCode: productInfo[0].pricingPlanCode,
                    usageCap: productInfo[0].usageCap
                }
                dispatch({ type: 'INTERNATIONALCHANNELPLAN_SELECTEDPROD', value: intlCallingProduct });               
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setIntlCallingProductForSCFlow', ex);
    }
}

export const updateSelectedproducts = (dispatch) =>{
    dispatch({type :"UPDATE_SELECTED_TECHSECURE"});
}
export const redirectToCheckout = (visitId,dispatch) =>{
    checkoutAction.doValidateCart(visitId,dispatch);
    buildProductAction.updateCheckoutBtnStatus(true, dispatch);
    let autoPayinCart = buildProductAction.isAutoPayInCart(store.getState().app.visitId, store.getState().cart);
    buildProductAction.autoPayinCart(autoPayinCart ? true : false, dispatch);
    //redirectTo(Pages.Checkout,dispatch);
}
export const updateCart = (visitId, signInState, product, prodType, isChecked, dispatch, voiceTn, firstBill,
    addonProduct, contract, selectedCoreServices, isLocalTVInCart = false,
    isDCTinCart = false, upsellInfo, buildProductState ,equipmentState = null, lqState,flowType = "", isOptOut = false, profileCart, defaultProductadded = false, triggeredFromCta = false) => {
  if(product?.prodType === 'VHSBILLER'){
    if(product?.name === 'Home Security'){
        dispatch({type: 'HOME_SECURITY',
            value: true
        })
    }else if(product?.name === 'Home Security Plus'){
        dispatch({type: 'HOME_SECURITY_PLUS',
            value: true
        })
    }
    dispatch({ type: 'HOME_SECURITY_REMOVED', value: false });

    prodType="TECHSURE";
  }
  if(product?.prodType === 'DHSBILLER'){
    dispatch({ type: 'DSH_REMOVED', value: false });
    prodType="TECHSURE";
  }
  if(product?.prodType !== 'fneDeviceCount'){
    dispatch({ type: 'AP_BUY_COUNT', value: 0 })
  }
        try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Updating your cart", isLoaderImg: "loader" }
        });

        if (buildProductState?.requiredErrBanner) {
            dispatch({type : 'SHOW_REQUIRED_ERR_BANNER', value : false})
        }
        
        let sevicesType = prodType;
        let isFCPflow = false;
        let isCartAdded= true;
        let VecContractServices=InHomeUtils.isNotEmpty(signInState)&&InHomeUtils.isNotEmpty(signInState.response)&&InHomeUtils.isNotEmpty(signInState.response.hoaServiceType)?signInState.response.hoaServiceType:"";
        let addlInfo = {
            isDoFlow: false,
            zip: signInState.response.zipCode,
            tarCode: signInState.response.tarCode,
            state: signInState.response.state,
            couponFlowType: false,
            EquipmentState: equipmentState,
            masterpackageview: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.masterpackageview) ? buildProductState.tv.masterpackageview : [],
            selectedProductId: '',
            isFCPflow: signInState.response.userProfile.isFcpInProfile,
            isAlaCarte: product.isAlaCarte,
            enableMixmatch2: (signInState && signInState.response && (signInState.response.classicToFcp || signInState.response.userProfile.isFcpInProfile)) ? true: false,
            enableConnectedTv: ((lqState && lqState.runtimeKey && lqState.runtimeKey.enableECceapps && lqState.runtimeKey.enableECceapps.toUpperCase() === 'Y' && (signInState && signInState.response && (signInState.response.classicToFcp || signInState.response.userProfile.isFcpInProfile))) ? true : false)
        }
        let isHoaFlow = (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.hoaFlowDetails) && InHomeUtils.isNotNull(lqState.hoaFlowDetails.isHoaFlow))? lqState.hoaFlowDetails.isHoaFlow : false;
        let isVecFlow = InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.ecLQResponse) && (lqState.ecLQResponse.hoaFlag === "V")?true:false
        let isInternetOnProfile = false;
        let isFiosTvOneSelected = false;
        let onProfileSetUpBox = '';
        let profileStbCount = 0;
        let profileRouter = '';
        isFCPflow = signInState.response.userProfile.isFcpInProfile;
        if (InHomeUtils.isNull(upsellInfo)) {
            upsellInfo = { isUpsell: false }
        }
        isInternetOnProfile = InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.internet) && InHomeUtils.isNotNull(buildProductState.internet.m2mPlans) ? buildProductState.internet.m2mPlans.filter(v => v.isprdOnProfile === true).length > 0 : false;
        onProfileSetUpBox = InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.vRoom) && InHomeUtils.isNotNull(buildProductState.vRoom.equipments) ? buildProductState.vRoom.equipments.filter(v => v.isprdOnProfile === true) : null;
        profileRouter = InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.router) && InHomeUtils.isNotNull(buildProductState.router.equipments) ? buildProductState.router.equipments.filter(v => v.isprdOnProfile === true) : null;
        if (onProfileSetUpBox && onProfileSetUpBox.length > 0) {
            profileStbCount = onProfileSetUpBox && onProfileSetUpBox[0].unitCount ? parseInt(onProfileSetUpBox[0].unitCount) : 0;
        }
        isFiosTvOneSelected = InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && buildProductState.tv.FiosTvOneSelected ? buildProductState.tv.FiosTvOneSelected : false;
        let isSubSectionsValid = false;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "Inside updateCart"));
        logKafka("INFO", "BuildProduct", "Inside updateCart", kafkaPageLogs, "applogs", visitId);
        if (upsellInfo.isUpsell) {
            modalAction.closeModalWindow("UPSELL", dispatch);
        }
        const nrTimeData = getNRCurrentTime('BuildProducts:UpdateCart', dispatch);
        window.nrTimeState = nrTimeData;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Updating your cart", isLoaderImg: "loader" }
        });
        dispatch({
            type: 'SET_CART_DIRTY',
            value: true
        });
        // calling router api to fetch for udated router list on FIOS Tv equipment upgrade
        if(lqState?.runtimeKey?.enableZeroRatedRouterFetch === 'Y' && (product.id  === "VMS1100" || product.prodType === "fiosTvOne") && buildProductState?.router?.upgradeRouter && buildProductState?.router?.upgradeRouter !== "Upgraded" && !signInState?.response?.classicToFcp && profileCart.legacyTVInProfile) {
            fetchRouter(dispatch, visitId, 0, true);
            dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
        }
        if (prodType === Service.winBack || product.id === 'CUST') {
            if (!isChecked) {
                scClickEventProduct(product, prodType);
                if (product.id === Service.winBackNo) {
                    tempSCData.pageName = "urc landing page";
                    tempSCData.detailPageName = "ec| services overview| phone| add your existing phone number";
                    updateSCcustomEvent("cartAddService", "ddAddToCartEvent", "detailPageName,pageName")
                }
            }
            dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        else {
            if (!isChecked && product.prodTypeValue !== "CUSTOMER_PROVIDED_ROUTER" && product.prodTypeValue !== "VROOM_HD_SD") {
               if(triggeredFromCta === false){ // VCGBQA-1499 - changes
                 scClickEventProduct(product, prodType);
               }
                if (prodType === Service.router) {
                    customRouterCheck(true, dispatch);
                }
            }else{
                if(product?.name?.includes('Alarm') && product?.prodType === "VHSBILLER" ){
                   if(product.qty > 1){
                    scClickEventProduct(product, prodType);
                   }else{
                    scUnselectEventProduct(product, prodType);
                   }

                }else{
                    scUnselectEventProduct(product, prodType);
                }
                if(product.prodType !== "DUMMYVROOM"){
                    if(isChecked){
                        updatecartEvent("RemovefromCart",product.name,"", product);
                    }
                    else{
                        addProductCurrent(product,true);
                        let detailName = prodType=== Service.internet && !buildProductState?.isClassicAccount ? "" : product.name
                        updatecartEvent("AddtoCart", detailName,"", product);
                    }
                }
                isCartAdded=false;
            }
            let url = "";
            let request = "";
            let utdClearCart = false;
            let fiosFiveChannelsSelected = (product.fiosFiveSelectedChannels != undefined) ? true : false;
            let tvDisconnect = false;
            let voiceDisconnect = false;
            let internetDisconnect = false;
            //tv disconnect prod on profile
            if (prodType === Service.tv && (product.isprdOnProfile || product.prodTypeValue === 'DONTWANTTV') && !buildProductState.tv.disconnected && (!fiosFiveChannelsSelected || product.prodTypeValue === 'DONTWANTTV') && buildProductState.tv.selectedProduct===null) {
                url = apiUrl().clearCart + '/' + visitId;
                let refNumber = (InHomeUtils.isNotNull(product.refNumber)) ? product.refNumber : '';
                request = getClearCartRequest(prodType, selectedCoreServices, ((prodType === Service.tv) && product.isprdOnProfile || product.prodTypeValue === 'DONTWANTTV'? "Y" : "N"), refNumber, dispatch);
                if (prodType === Service.tv && (product.isprdOnProfile || product.prodTypeValue === 'DONTWANTTV')) {
                    dispatch({ type: 'UPDATEDISCONNECTTV', value: true })
                    tvDisconnect = true;
                }
            }
            else if((prodType === Service.internet || prodType === Service.mm3) && product.isprdOnProfile && !buildProductState.internet.disconnected && signInState.response?.flowRoute == 'FULLDISCONNECT'){
                url = apiUrl().clearCart + '/' + visitId;
                let referenceNumber = (InHomeUtils.isNotNull(product.refNumber)) ? product.refNumber : '';
                request = getClearCartRequest(prodType, selectedCoreServices, ((prodType === Service.internet || prodType === Service.mm3) && product.isprdOnProfile ? "Y" : "N"), referenceNumber, dispatch);
                if ((prodType === Service.internet || prodType === Service.mm3) && !product.isprdRemoved) {
                    dispatch({ type: 'UPDATEDISCONNECTINTERNET', value: true })
                    internetDisconnect = true;
                }                        
            }
            else if (prodType === Service.fiosTvOne && isChecked) {
                url = apiUrl().clearCart + '/' + visitId;
                let referenceNumber = (InHomeUtils.isNotNull(product.refNumber)) ? product.refNumber : '';
                request = getClearCartRequest(prodType, '', "N", referenceNumber, dispatch);
            }
            else if(prodType === Service.additionalChannel) {
                prodType = Service.channel;
                let productId = '', productType = '';
                url = apiUrl().updateCartAcc + '/' + visitId;
                product.forEach(item => {
                    let id = InHomeUtils.isNotNull(item.prodId) ? item.prodId: item.id;
                    if(productId !== '') {
                        productId = productId + ',' + id + ':add'
                    } else {
                        productId = id + ':add'
                    }
                    if(productType !== '') {
                        productType = productType + ',' + item.prodType
                    } else {
                        productType = item.prodType;
                    }
                });
                request = JSON.stringify({
                    contract: contract,
                    productId: productId,
                    productType: productType,
                    quantity: '1',
                    serviceType: 'VIDEO',
                    status: "add"
                });
            }
            else if ((prodType === Service.internet || (prodType === Service.tv && !fiosFiveChannelsSelected) || prodType === Service.voice) && isChecked) {
                if (selectedCoreServices === 'FIOS_VOICE') {
                    selectedCoreServices = '';
                }
                else if ((InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && buildProductState.tv.selectedProduct.prodTypeValue === 'ULTIMATETESTDRIVE' && prodType !== Service.tv && selectedCoreServices.indexOf(Service.video) > -1 && selectedCoreServices.split(",").length === 2)) {
                    selectedCoreServices = '';
                    utdClearCart = true;
                }
                else if (selectedCoreServices.split(",").length === 2 && selectedCoreServices.indexOf(Service.voice) > -1 && prodType !== Service.voice) {
                    selectedCoreServices = '';
                }
                url = apiUrl().clearCart + '/' + visitId;
                let refNumber = (InHomeUtils.isNotNull(product.refNumber)) ? product.refNumber : '';
                let isClassicFlow = (InHomeUtils.isNotEmpty(signInState) && InHomeUtils.isNotEmpty(signInState.response) && !(signInState.response.userProfile && signInState.response.userProfile.isFcpInProfile) && !signInState.response.classicToFcp) ? true : false;
                let disconnectPayloadFlag = product?.isprdOnProfile;
                request = getClearCartRequest(prodType, selectedCoreServices, (((prodType === Service.tv || prodType === Service.voice || prodType === Service.video ) && disconnectPayloadFlag) ? "Y" : "N"), refNumber, dispatch);
                if (prodType === Service.tv && disconnectPayloadFlag) {
                    dispatch({ type: 'UPDATEDISCONNECTTV', value: true });
                    tvDisconnect = true
                }
                else if (prodType === Service.voice && product.isprdOnProfile){
                    dispatch({ type: 'UPDATEDISCONNECTVOICE', value: true });
                    voiceDisconnect = true;
                }
            }
            else {
                url = apiUrl().updateCartAcc + '/' + visitId;
                let reqcontract = (contract === ContractConstants.twoYear) ? ContractConstants.twoYearInWords : ContractConstants.monthToMonth;
                let pegaBundle = null
                if(typeof(flowType)!='boolean' && (flowType === "MandMSelectTV" || flowType === "MandMTV&Voice")){
                    pegaBundle = addonProduct
                }
                if(typeof(flowType)!='boolean' && (flowType === "MandMSelect" || flowType === "MandMBundle" || flowType.indexOf("MandMCustom") > -1)){
                request= {
                        productId:"",
                        productType:sevicesType,
                        serviceType:"ALL",
                        quantity:"1",
                        recomType:product.recommendedType,
                        contract:product.pegaMTMContract,
                        status:"add",
                        bundleId:product.bundleType,
                        offerCombinationId:product.offerId,
                        bundleKey:product.key,
                        selectedPropositionId:product.propositionId
                        }
                request = JSON.stringify(request);
                }else{
                request = ((InHomeUtils.isNotNull(product.bundleId) && prodType != Service.techSure && prodType != Service.cloud)) ? getBundleRequest(reqcontract, product, prodType, isChecked, voiceTn, selectedCoreServices, isLocalTVInCart, isFCPflow, isOptOut ,isFiosTvOneSelected, isVecFlow, VecContractServices, pegaBundle) : getStdRequest(reqcontract, product, prodType, isChecked, selectedCoreServices, voiceTn, null, isInternetOnProfile, isFiosTvOneSelected,isVecFlow, VecContractServices);
                }
                if (prodType === Service.internet || prodType === Service.mm3){
                    dispatch({ type: 'UPDATEDISCONNECTINTERNET', value: false })
                    internetDisconnect = false;
                }
                if (prodType === Service.tv) {
                    dispatch({ type: 'UPDATEDISCONNECTTV', value: false });
                    tvDisconnect = false;
                }
                if (prodType === Service.voice) {
                    dispatch({ type: 'UPDATEDISCONNECTVOICE', value: false });
                    voiceDisconnect = false;
                }
            }
            
            if(isHoaFlow && (tvDisconnect || voiceDisconnect)) {
                return;
            }

            console.log(product,'get the product details',url,request)
            return new Promise((resolve, reject) => {
            api(url, 'POST', request).then(response => {

                console.log("request**", request)
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    if (InHomeUtils.isNotNull(response.data)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                        && response.data.cartTierPricing.tierContent.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, kafkaPageLogs, "applogs", visitId);

                        try {
                            if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections)
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections)
                                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection)
                                && response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.length > 0) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                                logKafka("INFO", "BuildProduct", "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, getErrorLogUrl, "applogs", visitId);
                                isSubSectionsValid = true;
                            }else{
                                    updateSelectedproducts(dispatch);
                            }
                            resolve(true);
                        
                        }
                        catch (ex) {
                            catchJSException(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', ex);
                        }
                    }
                    else {
                        updateSelectedproducts(dispatch);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART TIER CONTENT EMPTY", kafkaPageLogs, "applogs", visitId);
                    }

                    if(InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.productOnProfileStatus) && 
                       InHomeUtils.isNotNull(buildProductState.productOnProfileStatus.voice) && !buildProductState.productOnProfileStatus.voice && 
                       prodType === Service.voice ) {
                            console.log("buildProduct: loadTN buildproducts:voice");
                            loadTN(visitId, dispatch, isVecFlow);
                    }

                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                            cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                        }
                    });

                    let checkForRemovedServices = response?.data?.cartTierPricing?.tierContent[0]?.sections?.section?.find(sec => sec.sectionName === 'Removed Services');
                    let vasremovedProducts = checkForRemovedServices?.subSections?.subSection?.find(sec => sec.sectionType === 'VASSTANDALONE');
                    let isHomeSecurityAdded = vasremovedProducts?.products?.find((prod) => (prod?.prodId === "R3900" || prod?.prodId === "R3901"));
                    let isDHSrityAdded = vasremovedProducts?.products?.find((prod) => (prod?.prodId === "R4466" || prod?.prodId === "R4467" || prod?.prodId === "R4468"));

                    //let isHomeSecurityPlusAdded = vasremovedProducts?.products?.find((prod) => prod?.prodId === "R3901");
                    if(isHomeSecurityAdded){
                        dispatch({ type: 'HOME_SECURITY_REMOVED', value: true });

                    }

                    if(isDHSrityAdded){
                        dispatch({ type: 'DSH_REMOVED', value: true });

                    }

                    /* Disney perk promo changes -- planned during Oct 7th, 2024 to Nov 6th, 2024
                    For disney perk promo changes
                    */
                    if(prodType === Service.internet && response?.data?.cartTierPricing?.tierContent?.length > 0) {
                        const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                        const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers');
                            let disneyPromoEligible = false;
                            let netmaxEligible  = false;
                            offers?.promos?.forEach(promo => {
                                if(promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_MARKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT' || promo?.offerAttrValue === "DISNEY_BUNDLE_PERK_TRACKER") {
                                    disneyPromoEligible = true;
                                }
                                if(promo?.offerAttrValue ==='NETMAX_PERK_DISCOUNT' || promo?.offerAttrValue ==='NETMAX_PERK_MARKER'){
                                    netmaxEligible  = true;  
                                }
                            });
                            console.log('DISNEY_PROMO_PRESENT', disneyPromoEligible)
                        dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                        dispatch({ type: 'NETMAX_PROMO_PRESENT', value: netmaxEligible }); //  flag netmax marker check
                        // Checks special offers in cart and removes selected special offer if update cart does not have the special offer
                        const specialOffers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === CartServices.specialoffer);
                        const hasCartOffer = specialOffers?.promos?.some(promo =>
                            (promo?.id && (buildProductState?.sploffer?.selectedProduct?.id === promo?.id || buildProductState?.sploffer?.selectedProduct?.promoId !== promo?.id))
                            || (promo?.promoId && (buildProductState?.sploffer?.selectedProduct?.id === promo?.promoId || buildProductState?.sploffer?.selectedProduct?.promoId === promo?.promoId))
                        );
                        if (!hasCartOffer) {
                            if (prodType === Service.internet) {
                                dispatch({ type: 'SPLOFFER_SELECTEDPRODID_DATA', value: null });
                            } else if (prodType === Service.tv) {
                                dispatch({ type: 'SPLOFFER_SELECTEDPRODID_TV', value: null });
                            }
                            dispatch({ type: 'SPLOFFER_SELECTEDPRODID', value: null });
                        }
                    }
                    
                    if(prodType == Service.router){
                        fetchFne(dispatch, visitId);
                    }
                    let isPegaFlow = store.getState().pega.isPegaFlow
                    if(prodType == "MM3" || (prodType == "FTTPD" && isPegaFlow)){

                        let cartProducts1 = getCartProducts(response.data.cartTierPricing, visitId);
                        let dataPerkProduct = cartProducts1 && cartProducts1.DataProduct && cartProducts1.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE' || prod.prodTypeValue === 'STREAMING' || prod.prodTypeValue === 'GAMING' || prod.prodTypeValue === 'COMPLETE');
                        if ( InHomeUtils.isNotNull(dataPerkProduct) && dataPerkProduct !== undefined && dataPerkProduct) {     
                            let isPega = false     
                            if(typeof(flowType)!='boolean' && (flowType === "MandMTV&Voice" || flowType === "MandMSelect" || flowType === "MandMBundle" || flowType === "MandMSelectTV" || flowType.indexOf("MandMCustom") > -1)){
                                isPega = true
                            }                      
                            setDataPerksForSC_ECFlows(response.data.cartTierPricing,buildProductState,flowType, visitId, dispatch, isPega)
                        } 
                    } 
                    if((prodType === Service.internet || prodType === Service.data || prodType === Service.mm3) && product && product.downSpeed !== "2048M")                    {
                        dispatch({type : 'DISABLE_TV_VOICE',value : false})
                    }
                    if((prodType === Service.internet || prodType === Service.data) && product && product.planPerks)
                    {
                        dispatch({type : 'FETCH_DATASUBPROD',value : product.planPerks})
                    }
                    else if(prodType  === "MM3")
                    {
                        console.log('DEBUG: updateCart MM3 prodType', prodType, product);
                        dispatch({type:"MM3_SELECTEDPROD",value : product})
                        if(buildProductState?.isMNEnabled){
                            dispatch({type: "INTERNET_SELECTEDPROD", value: product})}
                    }
                    let classicTvInProfile =  profileCart?.classicTvInProfile;
                    let profileSpeedCode = profileCart?.profileSpeedCode;
                    let selectedSpeedCode = product?.speedCode;
                    if(((classicTvInProfile || !classicTvInProfile) && profileSpeedCode && selectedSpeedCode )||isPegaFlow){
                        getFiosTvOneQualification(dispatch, visitId,false);
                    }
                    if(prodType == 'fiosTvOne'){
                        fetchVRoom(dispatch, visitId);
                    }
                   
                    if(lqState && lqState.runtimeKey.iscrpenable==='Y' && flowType !== 'MandMSelect' && flowType !== 'MandMSelectTV' && flowType !== 'MandMCustom' && flowType !== 'MandMTV&Voice' && flowType !== "MandMBundle"){
                        sweetnerAction(product, buildProductState,isChecked,tvDisconnect,dispatch)
                        // checkNewProductAddedOrNot(dispatch)
                    }
                    dispatch({
                        type: 'IS_CART_SENT_TO_DTM',
                        value: false
                    });
                    DispatchSelectedCoreService(response.data.orderDetail, dispatch)
                    let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                    let cartData = response.data.cartTierPricing && response.data.cartTierPricing.tierContent && getCartData(response.data.cartTierPricing.tierContent, visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }) //No need to wait loader for backend work process prefetch call so close loader here...
                    let isWholeHomeWifiOnProfile = buildProductState && buildProductState.router && buildProductState.router.equipments && buildProductState.router.equipments.filter(each => each.isprdOnProfile && (each.id === 'R0640'||each.id ==='R0641')).length > 0
                    let isWholeHomeWifiSelected = (buildProductState && buildProductState.fne && buildProductState.fne.isWholeHomeWifiAdded) ? buildProductState.fne.isWholeHomeWifiAdded : isWholeHomeWifiOnProfile && buildProductState.router.selectedProduct==null?isWholeHomeWifiOnProfile:false;
                    let isConnectedAppFlow = false;
                    let servicesInCart = InHomeUtils.isNotNull(response.data.orderDetail) ? response.data.orderDetail.servicesOrdered : '';
                    isLocalTVInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                    let defaultdummyvRoom = null;
                    //ITT-670911 FIX router check added
                    if(prodType === Service.mm3 || prodType === Service.internet || prodType === Service.router)
                        {
                            let vas = '';
                            //dispatch({type : 'LOADER_ACTIVE',value : true});
                            setTimeout(() => {
                                const fetchUpgradeRouter = !!buildProductState?.router?.upgradeRouter && lqState?.runtimeKey?.enableZeroRatedRouterFetch === 'Y' && profileCart.legacyTVInProfile;
                                fetchRouter(dispatch, visitId, flowType, fetchUpgradeRouter);
                                fetchTechSure(dispatch, visitId, flowType);
                                fetchFne(dispatch, visitId);
                                //PreselectCartProducts(cartProducts, lqState, dispatch, visitId, '', null, buildProductState, signInState, upsellInfo.cart, upsellInfo.isUpsell, addlInfo.couponFlowType, true);
                                
                                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                                    if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment)) {//Getting the Equipments 
                                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'PreselectCartProducts', "Cart has Equipments"));
                                        logKafka("INFO", "BuildProduct", "Cart has Equipments", kafkaPageLogs, "applogs", visitId);
                                        for (let spCount = 0; spCount < cartProducts.CartSubProduct.Equipment.equipment.length; spCount++) {
                                            //let productType = cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink !== null ? cartProducts.CartSubProduct.Equipment.equipment[spCount].editLink.toUpperCase() : "";
                                           
                                            //Smartcart changes for EC flow
                                            let prdtype = cartProducts.CartSubProduct.Equipment.equipment[spCount].prodType;
                                            if(prdtype === "ACCESSPOINTBILLER" &&  cartProducts.CartSubProduct.Equipment.equipment[spCount].prodTypeVal !== 'ACCESSORIES'){
                                                dispatch({type:'EC_AccessPoint_SELECTEDPROD',value:cartProducts.CartSubProduct.Equipment.equipment[spCount]})
                                                if(cartProducts.CartSubProduct?.OneTimeCharges.oneTimeCharge[0].prodType === 'ACCESSPOINTNRCBILLER'){
                                                    dispatch({type:'EC_BuyAccessPoint_SELECTEDPROD',value:cartProducts.CartSubProduct?.OneTimeCharges.oneTimeCharge[0]})
                                                }else{
                                                    dispatch({type:'EC_BuyAccessPoint_SELECTEDPROD',value: null})
                                                }
                                            }else if(prdtype === "ACCESSPOINTBILLER" &&  cartProducts.CartSubProduct.Equipment.equipment[spCount].prodTypeVal === 'ACCESSORIES'){
                                                dispatch({type:'FNE_SELECTEDPROD',value:cartProducts.CartSubProduct.Equipment.equipment[spCount]})
                                            }
                                           if(prdtype === "ROUTERBILLER")
                                           {
                                            dispatch({type:'ROUTER_SELECTEDPROD',value:cartProducts.CartSubProduct.Equipment.equipment[spCount]})
                                            fetchFne(dispatch,visitId);
                                            let fneproduct2 =cartProducts?.CartSubProduct?.OneTimeCharges?.oneTimeCharge?.filter((x) => x?.prodId==="R4067")
                                            if(window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
                                                fneproduct2 = cartProducts?.CartSubProduct?.OneTimeCharges?.oneTimeCharge?.filter((x) => x?.prodType==="ACCESSPOINTNRCBILLER")
                                                if(fneproduct2 && fneproduct2.length === 0){
                                                    fneproduct2 = cartProducts.CartSubProduct.Equipment.equipment
                                                }
                                                fneproduct2 = {...fneproduct2?.[0], apitype:'extender'}
                                                if(!Array.isArray(fneproduct2)){
                                                    dispatch({type: Service.fne + "_SELECTEDPROD",value:fneproduct2,preSelect:true})
                                                }
                                            }
                                            if(fneproduct2?.length>0){
                                                dispatch({
                                                    type: Service.fne + "_SELECTEDPROD",
                                                    value:fneproduct2?.[0],preSelect:true
                                        });
                                    }
                                            // dispatch({type:'MM3_ROUTER_OPENACCOR',value:cartProducts.CartSubProduct.Equipment.equipment[spCount]})
                                           }
                                            if (prdtype === "NETWORKEXTENDERMRC") {
                                                dispatch({
                                                    type: Service.fne + "_SELECTEDPROD",
                                                    value: cartProducts.CartSubProduct.Equipment.equipment[spCount] ,preSelect:true
                                                });
                                                dispatch({type:'MM3_ROUTER_OPENACCOR',value:true})
                                           
                                            }
                                        }
                                    }
                                }
                                if (InHomeUtils.isNotNull(cartProducts.TechsureCloud) && InHomeUtils.isNotNull(cartProducts.TechsureCloud.VasProduct)) {//Getting the Equipments 
                                    dispatch({ type: Service.cloud + "_SELECTEDPROD", value: cartProducts.TechsureCloud.VasProduct[0],preSelect:true });
                                }

                                if(defaultProductadded)
                                {
                                    dispatch({type : 'TOGGLE_DATASUB_ACCOR',value : true})
                                } 
                                /*let vasProducts = [];
                                let routerselectedprod = []
                                vas = response.data.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                routerselectedprod = response.data.cartTierPricing?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.router);
                                if (InHomeUtils.isNotNull(routerselectedprod) && routerselectedprod.length > 0 && InHomeUtils.isNotNull(routerselectedprod[0]) && InHomeUtils.isNotNull(routerselectedprod[0].products)) {
                                    routerselectedprod = routerselectedprod[0].products;
                                    dispatch({type : 'ROUTER_SELECTEDPROD',value : routerselectedprod})
                                }
                                
                                if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                    vasProducts = vas[0].products;
                                }
                                const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });
                                */
                            }, 3000) 
                        }
                        if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === false && signInState.response?.flowRoute !== 'FULLDISCONNECT') {
                            
                            let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                            if(default_add_product)
                            {
                                updateCart(visitId, signInState, default_add_product, Service.mm3, false, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState, lqState, "", null, profileCart, true);
                            }
                        } 
                        if (product && product.defaultProduct && product.planPerks && product.planPerks.length > 0 && isChecked === true && signInState.response?.flowRoute !== 'FULLDISCONNECT') {
                            
                            let default_add_product = product.planPerks.find(e => e.id === product.defaultProduct);
                            if(default_add_product)
                            {
                                updateCart(visitId, signInState, default_add_product, Service.mm3, true, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState, lqState, "", null, profileCart, true);
                            }
                        } 

                        if(prodType === Service.recording){
                            fetchRecording(dispatch, visitId, false);
                        }
                        if (!buildProductState.showConnectedApps && prodType === Service.vRoom) {
                            fetchRecording(dispatch, visitId, addlInfo.couponFlowType);
                        }    
                        
                    if (upsellInfo.isUpsell) {
                        let accordionProdSelected = true;
                        dispatch({ type: BuildProduct.upsellCTA, value: { isUpsellAddedToCart: true, isUpsellDenied: false } });
                        let contract = response.data.orderDetail.contract === 'MTM' ? response.data.orderDetail.contract : '2YR';
                        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "updating Contract for SC - " + contract));
                        logKafka("INFO", "BuildProduct", "updating Contract for SC - " + contract, kafkaPageLogs, "applogs", visitId);
                        updatecontractforSC(contract, response.data.orderDetail.bundle, dispatch, addlInfo.couponFlowType)

                        doPrefetch("UPSELL", dispatch, visitId, addlInfo, contract, selectedCoreServices, false, isLocalTVInCart, '', '', false, servicesInCart);
                        PreselectCartProducts(cartProducts, lqState, dispatch, visitId, '', null, buildProductState, signInState, upsellInfo.cart, upsellInfo.isUpsell, addlInfo.couponFlowType, accordionProdSelected);
                        if (InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.bundle) && !response.data.orderDetail.bundle)
                            dispatch({ type: BuildProduct.checkoutBtnSelection, value: true });
                    }
                    dispatch({ type: 'ISCARTUPDATED', value: true });
                    dispatch({ type: 'CART_SAVE_ON_UPDATE', value: true });
                    
                    if(!isSubSectionsValid && prodType === Service.channel){
                        let profileTvProductItem = store.getState().ecProfileCart &&  store.getState().ecProfileCart.ProfileTVProduct && store.getState().ecProfileCart.ProfileTVProduct.prodId;
                        if(profileTvProductItem){
                            fetchChannel(dispatch, visitId, profileTvProductItem);
                        }
                    }
                    if (isSubSectionsValid && prodType === Service.channel) {
                        let premiumChannels = [];
                        let cartSection =  response.data.cartTierPricing.tierContent[0].sections.section;
                        cartSection.forEach(item => {
                            if(item.sectionName === 'Service' || item.sectionName === 'Onetimecharges') {
                                let subSection = item.subSections.subSection;
                                subSection.forEach(p => {
                                    if(p.sectionType === Service.channel) {
                                        p.products.forEach(prod => premiumChannels.push(prod));
                                    } else if(p.sectionType === Service.internationalPackageCart) {
                                        let channels = p.products.filter(data => data.prodTypeVal === 'VOD');
                                        channels.forEach(prod => premiumChannels.push(prod));
                                    }
                                })
                            } 
                        })
                        // let channel = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => (p.sectionType === Service.channel || (p.sectionType === Service.internationalPackageCart)));
                        // if (InHomeUtils.isNotNull(channel) && channel.length > 0 && InHomeUtils.isNotNull(channel[0]) && InHomeUtils.isNotNull(channel[0].products)) {
                        //     premiumChannels = channel[0].products;
                        // }
                        let selectedTvProductId = InHomeUtils.isNotNull(cartProducts.TvProduct) && cartProducts.TvProduct.tvProd[0] && cartProducts.TvProduct.tvProd[0].prodId;
                        if(selectedTvProductId === false){
                            selectedTvProductId = getSelectedTv(response.data.cartTierPricing, visitId).prodId
                        }
                        fetchChannel(dispatch, visitId, selectedTvProductId);
                        dispatch({ type: prodType + '_SELECTEDPROD', value: premiumChannels.length > 0 ? premiumChannels : null });
                    }
                    else if (isSubSectionsValid && prodType === Service.intrnlChnl) {
                        let internationalChannels = [];
                        let removedIntlChannels = [];
                        let intrnlchannel = response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.filter(p => p.sectionType === Service.internationalPackageCart);
                        if(InHomeUtils.isNotNull(intrnlchannel) && intrnlchannel.length > 0 && InHomeUtils.isNotNull(intrnlchannel[0]) && InHomeUtils.isNotNull(intrnlchannel[0].products)){
                            internationalChannels = intrnlchannel[0].products.filter(p => p.prodType.includes('INTLPREMIUM'));
                            
                        }
                        if (cartData && cartData[0] && cartData[0].removedotherchannel && cartData[0].removedotherchannel.channelsProds) {
                             removedIntlChannels = cartData[0].removedotherchannel.channelsProds;
                            if (removedIntlChannels && removedIntlChannels.length > 0) {
                                removedIntlChannels = removedIntlChannels.filter(p => p.prodType.includes('INTLPREMIUM'));
                                removedIntlChannels.map((product, index) => {
                                    product.isRemoved =  true;
                                })
                            }
                            
                        }
                        dispatch({ type: prodType + '_SELECTEDPROD', value: internationalChannels.length > 0 ? internationalChannels : null });
                        dispatch({ type: 'INTERNATIONAL_REMOVEDPROD', value: removedIntlChannels.length > 0 ? removedIntlChannels : null });                       

                    }
                    // else if(prodType === Service.fne && buildProductState && buildProductState.fne && product.id==='R0642'){
                    //     dispatch({ type: 'FNE_WHW_SELECTEDPROD', value: isChecked ? null : product });
                    // }
                    else if(prodType === 'fneDeviceCount' && product?.rcType === 'ACCESSPOINTBILLER'){
                        let whwProductCount = cartProducts.CartSubProduct.Equipment.equipment.filter(product => product?.prodId === 'R4100')
                        let rentProductCount = cartProducts.CartSubProduct.Equipment.equipment.filter(product => product?.prodId === 'R4094')
                        if(whwProductCount.length > 0){
                            dispatch({ type: 'FNE_SELECTEDPROD', value: whwProductCount?.[0] });
                        }else if(rentProductCount.length > 0){
                            dispatch({ type: 'EC_AccessPoint_SELECTEDPROD', value: rentProductCount?.[0] });
                        }
                    }else if(prodType === 'fneDeviceCount' && product?.rcType === 'ACCESSPOINTNRCBILLER'){
                        let buyProductCount = cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.filter(product => product?.prodId === 'R4095' || product?.prodId === 'R4096')
                        dispatch({ type: 'EC_BuyAccessPoint_SELECTEDPROD', value: buyProductCount?.[0] });
                    }
                    else if (prodType === Service.fneDeviceCount && buildProductState && buildProductState.fne && buildProductState.fne.selectedProduct) {
                        
                        let updatedProduct = buildProductState.fne.selectedProduct
                        if (!isChecked) {
                            updatedProduct.unitCount = product.unitCount;   
                        }
                        else {
                            updatedProduct.unitCount = 1;
                        }
                        console.log('fne selected 1',updatedProduct)
                        dispatch({ type: 'FNE_SELECTEDPROD', value: isChecked ? null : updatedProduct });
                    }
                    //fne count default to one if switched between fne prods
                    else if (prodType === Service.fne && buildProductState && buildProductState.fne && buildProductState.fne.selectedProduct){
                        let updatedProduct = product;
                        updatedProduct.unitCount = 1;
                        console.log('fne selected 2',updatedProduct)
                        dispatch({ type: 'FNE_SELECTEDPROD', value: isChecked ? null : updatedProduct });
                    }
                   
                    else if(isWholeHomeWifiSelected && product.prodType === 'NETWORKEXTENDERMRC'){
                        try{
                    let updatedProduct = product;

                    console.log('fne selected 3',updatedProduct)
                    dispatch({ type: 'FNE_SELECTEDPROD', value: isChecked ? null : updatedProduct });
                     }catch(eror){
                    console.log("error",eror)
                     }
                    }
                    else if (prodType === "Fios TV+" || prodType === "fiosTvOne" || prodType === Service.vRoom || prodType === Service.dummyvRoom || prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle) {
                        let tvConnProd = null;
                        let vRoom = null;
                        let dummyvRoom = null;
                        let ceApps = null;
                        let equipmentSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s=>s.sectionName === Service.equipment);
                        let tvConnProds = equipmentSection && equipmentSection.length ? equipmentSection[0].subSections.subSection.filter(p => p.sectionType === Service.setupbox) : [];
                        if(InHomeUtils.isNotNull(tvConnProds) && tvConnProds.length > 0 && tvConnProds[0] && tvConnProds[0].products && tvConnProds[0].products.length){
                            vRoom = tvConnProds[0].products.filter(p => p.prodType === Service.vRoom);
                            ceApps = tvConnProds[0].products.filter(p => p.prodType === Service.ceAppsParity || p.prodType === Service.ceAppsBundle);
                            dummyvRoom = tvConnProds[0].products.filter(p => p.prodType === Service.dummyvRoom);
                            vRoom = vRoom && vRoom.length ? vRoom[0] : null;
                            ceApps = ceApps && ceApps.length ? ceApps[0] : null;
                            dummyvRoom = dummyvRoom && dummyvRoom.length ? dummyvRoom[0] : null;
                            defaultdummyvRoom = dummyvRoom;
                            // if(prodType === Service.vRoom) {
                            //     dispatch({ type: prodType + '_SELECTEDPROD', value: vRoom });
                            // }
                            if(prodType === Service.vRoom || (vRoom && vRoom.unitCount && vRoom.unitCount !== buildProductState.vRoom.unitCount)) {
                                if(buildProductState.showConnectedApps){
                                    dispatch({ type: Service.vRoom + '_SELECTEDPROD_CEAPPS', value: {vRoom, ceApps, dummyvRoom} });
                                }
                                else {
                                    dispatch({ type: Service.vRoom + '_SELECTEDPROD', value: vRoom });
                                }                               
                            }
                            dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: {vRoom, ceApps, dummyvRoom}});
                            dispatch({ type: 'EC_' + Service.dummyvRoom + '_SELECTEDPROD', value: {vRoom, ceApps, dummyvRoom} });
                        }
                        else{
                            dispatch({ type: Service.vRoom + '_SELECTEDPROD', value: null });
                            dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: {vRoom, ceApps, dummyvRoom}});
                            dispatch({ type: Service.dummyvRoom + '_SELECTEDPROD', value: {vRoom, ceApps, dummyvRoom} });
                        }    
                        if (buildProductState.showConnectedApps && prodType === Service.vRoom) {
                            fetchRecording(dispatch, visitId, addlInfo.couponFlowType);
                            setTVConnectionsView(product, profileStbCount, buildProductState.tvConnections, isChecked, visitId, dispatch);
                            // dispatch({ type: 'UPDATE_CEAPPS', value: null });
                            setCEAppsView(defaultdummyvRoom ? defaultdummyvRoom: null, buildProductState.ceApps, buildProductState.vRoom, buildProductState.recording, isChecked, visitId, dispatch,product);
                            if(product && (product.id || product.prodId) && product.unitCount && parseInt(product.unitCount) === 1) {
                                let dummyvRoomProd = buildProductState.tvConnections && buildProductState.tvConnections.equipments && buildProductState.tvConnections.equipments.length ? buildProductState.tvConnections.equipments.filter(p => p.id === product.id || p.id === product.prodId) : null;
                                if(dummyvRoomProd && dummyvRoomProd.length) {
                                    dummyvRoomProd = {...dummyvRoomProd[0]}; 
                                    dummyvRoomProd['fromvRoom'] = true; 
                                    isConnectedAppFlow = true;
                                    updateCart(visitId, signInState, dummyvRoomProd, Service.dummyvRoom, false, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState, lqState, "", null, null);                             
    
                                }
                            }
                        }
                        if(prodType === Service.fiosTvOne){
                            fetchRecording(dispatch,visitId);
                            fetchFne(dispatch,visitId);
                            const fneproduct1 = cartProducts?.CartSubProduct?.Equipment?.equipment?.filter((x) => x?.prodId==="R4066")
                            const fneproduct2 =cartProducts?.CartSubProduct?.OneTimeCharges?.oneTimeCharge?.filter((x) => x?.prodId==="R4067")
                            if(fneproduct1?.length>0){
                                dispatch({
                                    type: Service.fne + "_SELECTEDPROD",
                                    value:fneproduct1?.[0],preSelect:true
                                });
                            }
                            else if(fneproduct2?.length>0){
                                dispatch({
                                    type: Service.fne + "_SELECTEDPROD",
                                    value:fneproduct2?.[0],preSelect:true
                        });
                        }
                        }
                        if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])) {
                            let allServiceSectionEquipment = response.data.cartTierPricing.tierContent[0].sections.section.filter(s => s.sectionName === 'Equipment');
                            let dvrSection = allServiceSectionEquipment && allServiceSectionEquipment.length ? allServiceSectionEquipment[0].subSections.subSection.filter(p => p.sectionType === Service.recording) : [];
                            if (dvrSection && dvrSection.length > 0 && dvrSection[0] && dvrSection[0].products && dvrSection[0].products.length) {
                                let autoAddDvr = dvrSection[0].products[0] && dvrSection[0].products.filter(v => v.status === 'ADD' && v.prodType === 'VFEATURE').length > 0 ? dvrSection[0].products.filter(v => v.status === 'ADD' && v.prodType === 'VFEATURE') : null;
                                dispatch({ type: 'RECORDING_SELECTEDPROD', value: autoAddDvr && autoAddDvr[0] ? autoAddDvr[0] : null });
                            }
                            // commenting for PRODDEF-34830 issue fix
                            // else {
                            //     dispatch({ type: 'RECORDING_SELECTEDPROD', value: null });
                            // }
                        }
                        if (buildProductState.showConnectedApps && (prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle)) {
                            fetchRecording(dispatch, visitId, addlInfo.couponFlowType);
                        }
                        if (buildProductState.showConnectedApps && prodType === Service.dummyvRoom && !product.fromvRoom) {
                            setCEAppsView(product, buildProductState.ceApps, buildProductState.vRoom, buildProductState.recording, isChecked, visitId, dispatch);
                        }
                    }
                    else if ((prodType === Service.streamServ && buildProductState && buildProductState.streamServ)) {
                        try{
                        let updatedProduct = [];
                        let RemovedProduct = [];

                        if ((product.prodTypeValue === Service.slingtv) && (prodType === Service.tv)) {
                            prodType = Service.streamServ;
                        }

                        if (buildProductState.streamServ.selectedProduct) {
                            updatedProduct = Array.isArray(buildProductState.streamServ.selectedProduct)?[...buildProductState.streamServ.selectedProduct]:[buildProductState.streamServ.selectedProduct];
                        }

                        if (buildProductState.streamServ.removedProduct) {
                            RemovedProduct = buildProductState.streamServ.removedProduct;
                        }

                        if (product.isprdOnProfile) {
                            if (!isChecked) {                                
                                RemovedProduct = buildProductState.streamServ.removedProduct?.filter(x => x.id != product.id);
                                if(product.id && updatedProduct && updatedProduct?.length>0){
                                    const newArr = [];
                                    let hasChanged = false;
                                    if(product.id === "R0944"){
                                        for(const item of updatedProduct){
                                            if(item?.id !== "R2540"){
                                                newArr.push(item);
                                            }
                                            else{
                                                hasChanged = true;
                                            }
                                        }
                                        
                                    }
                                    else if(product.id === "R2540"){
                                        for(const item of updatedProduct){
                                            if(item?.id !== "R0944"){
                                                newArr.push(item);
                                            }
                                            else{
                                                hasChanged = true;
                                            }
                                        }
                                    }
                                    if(hasChanged){
                                        dispatch({ type: prodType + '_SELECTEDPROD', value: newArr?.length > 0 ? newArr : null });
                                    }
                                }
                            }
                            else {
                                RemovedProduct.push(product);
                            }

                            dispatch({ type: prodType + '_REMOVEDPROD', value: RemovedProduct?.length > 0 ? RemovedProduct : null });
                            
                        }
                        else{                       

                            if (isChecked) {
                                //changed product.bundleKey filter to product.id
                                updatedProduct = buildProductState.streamServ.selectedProduct.filter(x => x.id != product.id);
                            }
                            else {
                                updatedProduct.push(product);
                            }

                            dispatch({ type: prodType + '_SELECTEDPROD', value: updatedProduct.length > 0 ? updatedProduct : null });
                        }
                        fetchStreamingServices(visitId, dispatch); 
                    }catch(error){
                        console.log("error",error)
                    }
                    }
                    else if (prodType === Service.techSure && buildProductState && buildProductState.techsure) {
                        if (signInState.response.mfrtFlow){
                            /**fetch voice for mfrt*/
                        fetchVoiceMTM(dispatch,visitId)
                        }
                        if (product.isprdOnProfile) {
                            if (buildProductState.techsure) {
                                addVasDisconnectKeys(dispatch,product)
                             let techsureProducts = store.getState().buildProduct.techsure.techsureProducts;
                             let modTechSureProducts = []
                             if(product.id==="7486966"&&product.disconnect){
                                 modTechSureProducts=techsureProducts
                             }else if(product.id==="7486399" && !product.disconnect){
                                 modTechSureProducts=techsureProducts
                             }else if(product.id==="7487729" && product.disconnect){
                                modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486966")
                             }else{
                                 modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486399")
                             }
                               
                                dispatch({ type: prodType + '_SELECTEDPROD', value: null,modTechSureProducts});


                               
                            }
                        }
                        else {
                            let updatedProduct = [];
                            let modTechSureProducts=[]
         
                             /**sub system */
                             let buildProductRedcuer = store.getState().buildProduct.techsure
                             let techsureProds = buildProductRedcuer.techsureProducts
                            let prodOnReducer = buildProductRedcuer.selectedProduct

                            var exclusionList=product.exclusionList
                            let afterExclusionprod = product.exclusionList ?
                            prodOnReducer&&prodOnReducer.filter(each=>exclusionList&&!exclusionList.includes((each.id || each.prodId).toString()))
                            :prodOnReducer
                            updatedProduct =prodOnReducer? [...updatedProduct,...afterExclusionprod]:updatedProduct
                            if(buildProductRedcuer.isHomeSecurityProductAdded && product?.id==="R3900"){                               
                               // dispatch({type:'HOMESECURITY_SELECTED_PROD',value : true});
                                techsureProds.map((prod)=>{
                                    prod.qty=0;
                                })
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (x.prodId || x.id) !== "R3901");
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (x.prodType !== "VHSBILLER"));

                            }
                            if(buildProductRedcuer.isHomeSecurityPlusProductAdded && product?.id==="R3901"){
                                techsureProds.map((prod)=>{
                                    prod.qty=0;
                                })
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (x.prodId || x.id) !== "R3900");
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (x.prodType !== "VHSBILLER"));
                            }
                            if(product?.prodType === "VHSBILLER" && buildProductRedcuer.isHomeSecurityProductAdded && product?.id!=="R3900" && product?.id!=="R3901"){
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (!x?.keyword?.includes('VHSTIER1')));

                            }
                            if(product?.prodType === "DHSBILLER"){
                                updatedProduct = buildProductRedcuer.selectedProduct?.filter(x => (x.prodType !== "DHSBILLER"));

                            }

                            if(isChecked){
                                if(product?.name === "Home Security" || product?.name === "Home Security Plus"){
                                    dispatch({ type: "HOME_SECURITY_CLEAR", value : true});
                                   }
                               updatedProduct = buildProductRedcuer.selectedProduct.filter(x => (x.prodId || x.id) !== product.id);
                               
                            }else{
                               // product.prodType="TECHSURE";
                                if(!updatedProduct){
                                    updatedProduct = [];
                                }
                              updatedProduct.push(product);
                            }

                            let productCount = store.getState().buildProduct?.accessoriesProductCount;

                            if(productCount >= 1){
                                product.qty = productCount;
                                if(!updatedProduct){
                                    updatedProduct = [];
                                }
                              updatedProduct.push(product);
                              dispatch ({type: 'SET_HS_PRODUCT_COUNT', value: 0});
                            }

               
                            /**sub system for mod products to show */
                             try{                             
                            //  var newTechsureProducts = techsureProds&&techsureProds.map(each=>exclusionList&&exclusionList.includes((each.id || each.prodId).toString())&&each.isprdOnProfile?each.disconnect=!each.disconnect:each)
                            if(product.id=="7487729" && product.isChecked === false){
                                modTechSureProducts=techsureProds.filter(each=>each.id!=="7486399")
                            }else if(product.id=="7487729" && product.isChecked === true){
                                modTechSureProducts=techsureProds.filter(each=>each.id!=="7486966")
                            }else{
                                if(techsureProds.filter(each=>each.id==="7487729"&& each.isChecked || each.isprdOnProfile || each?.disconnect === true).length > 0){
                                    modTechSureProducts=techsureProds.filter(each=>each.id!=="7486399")
                                }else{
                                    modTechSureProducts=techsureProds.filter(each=>each.id!=="7486966")
                                }                                                     
                            }
                             }catch(error){
                               console.log("error",error)
                             }
                             addVasDisconnectKeys(dispatch,product)


                            dispatch({ type: prodType + '_SELECTEDPROD', value: updatedProduct.length > 0 ? updatedProduct : null,modTechSureProducts });
                        }
                    }
                    else if (prodType === Service.vhsBiller){
                        let updatedProduct = [];
                        let buildProductRedcuer = store.getState().buildProduct?.vhsBiller

                        if(store.getState().buildProduct?.techsure?.isHomeSecurityPlusProductAdded){
                       let prodOnReducer = buildProductRedcuer?.selectedProduct

                       updatedProduct = prodOnReducer?prodOnReducer:[];
                        }


                        if(isChecked)
                        {
                            updatedProduct = buildProductRedcuer.selectedProduct.filter(x => (x.prodId || x.id) !== product.id);

                        }  else{ 
                            
                        if(!updatedProduct){
                            updatedProduct = [];
                        }                     
                        updatedProduct.push(product);
                        }






                       dispatch({ type: prodType + '_SELECTEDPROD', value: updatedProduct.length > 0 ? updatedProduct : null});




                    }
                    else if (prodType === Service.cloud && buildProductState && buildProductState.techsurecloud) {
                        if (product.isprdOnProfile) {
                            dispatch({ type: prodType + '_SELECTEDPROD', value: null });
                        } else {
                            dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });

                        }
                        fetchTechSure(dispatch,visitId); 
                    }
                    else if (prodType === Service.voice || prodType === Service.listing || prodType === Service.battery) {
                        if(buildProductState.productOnProfileStatus.voice && prodType === Service.listing) {
                            dispatch({ type: 'EXISTING_LISTING_SELECTEDPROD', value: isChecked ? null : product });
                        } else {
                            dispatch({ type: 'EC_' + prodType + '_SELECTEDPROD', value: isChecked ? null : product });
                        }
                    }
                    else if (product.prodTypeValue === Service.slingtv) {
                        dispatch({ type: 'SLING_SELECTEDPROD', value: isChecked ? null : product });
                    }
                    else if ((product.prodType === Service.vRoom || prodType === Service.recording)  && product.isprdOnProfile){
                        /**update reducer with null to avoid checked for prodInproffile added issue*/
      
                        dispatch({ type: prodType + '_SELECTEDPROD', value: null })

                    }
                    else {
                        if ((prodType === Service.tv && product.prodTypeValue !== Service.slingtv) && product.isprdOnProfile || product.prodTypeValue === 'DONTWANTTV') {
                            dispatch({ type: prodType + '_SELECTEDPROD', value: null });
                        } 
                        else if(product.id  === "VMS1100" || product.prodType === "fiosTvOne") {
                           /* const routerProfileProduct = buildProductState.router.equipments
                            const olderRouterVersions = InHomeUtils.isNotNull(routerProfileProduct) && !(routerProfileProduct[0]&&routerProfileProduct[0].keyword&&routerProfileProduct[0].keyword.includes("BHRX") ||routerProfileProduct[0].keyword.includes("CHR") || routerProfileProduct[0].keyword.includes("BHR4") || routerProfileProduct[0].keyword.includes("FQGRENTAL") || routerProfileProduct[0].keyword.includes("ROUTERCATEGORY:200")|| routerProfileProduct[0].keyword.includes("DESC:FIOS_QUANTUM_GATEWAY")||routerProfileProduct[0].keyword.includes("|OWNERSHIP:CUSTOMER|"))
                            const vFeatureOnProfile = InHomeUtils.isNotNull(buildProductState.recording) && InHomeUtils.isNotNull(buildProductState.recording.equipments) && buildProductState.recording.equipments.filter(v => v.isprdOnProfile && (v.prodTypeValue.indexOf('HD-DVR') > -1 || v.prodTypeValue.indexOf('HD-HMDVR') > -1))
                            *///if(product.id==="VMS1100" )
                            const fetchUpgradeRouter = buildProductState?.router?.upgradeRouter && buildProductState?.router?.upgradeRouter !== "Upgraded" && !signInState?.response?.classicToFcp && lqState?.runtimeKey?.enableZeroRatedRouterFetch === 'Y' && profileCart.legacyTVInProfile;
                            fetchRouter(dispatch, visitId, 0, fetchUpgradeRouter);
                            // if (product.id === "VMS1100" )
                            fetchRecording(dispatch, visitId);
                            dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
                        }
                        else{
                            let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                            if((product?.rcType === 'ACCESSPOINTNRCBILLER' || product?.prodType === 'ACCESSPOINTNRCBILLER') && cartProducts.CartSubProduct?.OneTimeCharges.oneTimeCharge[0].prodType === 'ACCESSPOINTNRCBILLER'){
                                dispatch({ type: 'EC_BuyAccessPoint_SELECTEDPROD', value: cartProducts.CartSubProduct?.OneTimeCharges.oneTimeCharge[0] });
                            }else if(prodType === 'AccessPoint' && product?.prodTypeValue === 'ACCESSORIES'){
                                dispatch({ type: 'EC_RentAccessPoint_SELECTEDPROD', value: isChecked ? null : product });
                            }else if(prodType === 'AccessPoint'){
                                dispatch({ type: 'EC_AccessPoint_SELECTEDPROD', value: isChecked ? null : product });
                            }else if(prodType === 'fneDeviceCount' && (product?.rcType === 'ACCESSPOINTNRCBILLER' || product?.rcType === 'ACCESSPOINTNRCBILLER')){
                                dispatch({ type: 'FNE_SELECTEDPROD', value: isChecked ? null : product });
                            }else if(prodType === 'ROUTER' && (product?.prodType === 'ACCESSPOINTNRCBILLER' || product?.prodType === 'ACCESSPOINTBILLER')){
                            }else{
                                dispatch({ type: prodType + '_SELECTEDPROD', value: isChecked ? null : product });
                            }
                        }
                        
                    }
                  //  console.log("cart**",{cartProducts})
                    if (prodType === Service.internet || prodType === Service.mm3 || (prodType === Service.tv && (product.prodTypeValue !== Service.slingtv)  || prodType === Service.customTV || prodType === Service.voice)) {
                        if (prodType === Service.internet){
                           getSpecialOffers(visitId, contract, dispatch);
                        }
                        fetchOfferInCart(visitId, cartProducts, dispatch, product.specialOffers);
                        var selectedprodid = product.id
                        if (!isChecked && InHomeUtils.isNotEmpty(product.prodTypeValue) && product.prodTypeValue === "ULTIMATETESTDRIVE" && InHomeUtils.isNotNull(buildProductState) && (InHomeUtils.isNotNull(buildProductState.tv)) && InHomeUtils.isNotNull(buildProductState.tv.ultimateTvUsoc))
                            selectedprodid = buildProductState.tv.ultimateTvUsoc;

                        let cartTvProduct = InHomeUtils.isNotNull(cartProducts.TvProduct) && cartProducts.TvProduct.tvProd[0] && cartProducts.TvProduct.tvProd[0].prodId;
                        let profileTvProductId = store.getState().ecProfileCart &&  store.getState().ecProfileCart.ProfileTVProduct && store.getState().ecProfileCart.ProfileTVProduct.prodId;
                        if(cartTvProduct){
                            selectedprodid = cartTvProduct;
                        }
                        else if(profileTvProductId){
                            selectedprodid = profileTvProductId;
                        }

                        addlInfo.selectedProductId = selectedprodid;
                        if ((!upsellInfo.isUpsell) && (product.prodTypeValue !== Service.slingtv)) {
                            let isClassicDisconnect =  (InHomeUtils.isNotEmpty(signInState) && InHomeUtils.isNotEmpty(signInState.response) && signInState.response.flowRoute && signInState.response.flowRoute === "FULLDISCONNECT" && !(signInState.response.userProfile && signInState.response.userProfile.isFcpInProfile) && !signInState.response.classicToFcp) ? true : false;
                            if(!isClassicDisconnect){
                                doPrefetch(prodType + "_SELECTED", dispatch, visitId, addlInfo, contract, selectedCoreServices, false, isLocalTVInCart, isDCTinCart, '', isChecked, servicesInCart,VecContractServices);
                            }
                        }
            
                    }

                    
                    if(prodType && prodType == 'FTTPD'){
                        fetchRecording(dispatch, visitId);
                    }

                    if (prodType === Service.router || prodType === Service.customRouter){
                         fetchTechSure(dispatch,visitId)
                    }
                    if (prodType === Service.tv && signInState.response && signInState.response.flowRoute=="CLASSICTOFCP"){
                        fetchRecording(dispatch,visitId)
                   }
                   if(prodType === Service.ceAppsParity || prodType === Service.ceAppsBundle){
                    dispatch({ type: 'TOGGLE_TV_RECORDING_ACCOR', value: null });
                   }

                    /**multigig */
                    if((signInState.response.visionCustomerId === '137442428' || signInState.response.visionCustomerId === '150395512'
                          || signInState.response.visionCustomerId === '550400420' || signInState.response.visionCustomerId === '159701634' 
                          || signInState.response.visionCustomerId === '259700008' || signInState.response.visionCustomerId === '359700012' 
                          || signInState.response.visionCustomerId === '459700001' || signInState.response.visionCustomerId === '659700145' || signInState.response.visionCustomerId === '259700147' || signInState.response.visionCustomerId === '557047080' || signInState.response.visionCustomerId === '257051757')){
                        dispatch({type : 'ALLOW_MUTLIGIG_TV_ENABLE',value : true})
                    }

                     const routerProfileProduct = buildProductState.router.equipments
                     const olderRouterVersions = InHomeUtils.isNotNull(routerProfileProduct) && !(routerProfileProduct[0]&&routerProfileProduct[0].keyword&&(routerProfileProduct[0].keyword.includes("BHRX") ||routerProfileProduct[0].keyword.includes("CHR") || routerProfileProduct[0].keyword.includes("BHR4") || routerProfileProduct[0].keyword.includes("FQGRENTAL") || routerProfileProduct[0].keyword.includes("ROUTERCATEGORY:200")|| routerProfileProduct[0].keyword.includes("DESC:FIOS_QUANTUM_GATEWAY")||routerProfileProduct[0].keyword.includes("|OWNERSHIP:CUSTOMER|")))

                    if (prodType === Service.internet || (olderRouterVersions && product.id==="VMS1100")) {
                        if(product.id !== "VMS1100"){
                            dispatch({type : 'TOGGLE_OTHER_ACCOR',value : 'internetSubAccClose'});
                        }
                        if (isChecked) {
                            clearDataSubProducts(dispatch, selectedCoreServices);
                            clearStreamService(dispatch);
                        }
                        else {
                            let newEquipmentSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s=>s.sectionName === Service.equipment);
                            let allServiceSection = response.data.cartTierPricing.tierContent[0].sections.section.filter(s=>s.sectionName === 'Service');
                            let RouterSection = newEquipmentSection && newEquipmentSection.length ? newEquipmentSection[0].subSections.subSection.filter(p => p.sectionType === Service.router) : [];
                            let vasSection = allServiceSection && allServiceSection.length ? allServiceSection[0].subSections.subSection.filter(p => p.sectionType === Service.vasstandalone) : [];
                            let streamingSection = allServiceSection && allServiceSection.length ? allServiceSection[0].subSections.subSection.filter(p => p.sectionType === "STREAMINGSERVICES") : [];
                            if (RouterSection && RouterSection.length >0 && RouterSection[0] && RouterSection[0].products && RouterSection[0].products.length) {
                                let autoAddRouter = RouterSection[0].products[0] && RouterSection[0].products[0].status === 'ADD' ? RouterSection[0].products[0] : null;
                                dispatch({ type: 'ROUTER_SELECTEDPROD', value: autoAddRouter ? autoAddRouter : null });
                                try{
                                let customerProviderRouter = store.getState().buildProduct.router.equipments
                                customerProviderRouter =  customerProviderRouter.filter(each=>each.id==='J4396' && each.isprdOnProfile).length===1
                                let whwRouterOnProfile = store.getState().ecProfileCart.cartData
                                whwRouterOnProfile = whwRouterOnProfile[0].equipments&&whwRouterOnProfile[0].equipments.equipment.filter(each=>each.prodId === 'R0641').length> 0
                                let selectedRouter = buildProductState.router.selectedProduct
                                if(!customerProviderRouter && !whwRouterOnProfile){
                                sweetnerAction(autoAddRouter?autoAddRouter:selectedRouter, buildProductState,isChecked,tvDisconnect,dispatch)
                                dispatch({ type: 'ROUTER_SELECTEDPROD', value: autoAddRouter ? autoAddRouter : selectedRouter });                              
                            }
                                }catch(error){
                                    console.log("error",error)
                                } 


                            }
                            try{
                            if (streamingSection && streamingSection.length >0 && streamingSection[0] && streamingSection[0].products && streamingSection[0].products.length) {
                                let autoAddStreaming = streamingSection[0].products[0] && streamingSection[0].products.filter(v=>v.status === 'ADD').length > 0 ? streamingSection[0].products.filter(v=>v.status === 'ADD') : null; 
                                let finalStreamingProduct = store.getState().buildProduct.streamServ.streamServProd
                                let autoAddIds =autoAddStreaming && autoAddStreaming.map(each=>each.prodId)
                                finalStreamingProduct = finalStreamingProduct && finalStreamingProduct.filter(each=> autoAddIds && autoAddIds.includes(each.id))
                                dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: finalStreamingProduct && finalStreamingProduct.length > 0 ? finalStreamingProduct : null });                                
                            }
                            else{
                                dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: null});
                            }
                        }catch(error){
                            console.log("error",error)
                        }
                            if (vasSection && vasSection.length >0 && vasSection[0] && vasSection[0].products && vasSection[0].products.length) {
                                let autoAddCloudProduct = vasSection[0].products[0] && vasSection[0].products.filter(v=>v.status === 'ADD' && v.prodType === 'PPPCLOUD').length > 0 ? vasSection[0].products.filter(v=>v.status === 'ADD' && v.prodType === 'PPPCLOUD') : null; 
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: autoAddCloudProduct && autoAddCloudProduct[0] ? autoAddCloudProduct[0] : null });                                
                            }
                            else{
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: null});
                            }
                        }
                    }
                    else if (prodType === Service.tv) { // || prodType === Service.customTV
                        if (isChecked) {
                            clearVideoSubProducts(dispatch, selectedCoreServices);
                        }
         
                        dispatch({ type: 'CUSTOMTV_SELECTEDPROD', value: null });
                        //dispatch({ type: 'SET_CUSTOMTV_PACKAGE_STATUS', value: false });
                        if (InHomeUtils.isNotNull(response.data.cartTierPricing)) {
                            // let selectedInternet = getSelectedInternet(response.data.cartTierPricing, visitId)
                            // if (InHomeUtils.isNotNull(selectedInternet) && selectedInternet.length > 0)
                            //     dispatch({ type: Service.internet + '_SELECTEDPROD', value: selectedInternet });

                            let selectedChannels = getSelectedChannels(response.data.cartTierPricing, visitId)
                            dispatch({ type: 'CHANNEL_SELECTEDPROD_ON_TVCHANGE', value: selectedChannels });
                        }
                        // if(signInState.response.flowRoute=="CLASSICTOFCP"){
                        // let allServiceSectionEquipment = response.data.cartTierPricing.tierContent[0].sections.section.filter(s=>s.sectionName === 'Equipment');

                        // let dvrSection = allServiceSectionEquipment && allServiceSectionEquipment.length ? allServiceSectionEquipment[0].subSections.subSection.filter(p => p.sectionType === Service.recording) : [];
                        // if (dvrSection && dvrSection.length >0 && dvrSection[0] && dvrSection[0].products && dvrSection[0].products.length) {
                        //     let autoAddDvr = dvrSection[0].products[0] && dvrSection[0].products.filter(v=>v.status === 'ADD' && v.prodType === 'VFEATURE').length > 0 ? dvrSection[0].products.filter(v=>v.status === 'ADD' && v.prodType === 'VFEATURE') : null; 
                        //     dispatch({ type: 'RECORDING_SELECTEDPROD', value: autoAddDvr && autoAddDvr[0] ? autoAddDvr[0] : null });                                
                        // }
                        // else{
                        //     dispatch({ type: 'RECORDING_SELECTEDPROD', value: null});
                        // }
                        // }
                    }
                    else if (prodType === Service.voice && isChecked) {
                        clearVoiceSubProducts(dispatch);
                    }

                    let profileRouter=''
                    if ((buildProductState.showConnectedApps) && (prodType === Service.router)) {
                        if (profileRouter && profileRouter[0] && profileRouter[0].keyword && !(profileRouter[0].keyword.indexOf('FIOS_QUANTUM_GATEWAY') > -1 || profileRouter[0].keyword.indexOf('BHRX') > -1)) {
                            fetchCeapps(dispatch, visitId, addlInfo.couponFlowType);
                        }
                    }

                    if (utdClearCart) {
                        dispatch({ type: 'TV_SELECTEDPROD', value: null });
                        clearVideoSubProducts(dispatch, selectedCoreServices);
                        dispatch({ type: DOFlow.onSelectedCoreService, value: { selectedCoreService: '' } });
                        //Open Internet Plans by default for BYOB and DO
                        dispatch({ type: 'TOGGLE_INTERNET_ACCOR', value: '' });
                    }
                    //Voice is mandatory for EC flow. So commented this code
                    /*if (servicesInCart === '') {
                        dispatch({ type: 'FIOS_VOICE_SELECTEDPROD', value: null });
                        clearVoiceSubProducts(dispatch);
                    }*/

                    if (!firstBill.socInvoked && response.data.cartTierPricing != null && !isChecked) {
                        fetchPostSoc(dispatch, visitId);
                        socInvoked(true, dispatch);
                    }
                    
                    // checkout redirection                     
                    if(typeof(flowType)!='boolean' && flowType.indexOf("MandMSelect")>-1)
                    {
                        updatecartEvent("AddtoCart", "");
                        redirectToCheckout(visitId,dispatch)
                    }
                    else if(typeof(flowType)!='boolean' && flowType.indexOf("MandMCustom")>-1)
                    {
                        if(flowType === "MandMCustom"){
                            redirectTo(Pages.PegaToECBuildProductRedirect+(signInState.response.classicToFcp ? "CLASSICTOFCP" : ''), dispatch);
                        }else{
                            redirectTo(Pages.PegaToECBuildProductRedirect+(signInState.response.classicToFcp ? "CLASSICTOFCP" : ''), dispatch);
                        }
                    }
                    else if (typeof(flowType)!='boolean' && flowType === "MandMBundle"){
                        buildProductAction.updateCheckoutBtnStatus(true, dispatch);
                        updatecartEvent("AddtoCart", "");
                        let autoPayinCart = buildProductAction.isAutoPayInCart(store.getState().app.visitId, store.getState().cart);
                        buildProductAction.autoPayinCart(autoPayinCart ? true : false, dispatch);
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        return;
                    }

                    //ADDON Products
                    if(InHomeUtils.isNotNull(addonProduct) && InHomeUtils.isNotNull(addonProduct.productInCart) && addonProduct.productInCart.length > 0 ){
                        let addonProd = addonProduct.productInCart.shift();
                        let addonProdType = addonProduct.prodType.shift();
                        let addonProdMode = addonProduct.isRemoved.shift();
                        addonProducts = addonProd.prodType;
                        updateCart(visitId, signInState, addonProd, addonProdType, addonProdMode, dispatch, voiceTn, firstBill, addonProduct, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState, lqState, "", null, null);
                        // updateCart(visitId, lqState, addonProd, addonProdType, addonProdMode, dispatch, voiceTn, firstBill,addonProduct, contract, servicesInCart, false, false, upsellInfo,buildProductState, equipmentState);
                        prodType === Service.vRoom ? dispatch({ type: 'TOGGLE_TV_RECORDING_ACCOR', value: null }) : {};
                    }
                    else if (prodType === Service.battery && InHomeUtils.isNotNull(addonProduct) && !InHomeUtils.isNotEmpty(addonProduct.productInCart)) {
                        dispatch({ type: 'BBUSHIPMENT_SELECTEDPROD', value: null });
                    }

                    if (prodType === Service.dct || prodType === Service.tv) {
                        let cartTvProduct = InHomeUtils.isNotNull(cartProducts.TvProduct) && cartProducts.TvProduct.tvProd[0] && cartProducts.TvProduct.tvProd[0].prodId;
                        fetchChannel(dispatch, visitId, cartTvProduct);
                        fetchVRoom(dispatch, visitId);
                        if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.vRoom)) {
                            dispatch({ type: 'TOGGLE_TV_SETTOPBOX_ACCOR', value: null })
                        }
                        setTimeout(() => {
                            dispatch({ type: 'UPDATE_VROOM', value: { product, isChecked } });
                        }, 4500)
                    }
                                            
                  
                    
                    if(!isConnectedAppFlow) {
                        setTimeout(() => dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }), 1000);
                    }

                    //Sitecatalist Logging
                    if (!isChecked) {
                        // if (prodType === Service.voice) {
                        //     updateSCTags("check my number");
                        //     tempSCData.pageName = addlInfo.isDoFlow ? "do accord" : "byob"
                        //     updateSCcustomEvent("winBackLoad", "ddAddToCartEvent", "pageName");
                        // }

                        addToCartSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, true, upsellInfo)
                    }
                    else {
                        addToCartSCEvent(visitId, product, prodType, response, addlInfo.isDoFlow, false)
                    }

                    if(product && product.speedCode == "947" && isChecked === false && buildProductState.voice.selectedProduct && (product.defaultProduct == undefined || product.defaultProduct == "")){
                        let voiceRemoveProduct = buildProductState.voice && buildProductState.voice.plans && buildProductState.voice.plans[0];
                        updateCart(visitId, signInState, voiceRemoveProduct, Service.voice, true, dispatch, voiceTn, firstBill, null, contract, servicesInCart, false, false, upsellInfo, buildProductState, equipmentState, lqState, "", null, null);
                    }

                    if(product && product.speedCode == "947" && isChecked === false && (product.defaultProduct == undefined || product.defaultProduct == "") && (buildProductState.tv.streamTvEligible || buildProductState.tv.AndriodUpgradeEligible) && !buildProductState.tv.StreamTVProductSelected && profileCart.ProfileTVProduct !== null){
                        setTimeout(() => {
                            dispatch({ type: 'TOGGLE_INTERNET_ACCR_FIOSTV'});
                            dispatch({ type: 'TOGGLE_TV_FIOSTVONE_ACCOR', value: 'streamtv'});
                        },7000);
                    }

                    if(isCartAdded){
                        if(!flowType.includes('MandMCustom')){
                            let detailName = prodType=== Service.internet && !buildProductState?.isClassicAccount ? "" : product.name
                            updatecartEvent("AddtoCart", detailName);
                        }
                        else{
                            setPegaButtonStatus();
                        }
                    }
                    isCartAdded=true;
                   
                    let isGigaOnProfile = false;
                    let isGigaOnCart = (InHomeUtils.isNotNull(buildProductState.internet.selectedProduct) && buildProductState.internet.selectedProduct.downSpeed == '1024M') ? true : false;
                    let dataproducts = (buildProductState.internet.contract === '2YR') ? buildProductState.internet.twoYearPlans : buildProductState.internet.m2mPlans;
                    if (profileCart && profileCart.ProfileDataProduct && profileCart.ProfileDataProduct.prodId) {
                        let profileData = dataproducts.find(item => item.id === profileCart.ProfileDataProduct.prodId);
                        isGigaOnProfile = ((InHomeUtils.isNotNull(profileData) && profileData.downSpeed == '1024M') ||(profileCart.ProfileDataProduct.prodName.indexOf('Gigabit') > -1)) ? true: false;
                    }
                    //Recommendations Upsell 
                    if(InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.RecommUpsell) && lqState.runtimeKey.RecommUpsell ==="Y")
                        if(InHomeUtils.isNotNull(profileCart) && !isGigaOnProfile && !isGigaOnCart && (prodType === 'ROUTER' || prodType === 'FNE' || prodType === 'OTTBASIC'))
                            assignUpsellrecommendations(buildProductState, profileCart, product, prodType, dispatch, visitId);
                }
                else { //error while updating cart
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "updateCart - Failed"));
                    logKafka("ERROR", "BuildProduct", "updateCart - Failed", getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(true);
            })
                .catch(error => {
                    let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
                    logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                });
            });
            
        }

    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateCart', ex);
    }
}

export const updatePerkSelection = async(requestParams) => {
    const { product, prodId, visitId, add, flowType, dispatch,isMnHAuthenticated, fromPerkToggle, findSelectedprod} = requestParams;
    const { data } = product;
    const payload = {
        "contract": "MTM",
        "productId":  prodId ? prodId : data.id,
        "productType": "BYOPERK",
        "quantity": "1",
        "serviceType": "DATA",
        "status": add ? 'remove' : 'add',
        "orderType": "",
        "isMnHAuthenticated":isMnHAuthenticated
    };
    const perkProductId = prodId ? prodId : product?.data?.id;
    try {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart"} })
      // logOtherInfo(detailsInfo('BuildProduct', visitId, 'perk selection', "In update perks"));                
      let perkUpdateUrl = apiUrl().updateCartAcc + '/' + visitId;
      console.log('***** prod change updated perks payload ', perkUpdateUrl, payload);
      await api(perkUpdateUrl, 'POST', JSON.stringify(payload)).then(response => {
          if (InHomeUtils.isNotNull(response)) {  
            console.log('****** prod change updated perks response', JSON.parse(JSON.stringify(response)));
            // const res = JSON.parse(JSON.stringify(response));
            if(InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing)
                && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && response.data.cartTierPricing.tierContent.length > 0) {
                const tierContent = response.data.cartTierPricing.tierContent[0];
                console.log('response.data.cartTierPricing.tierContent[0].sections.section.length',response.data.cartTierPricing.tierContent[0].sections.section.length)
                if(InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections) && 
                InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section) && 
                InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section.length > 0)
              ) {
                    const perkRes = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(sec => sec.sectionName === 'Perks');
                    const promoSection = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(p => p?.sectionName === CartServices.Promotions);
                    if(perkRes && 
                        InHomeUtils.isNotNull(perkRes.subSections) && 
                        InHomeUtils.isNotNull(perkRes.subSections.subSection) && 
                        InHomeUtils.isNotNull(perkRes.subSections.subSection.length > 0)) {
                        const perkProds = perkRes.subSections.subSection.find(sub => sub.sectionType === 'Perks');
                        const prods = perkProds.products;
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: prods});
                    } else {
                        dispatch({ type: 'PERKS_SELECTEDPROD', value: []});
                    }
                    
                    // CETC-146567 Check if disney is eligible when perk added without Data change
                    if(promoSection) {
                        const offers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'Offers');
                        let disneyPromoEligible = false;
                        let netmaxEligible = false; 
                        offers?.promos?.forEach(promo => {
                            if(promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_MARKER' || promo?.offerAttrValue === 'DISNEY_BUNDLE_PERK_DISCOUNT' || promo?.offerAttrValue === "DISNEY_BUNDLE_PERK_TRACKER") {
                                disneyPromoEligible = true;
                            }
                            if( promo?.offerAttrValue === 'NETMAX_PERK_DISCOUNT' || promo?.offerAttrValue ==='NETMAX_PERK_MARKER'){ 
                                netmaxEligible = true ; 
                            }
                        });

                        // netmax from special offers -- EC changes

                        const sploffers = promoSection?.subSections?.subSection?.find(sec => sec?.sectionType === 'SpecialOffers');
                         
                        sploffers?.promos?.forEach(promo => {
                            if( promo?.offerAttrValue === 'NETMAX_PERK_DISCOUNT'){ 
                                netmaxEligible = true ; 
                            }
                        });

                        dispatch({ type: 'DISNEY_PROMO_PRESENT', value: disneyPromoEligible });
                        dispatch({ type: 'NETMAX_PROMO_PRESENT', value: netmaxEligible }); // dicount check netmax marker check 
                    }

                    // Call this when we have Removed Streaming Services in cart to update Straming Tiles content.
                    const checkForRemovedStreamingServices = response.data.cartTierPricing.tierContent[0].sections.section.find(sec => sec.sectionName === 'Removed Streaming Services');
                    if(checkForRemovedStreamingServices && 
                       InHomeUtils.isNotNull(checkForRemovedStreamingServices.subSections) && 
                       InHomeUtils.isNotNull(checkForRemovedStreamingServices.subSections.subSection) && 
                       InHomeUtils.isNotNull(checkForRemovedStreamingServices.subSections.subSection.length > 0)){
                        const streamingServicesProds = checkForRemovedStreamingServices.subSections.subSection.find(sub => sub.sectionType === 'STREAMINGSERVICES').products;
                        if(streamingServicesProds?.length > 0){
                            console.log("streamingServicesProds if",streamingServicesProds);
                            fetchStreamingServices(visitId, dispatch); 
                        }  
                        console.log("streamingServicesProds else",streamingServicesProds);
                    }
                }
                console.log('***** perks cart 1');
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
                // if Home Device Support & Protection perks were added or removed from the cart update the buildProduct techsure state
                if (perkProductId === "R3731" || perkProductId === "R3784") {
                    const iwmProducts = response?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.find(sec => sec?.sectionName?.toLowerCase() === "service")?.subSections?.subSection?.find(sec => sec?.sectionType?.toUpperCase() === "VASSTANDALONE")?.products;
                    dispatch({ type: "TECHSURE_SELECTEDPROD", value: iwmProducts ? iwmProducts : null });
                }
                if (flowType === "SUPP") {
                    let updatedSuppProfileCartStatus = store && store.getState && store.getState().supp && store.getState().supp.suppProfileCartStatus;
                    let suppCartupdateStatus = false;
                    if (JSON.stringify(updatedSuppProfileCartStatus).indexOf("ADDED") > -1 || JSON.stringify(updatedSuppProfileCartStatus).indexOf("REMOVED") > -1) {
                        suppCartupdateStatus = true;
                    }
                    console.log('DEBUG: Change Supp flow ', suppCartupdateStatus);
                    dispatch({
                        type: "UPDATE_CART_SUPP",
                        value: suppCartupdateStatus
                    });
                }

                if (flowType === "SUPP") {
                    let suppProfileCartStatus = store && store.getState && store.getState().supp && store.getState()?.supp?.suppProfileCartStatus;
                    let searchTerm = (prodType === Service.internet && product?.speedCode) ? `"speedCode":${product?.speedCode}` : (product?.id || product?.prodId);
                   
                        suppProfileCartStatus[prodType] = getProductStatus(searchTerm, isChecked, prodType) //productStatus;
                        console.log('DEBUG: suppProfileCart',suppProfileCartStatus[prodType])
                    
                    dispatch({
                        type: "UPDATE_PROFILE_CART_STATUS",
                        value: suppProfileCartStatus
                    });
                }
            }
            // const perks = res?.data?.cartTierPricing?.tierContent?[0]?.sections;
            // dispatch({ type: 'PERKS_SELECTEDPROD', value: { response: JSON.parse(jsonString), servType: type }});
            let perkSelectedProduct = InHomeUtils.isNotNull(data) ? data : payload
            if(InHomeUtils.isNotNull(findSelectedprod)){
                perkSelectedProduct = findSelectedprod;
            }
            addToCartSCEvent(visitId, perkSelectedProduct, "BYOPERK", response, "", "", null, flowType, "")
            if(fromPerkToggle && fromPerkToggle === 'Y'){
                let eventVal = !add ? 'AddtoCart': 'RemovefromCart' ;
                updatecartEvent(eventVal,"","");
            }
          }
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "Updating your cart"} })
      })
      .catch(error => {
          console.log('***** perks in error', error);
          errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "Updating your cart"} })
          addToCartSCEvent(visitId, payload, "BYOPERK", "", "", "",  null, flowType, "" )

          
      });
    }
    catch (ex) {
      console.log('***** perks in JS exception ', ex);
      catchJSException('BuildProduct', visitId, 'getCommonDisclaimer', ex);
    }
};

export const GetShoppingCartProducts = (visitId, dispatch, signInState, buildProductState, cart, lqState, isPreSelection=false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'GetShoppingCartProducts', "Inside GetShoppingCartProducts"));
        logKafka("INFO", "BuildProduct", "Inside GetShoppingCartProducts", kafkaPageLogs, "applogs", visitId);
        let cartResult = false;
        let isPegaFlow = store.getState().pega.isPegaFlow
        let url = apiUrl().getCartAcc + '/' + visitId;
        loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data)
                    && InHomeUtils.isNotNull(response.data.cartTierPricing)
                    && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                    && response.data.cartTierPricing.tierContent.length > 0) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, kafkaPageLogs, "applogs", visitId);

                    try {
                        if (InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0])
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections)
                            && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection)
                            && response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection.length > 0) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, PAGEACTIVITY.UA));
                            logKafka("INFO", "BuildProduct", "CART BUNDLE PRICE : " + response.data.cartTierPricing.tierContent[0].sections.section[0].subSections.subSection[0].sectionTotalprice, getErrorLogUrl, "applogs", visitId);
                            // isSubSectionsValid = true;
                            if (InHomeUtils.isNotNull(cart) ) {
                                let cartDataOnResume = getCartDataDefault();
                                cartDataOnResume = getCartData(response.data.cartTierPricing.tierContent, visitId);
                                cart.cartResponse=response.data.cartTierPricing;
                                cart.cartHeader= getCartHeader(response.data.cartTierPricing.tierContent,visitId);
                                cart.cartData= cartDataOnResume;
                                cart.cartOrderDetail=response.data.orderDetail;
                            }
                        }
                    }
                    catch (ex) {
                        catchJSException(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', ex);
                    }
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateCart', "CART TIER CONTENT EMPTY", PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "CART TIER CONTENT EMPTY", kafkaPageLogs, "applogs", visitId);
                }

                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                        cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                    }
                });
                
                let cartProducts = getCartProducts(response.data.cartTierPricing, visitId);
                let profileTvProductId = store.getState().ecProfileCart &&  store.getState().ecProfileCart.ProfileTVProduct && store.getState().ecProfileCart.ProfileTVProduct.prodId;
                if(cartProducts.TvProduct != null){
                    let selectedTvProductId = InHomeUtils.isNotNull(cartProducts.TvProduct) && cartProducts.TvProduct.tvProd[0] && cartProducts.TvProduct.tvProd[0].prodId;
                    if(selectedTvProductId === false){
                        selectedTvProductId = getSelectedTv(response.data.cartTierPricing, visitId).prodId
                    }
                    if(selectedTvProductId || profileTvProductId){
                        fetchChannel(dispatch, visitId, selectedTvProductId ? selectedTvProductId : profileTvProductId)
                    }
                }
                
                //console.log("cart**",response.data.cartTierPricing)
                if(signInState && signInState.isTVQualified){
                    fetchVRoom(dispatch, visitId);
                    fetchCeapps(dispatch, visitId, false);
                    fetchChannel(dispatch, visitId, profileTvProductId);
                    fetchIntrChannel(dispatch, visitId, profileTvProductId);
                }
                
                if(isPreSelection == true || isPreSelection == 'goBackToMM2'){
                    let cartData = store.getState().cart;
                    let isLocalTVInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                    let selectedCoreServices = (InHomeUtils.isNotNull(response.data.cartTierPricing) && InHomeUtils.isNotNull(response.data.orderDetail) && InHomeUtils.isNotNull(response.data.orderDetail.servicesOrdered))
                    ? response.data.orderDetail.servicesOrdered : (InHomeUtils.isNotNull(cartData) && InHomeUtils.isNotNull(cartData.cartOrderDetail) && InHomeUtils.isNotNull(cartData.cartOrderDetail.servicesOrdered)) ? cartData.cartOrderDetail.servicesOrdered : null;
                    let VecContractServices=InHomeUtils.isNotEmpty(signInState)&&InHomeUtils.isNotEmpty(signInState.response)&&InHomeUtils.isNotEmpty(signInState.response.hoaServiceType)?signInState.response.hoaServiceType:"";
                    let addlInfo = {
                        zip: signInState.response.zipCode,
                        tarCode: signInState.response.tarCode,
                        state: signInState.response.state,
                        couponFlowType: lqState.couponFlowType,
                        EquipmentState: buildProductState.loadedEquipments,
                        masterpackageview: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.masterpackageview) ? buildProductState.tv.masterpackageview : [],
                        selectedProductId: '',
                        isFCPflow: signInState.response.userProfile.isFcpInProfile,
                        isAlaCarte: false,
                    }
                   doPrefetch('', dispatch, visitId, addlInfo, 'MTM', '', false, isLocalTVInCart, '', '', false, selectedCoreServices, VecContractServices);
                }
                DispatchSelectedCoreService(response.data.orderDetail, dispatch)
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }) //No need to wait loader for backend work process prefetch call so close loader here...
                if(isPreSelection == 'clearCart' || (isPreSelection && isPegaFlow)){
                    if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {                    
                        let dataPerkProduct = cartProducts.DataProduct.dataProd.filter(prod => prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE' );
                            if ( InHomeUtils.isNotNull(dataPerkProduct) && dataPerkProduct !== undefined && dataPerkProduct) {                            
                                setTimeout(() =>{
                                    setDataPerksForSC_ECFlows(response.data.cartTierPricing, buildProductState, 'AF', visitId, dispatch, false)
                                }, 3000)    
                            }                    
                        buildProductState.validatePerksForSCFlows = true;
                        dispatch({ type: "VALIDATE_PERKS_FOR_SCFLOWS", value: true });
                    }
                   isPreSelection = true;
                }
                if(isPreSelection == 'goBackToMM2'){
                    isPreSelection = false;
                    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                }
                PreselectCartProducts(cartProducts, lqState, dispatch, visitId, '', null, buildProductState, signInState, cart, null, false, isPreSelection);

                //Smartcart changes for EC flow
                if (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd) && cartProducts.TvProduct.tvProd.length > 0) {
                    let tvServiceInCart = cartProducts.TvProduct.tvProd.filter(p => p.prodType === 'BASIC');
                    if (InHomeUtils.isNotNull(signInState.isECSmartcart) && signInState.isECSmartcart == true && InHomeUtils.isNotNull(tvServiceInCart) && tvServiceInCart.length > 0 && InHomeUtils.isNotNull(tvServiceInCart[0].prodId) && InHomeUtils.isNotEmpty(tvServiceInCart[0].prodId)) {
                        fetchChannel(dispatch, visitId, tvServiceInCart[0].prodId);
                    }
                }

                if (signInState.response.classicToFcp || signInState.response.source === "PegaNoThanksLink"){
                //M&M2.0 Changes
                if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd) && cartProducts.DataProduct.dataProd.length > 0) {
                    let dataServiceInCart = cartProducts.DataProduct.dataProd.filter(p => p.prodType === 'FTTPD');
                    if (dataServiceInCart && dataServiceInCart[0]) {
                        fetchTechSure(dispatch, visitId);
                        fetchRouter(dispatch, visitId);    // CETC-142322 fix
                    }
                }
                    //dispatch({ type: 'SET_DEFAULT_ACCORDION', value:'' });
                }
                if(isPreSelection == false && (signInState.response.flowRoute == '' || signInState.response.flowRoute == "INTERNETUPGRADE" || signInState.response.flowRoute == "ACCOUNTREVIEW" || signInState.response.classicToFcp) && signInState.response.source !== 'mvapp'){ //Added source not equal to mva for CXTDT-354521 - fix
                    setTimeout(() =>{
                        dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internetSubAccOpen,voice,tv,contract,sploffer,streamserv" });
                    }, 5000)
                }
            }
            else { //error while updating cart
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateCart', "updateCart - Failed"));
                logKafka("ERROR", "UpdateCart", "updateCart - Failed", getErrorLogUrl, "applogs", visitId);
                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
        })
            .catch(error => {
                let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
                //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'BindCartProductsDOFlow', ex);
    }
};

const clearDataSubProducts = (dispatch, selectedCoreServices) => {
    dispatch({ type: 'TECHSURE_SELECTEDPROD', value: null });
    dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: null });
    dispatch({ type: 'FNE_SELECTEDPROD', value: null });
    dispatch({ type: 'SET_WHOLE_WIFI_STATUS', value: null});
    dispatch({ type: 'SET_WHOLE_WIFIPLUS_STATUS', value: null});
    dispatch({ type: 'SET_WHOLE_WIFIPLUS2_STATUS', value: null});
    if (selectedCoreServices === '') {
        dispatch({ type: 'ROUTER_SELECTEDPROD', value: null });
    }

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "internet" });
}

const clearVideoSubProducts = (dispatch, selectedCoreServices) => {
    dispatch({ type: 'DCT_SELECTEDPROD', value: null });
    dispatch({ type: 'VROOM_SELECTEDPROD', value: null });
    dispatch({ type: 'RECORDING_SELECTEDPROD', value: null });
    dispatch({ type: 'CHANNEL_SELECTEDPROD', value: null });
    if (selectedCoreServices === '') {
        dispatch({ type: 'ROUTER_SELECTEDPROD', value: null });
    }
    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "tv" });
}

const clearVoiceSubProducts = (dispatch) => {
    dispatch({ type: 'WINBACK_SELECTEDPROD', value: null });
    dispatch({ type: 'LISTING_SELECTEDPROD', value: null });
    dispatch({ type: 'BATTERY_SELECTEDPROD', value: null });
    dispatch({ type: 'BBUSHIPMENT_SELECTEDPROD', value: null });
    dispatch({ type: 'CALLINGFEATURE_SELECTEDPROD', value: null });
    dispatch({ type: 'INTLPLAN_SELECTEDPROD', value: null });
    dispatch({ type: 'LONGDISTANCE_SELECTEDPROD', value: null });
    dispatch({ type: 'WIREMAINTENANCE_SELECTEDPROD', value: null });

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "voice" });
}

const clearStreamService = (dispatch) => {
    dispatch({ type: 'OTTBASIC_SELECTEDPROD', value: null });
    dispatch({ type: 'OTTEQUIPNRC_SELECTEDPROD', value: null });
    dispatch({ type: 'STREAMDEVCNT_SELECTEDPROD', value: null });

    dispatch({ type: 'TOGGLE_OTHER_ACCOR', value: "stream" });
}

export const toggleMessage = (dispatch) => {
    dispatch({ type: 'TOGGLE_MESSAGE', value: "" });
}

export const toggleBatteryMessage = (dispatch) => {
    dispatch({ type: BuildProduct.toggleBatteryMsg, value: "" });
}

export const toggleDctMessage = (dispatch) => {
    dispatch({ type: BuildProduct.toggleDctMsg, value: "" });
}

export const toggleTVMoreOption = (dispatch) => {
    dispatch({ type: BuildProduct.toggleTVMoreOpt, value: "" });
}

export const SweetnerMsg = (SweetnerMessage, dispatch) => {

    dispatch({
        type: BuildProduct.SweetnerMsg,
        value: { currentMsg: InHomeUtils.isNotNull(SweetnerMessage[0]) ? SweetnerMessage[0] : "", prevMsg: InHomeUtils.isNotNull(SweetnerMessage[1]) ? SweetnerMessage[1] : "", isDisplay: SweetnerMessage[2] }
    });
}

export const bannerContent = (dispatch) => {
    let value =
    {
        headerText: "No one delivers entertainment to your home like Fios.", footerText: "The best deserves the best. Save $10 off your Verizon Wireless bill and your Verizon Fios bill - a total savings of $20 per month",
        bodyText: "Sign up for a qualifying Fios Triple Play bundle with a 2-year agreement and get one year of Netflix premium plan on us. Already have Netflix? We'll cover the cost for one year.",
        imgUrl: "desk-ordering-page-hero-netflix.jpg"
    }
    dispatch({ type: 'BANNER_UPDATED', value: value });
}

export const resetTNStatus = (dispatch) => {
    dispatch({ type: 'UPDATE_WB_PH1', value: '' })
    dispatch({ type: 'UPDATE_WB_PH2', value: '' })
    dispatch({ type: 'UPDATE_WB_PH3', value: '' })
    dispatch({ type: 'UPDATE_PORTEDTN', value: '' })
    dispatch({ type: 'UPDATE_TNPORTABILITY', value: false })
}

export const tnPortableCheck = (tn, dispatch, visitId, isDoFlow) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'tnPortableCheck', "Inside tnPortableCheck"));
        logKafka("INFO", "UpdateCart", "Inside tnPortableCheck", kafkaPageLogs, "applogs", visitId);

        let url = apiUrl().checkportability + '/checkportability';
        let request = JSON.stringify({ "tn": tn, "lineNo": 1 })
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });

        api(url, 'POST', request).then(response => {
            // response={
            //     "meta": {
            //         "code": 200.01,
            //         "description": "Portability Completed successfully .",
            //         "timestamp": "Fri Nov 16 11:09:42 UTC 2018"
            //     },
            //     "data": {
            //         "isPortable": "Y",
            //         "isCharged": "true"
            //     }
            // }
            dispatch({ type: 'UPDATE_PORTEDTN', value: tn })
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tnPortableCheck', "tnPortableCheck - Success"));
                logKafka("INFO", "UpdateCart", "tnPortableCheck - Success", kafkaPageLogs, "applogs", visitId);                
                if (response.data.isPortable === "Y") {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tn - PORTABLE", PAGEACTIVITY.UA));
                    logKafka("INFO", "UpdateCart", "tn - PORTABLE", kafkaPageLogs, "applogs", visitId);
                    tempSCData.detailPageName = "ec| services overview | phone| winback| current phone number eligible";
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tn - NONPORTABLE", PAGEACTIVITY.UA));
                    logKafka("INFO", "UpdateCart", "tn - NONPORTABLE", kafkaPageLogs, "applogs", visitId);
                    tempSCData.detailPageName = "ec| services overview | phone| winback| current phone number ineligible";
                }
                updateSCcustomEvent("winBackPage", "ddAddToCartEvent", "detailPageName")
                dispatch({ type: 'UPDATE_TNPORTABILITY', value: (response.data.isPortable === "Y" ? true : false) });
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'tnPortableCheck', "tnPortableCheck - FAIL", PAGEACTIVITY.UA));
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:tnPortableCheck,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'tnPortableCheck', ex);
    }
};

export const updateTn = (type, value, dispatch) => {
    dispatch({ type: 'UPDATE_WB_' + type, value: value });
    dispatch({ type: 'UPDATE_PORTEDTN', value: '' })
    dispatch({ type: 'UPDATE_TNPORTABILITY', value: false })
}

export const fetchPostSoc = (dispatch, visitId, showLoader = false, postSoc = '') => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPostSoc', "Inside fetchPostSoc"));
        logKafka("INFO", "UpdateCart", "Inside fetchPostSoc", kafkaPageLogs, "applogs", visitId);
        if (showLoader) {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Estimating your first month bill", isLoaderImg: "loader" } });
        }
        let jsonstr = JSON.stringify({ flowtype: 'BAU' });
        let url = apiUrl().fbePostSoc;
        return new Promise((resolve, reject) => {
             api(url, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchPostSoc', "fetchPostSoc - Success"));
                logKafka("INFO", "UpdateCart", "fetchPostSoc - Success", kafkaPageLogs, "applogs", visitId);
                dispatch({ type: 'POST_SOC', value: response.meta.description });
                if (showLoader){
                    setTimeout(() => {
                        fetchGetSoc(dispatch, visitId);
                    },3000)
                }                    
            }
            else {
                postSoc == 'postSoc' && modalAction.openModalWindow("SOC", dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchPostSoc', "fetchPostSoc - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchPostSoc,errorMessage:API Response error`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            resolve(response)
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchPostSoc,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                reject(error)
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        })
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchPostSoc', ex);
    }
};

export const fetchGetSoc = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchGetSoc', "Inside fetchGetSoc"));
        logKafka("INFO", "BuildProduct", "Inside fetchGetSoc", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().fbeGetSoc;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data)) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchGetSoc', "fetchGetSoc - Success"));
                logKafka("INFO", "BuildProduct", "fetchGetSoc - Success", kafkaPageLogs, "applogs", visitId);
                dispatch({
                    type: 'GET_SOC',
                    value: response.data
                });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                modalAction.openModalWindow("SOC", dispatch);
            }
            else {
                modalAction.openModalWindow("SOC", dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchGetSoc', "fetchGetSoc - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                let errorMsg = `MethodName:fetchGetSoc,errorMessage:API Response error`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                //errorAction("LBO", "BuildProduct", error.message, "applogs", visitId, dispatch, true, "FirstBillEstimate");
                let errorMsg = `MethodName:fetchGetSoc,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchGetSoc', ex);
    }
};

export const getMon = (dispatch, visitId, stateFromLq, isGetMonFailed = false) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getMon', "Inside getMon"));
        logKafka("INFO", "BuildProduct", "Inside getMon", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().getMon;

        if (InHomeUtils.isNotEmpty(stateFromLq))
            url = apiUrl().getMon + "?serviceState=" + stateFromLq

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getMon', "getMon - Success"));
                logKafka("INFO", "BuildProduct", "getMon - Success", kafkaPageLogs, "applogs", visitId);
                dispatch({ type: BuildProduct.monNo, value: response.data.mon });
                monInvoked(true, dispatch)
            }
            else if (!isGetMonFailed) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + PAGEACTIVITY.MSG.notAvailable + "ReAttempt", PAGEACTIVITY.UA));
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getMon', "Triggering getMon again"));
                logKafka("INFO", "BuildProduct", "Triggering getMon again", kafkaPageLogs, "applogs", visitId);
                getMon(dispatch, visitId, stateFromLq, true);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'getMon', "getMon - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", "getMon - " + PAGEACTIVITY.MSG.apiResponseFailed, getErrorLogUrl, "applogs", visitId);
                errorAction("LBO", "BuildProduct", 'MON generation failed', "applogs", visitId, dispatch, true, "MONGENFailed");
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getMon,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                // errorAction("LBO","BuildProduct",error.message,"applogs",visitId,dispatch,true,"MONGENFailed");  
                errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getMon', ex);
    }
}

export const socInvoked = (status, dispatch) => {
    dispatch({ type: BuildProduct.socInvoked, value: status })
};

export const monInvoked = (status, dispatch) => {
    dispatch({ type: BuildProduct.monInvoked, value: status })
};

export const setResumedMON = (status, dispatch) => {
    dispatch({ type: BuildProduct.monNo, value: status })
};

export const customRouterCheck = (status, dispatch) => {
    dispatch({ type: BuildProduct.cutomeRouterCheck, value: status })
};

export const testdriveOptOut = (status, dispatch) => {
    dispatch({ type: 'TESTDRIVEOPTOUT', value: status })
};

export const updateCheckoutBtnStatus = (val, dispatch) => {
    dispatch({ type: BuildProduct.updateCheckoutBtnStatus, value: val })
}

export const couponErr = (status, dispatch) => {
    dispatch({ type: "COUPONVALIDATIONERROR", value: status })
};

export const validateInputcoupon = (action, dispatch) => {
    dispatch({ type: "COUPONVALIDATION", value: action });
}

export const updateGPONINOTContract = (action, dispatch) => {
    dispatch({ type: "UPDATE_GPONIONT_CONTRACT", value: action });
}

export const updateVideoContract = (action, dispatch) => {
    dispatch({ type: "UPDATE_VIDEO_CONTRACT", value: action });
}

export const updateContractStatus = (action, dispatch) => {
    dispatch({ type: "UPDATE_CONTRACT_STATUS", value: action });
}

export const viewDetailsDecide = (modalId, prodType, visitId, dispatch,buildProduct) => {
    if(!(store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.viewdetailsaem && store.getState().loopQual.runtimeKey.viewdetailsaem.toUpperCase() === 'N')) {
       let QAM_Type = '';
       if(store.getState().loopQual.runtimeKey?.QAM === 'Y' && (buildProduct.tv.streamTvEligible || buildProduct.tv.AndriodUpgradeEligible))
       {
        QAM_Type = 'QAM';
       }
       viewDetails(modalId, prodType, visitId, dispatch, QAM_Type);
        // viewDetailsFromAEM(modalId, prodType, visitId, dispatch, QAM_Type);
    }
 }
export const processViewDetails = (usoc, modalId, serviceType, viewDetailObj, dispatch) => {
   let prodViewDetail = viewDetailObj[serviceType][usoc];
   if (prodViewDetail && prodViewDetail.longdesc) {
       let displayText = prodViewDetail.longdesc.replace(/u003C/g, '<')
           .replace(/u003E/g, '>')
           .replace(/\\\'/g, "'")
    
       modalAction.openModalWindow(modalId, dispatch);
       dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: displayText });
   }
}
export const viewDetailsFromAEM = (modalId, prodType, visitId, dispatch, QAM_Type = "") => {
   try {
       dispatch({
           type: 'LOADER_ACTIVE',
           value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
       });
       logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "Inside viewDetails"));
       let serviceType = 'DAT';
       let usoc = modalId;
       if ((modalId.indexOf('DETAIL') > -1) || (modalId.indexOf('SPLOFFER') > -1) || (modalId.indexOf('FLASHOFFER') > -1)) {
           usoc = modalId.split('_')[1];
           if (QAM_Type === 'QAM' && ((usoc === 'N0017') || (usoc === 'N0018') || (usoc === 'N0020'))) {
               usoc = `${usoc}_QAM`
           }
       }
       if (InHomeUtils.isNotNull(usoc) && usoc === 'R0276') {
           const isNYDMASpeed = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
           const speedCode = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.selectedProduct && store.getState().buildProduct.internet.selectedProduct.speedCode;

           if (isNYDMASpeed && speedCode === '940') {
               usoc = usoc + '_500';
           }
       }
       // if(prodType === Service.voice) {
       //     const isNYDMA = store && store.getState && store.getState().loopQual && store.getState().loopQual.lqQualdetails && store.getState().loopQual.lqQualdetails.getAdditionalInfo && store.getState().loopQual.lqQualdetails.getAdditionalInfo.isNYDMA;
       //     usoc = isNYDMA ? usoc+'0' : usoc;
       // }
       switch (prodType) {
           case Service.internet:
           case Service.router:
           case Service.customRouter:
           case Service.techSure:
           case Service.streamServ:
               serviceType = 'DAT';
               break;

           case Service.tv:
           case Service.customTV:
           case Service.vRoom:
           case Service.recording:
           case Service.channel:
           case Service.intrnlChnl:
               serviceType = 'VID';
               break;

           case Service.voice:
           case Service.intlPlans:
           case Service.listing:
           case Service.battery:
           case Service.callingFeature:
           case Service.batteryshipment:
               serviceType = 'FDV';
               break;
           default:
               serviceType = 'DAT';
               break;
       }
       let url = `${apiUrl().viewDetailAEM}${serviceType === 'DAT' ? 'data' : serviceType === 'VID' ? 'tv' : 'voice'}.json`;
       if ( store && store.getState && store.getState().buildProduct && store.getState().buildProduct.viewDetails) {
           if ((usoc !== 'R3587' && usoc !== 'R3585' && usoc !== 'R3583') && (serviceType === 'DAT' && store.getState().buildProduct.viewDetails.DAT) || (serviceType === 'VID' && store.getState().buildProduct.viewDetails.VID) || (serviceType === 'FDV' && store.getState().buildProduct.viewDetails.FDV)) {
               processViewDetails(usoc, modalId, serviceType, store.getState().buildProduct.viewDetails, dispatch)
               dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
           }
           else {
               console.log("AEMDATA CALL");
               api(url, 'GET', '', 'text/plain').then(response => {
                   if (typeof response === 'string' && response) {
                       
                       logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsFromAEM', "viewDetailsFromAEM - Success"));
                       console.log('View detail response');
                       let jsonString = response
                           .replace(/^\s+|\s+$/g, "")
                           .replace(/\s+/g, " ")
                           .replace(/\\n/g, "\\n")
                           .replace(/\'/g, "\\\\'")
                           .replace(/\/\//g, "\\\/\\/")
                           .replace(/\\r/g, "\\r")
                           .replace(/\\t/g, "\\t")
                           .replace(/\\b/g, "\\b")
                           .replace(/\\f/g, "\\f")
                           .replace(/\</g, 'u003C')
                           .replace(/\>/g, 'u003E');
                       //let uint8array = new TextEncoder("utf-8").encode(jsonString);
                       //let resstring = new TextDecoder("utf-8").decode(uint8array);
                       //     console.log(JSON.parse(resstring));
                       response = JSON.parse(jsonString);
                       console.log("AEMDATA CALL response", response);
                       if (response && response.Products && response.Products.length) {
                           let parsedResponse = {};
                           response.Products.forEach(item => {
                               let viewdetailsidentifier = item.identifier ? item.identifier : '';
                               parsedResponse[viewdetailsidentifier] = { ...item };
                           });

                       // We can remove this once this once The Rskn change implemented
                       if(usoc === 'R3587' || usoc === 'R3585' || usoc === 'R3583'){
                           const cmsProds = midniteProds?.Products || [];
                           const classicProds = cmsProds?.filter(product => product?.longdesc).find(item => item?.identifier === usoc)
                           parsedResponse[usoc] = classicProds
                       }
                           let viewDetailObj = {};
                           viewDetailObj[serviceType] = parsedResponse;
                           dispatch({ type: 'VIEW_DETAILS_AEM_UPDATE', value: viewDetailObj });
                           processViewDetails(usoc, modalId, serviceType, viewDetailObj, dispatch)
                       }
                       dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                   }
                   else {
                       logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsFromAEM', "viewDetailsFromAEM - Failed"));
                       dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                       viewDetailsExpApi(modalId, prodType, visitId, dispatch, QAM_Type = "");
                   }
               }).catch(error => {
                   let errorMsg = `MethodName:viewDetailsFromAEM,errorMessage:${error.message}`;
                   logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                   // vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                   errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
                   dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: '' });
                   dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
               });
           }
       }
   }
   catch (ex) {
       catchJSException('BuildProduct', visitId, 'viewDetails', ex);
   }
}

export const getPerksAEM = async (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPerksAEM', "Inside getPerksAEM"));
        let getPerksUrl = apiUrl()?.getPerksAEM;
        api(getPerksUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                const jsonString = response
                console.log("***perks",JSON.stringify(jsonString))
                dispatch({ type: 'ALL_PERKS_AEM_FRAGMENTS', value: { response: jsonString, servType: 'perks' }});
            }
        })
        .catch(error => {
            errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPerksFromAEM', ex);
        return null;
    }
}

export const viewDetails = (modalId, prodType, visitId, dispatch) => {
    let QAM_Type = store.getState().loopQual?.runtimeKey?.QAM === 'Y' && store.getState().loopQual?.lqResponse ?.ontPonType !== 'BPON' ? 'QAM' : '';
    console.log("viewDetailsExpApi 6166", modalId, prodType, visitId, dispatch,QAM_Type);
    viewDetailsFromAEM(modalId, prodType, visitId, dispatch, QAM_Type);
    if (!(store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.viewdetailsaem && store.getState().loopQual.runtimeKey.viewdetailsaem.toUpperCase() === 'N')) {
        viewDetailsFromAEM(modalId, prodType, visitId, dispatch, QAM_Type);
    }
    else {
        viewDetailsExpApi(modalId, prodType, visitId, dispatch, QAM_Type);
    }
}
export const viewDetailsExpApi = (modalId, prodType, visitId, dispatch,QAM_Type="") => {
    console.log("viewDetailsExpApi 7176", modalId, prodType, visitId, dispatch,QAM_Type);
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Lets wait for a moment, we are processing your request.", isLoaderImg: "loader" }
        });
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsExpApi', "Inside viewDetailsExpApi"));
        logKafka("INFO", "BuildProduct", "Inside viewDetailsExpApi", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().viewDetail;        
        // let usoc = modalId;
        // if (modalId.indexOf('DETAIL') > -1) {
        //     usoc = modalId.split('_')[1];
        // }
        let usoc = modalId;
        console.log("modalIdmodalId",modalId, prodType, visitId, dispatch,QAM_Type="")
    
        if ((modalId.indexOf('DETAIL') > -1) || (modalId.indexOf('SPLOFFER') > -1) || (modalId.indexOf('FLASHOFFER') > -1)) {
            usoc = modalId.split('_')[1];
            if(QAM_Type === 'QAM'){
                usoc = `${usoc}_QAM`
            }
        }
        switch (prodType) {
            case Service.internet:
            case Service.router:
            case Service.fne:
            case Service.customRouter:
            case Service.techSure:
                url += '/DAT/' + usoc;
                break;
            case Service.techSureCloud:
                url += '/DAT/' + usoc;
                break;
            case Service.tv:
            case Service.customTV:
            case Service.vRoom:
            case Service.recording:
            case Service.channel:
            case Service.intrnlChnl:
                url += '/VID/' + usoc;
                break;
            case Service.intlPlans:
                url += '/FDV/' + usoc;
                break;
            case Service.voice:
            case Service.listing:
            case Service.battery:
            case Service.callingFeature:
            case Service.batteryshipment:
                url += '/FDV/' + usoc;
                break;
            default:
                url += '/DAT/' + usoc;
                break;
        }
        
        api(url, 'GET', '').then(response => {
            // response.data = "<div><h5 style='width: 90%;'>discovery+ (Ad - Free) on us.</h5></div><br><div style='display: inline-block; vertical-align: middle; width: 41.6667%;'><img src='https://wwwawssit.ebiz.verizon.com/content/dam/verizon/personal/accordion-images/banners/Discovery+_Logo.jpg' alt=''></img></div><br><br><div><b>Introducing discovery+. Stream what you love! </b></div><br><div>The only streaming service with the greatest real-life entertainment … your favorite brands and personalities, plus exclusive originals, all in one place. Whatever you’re into, you’ll find it here. </div><br><div>With discovery+, you get: </div><br><div>- <b>Favorite</b> shows and personalities from the most beloved TV brands including HGTV, Food Network, TLC, ID, Animal Planet, Discovery Channel and more </div><br><div>- <b>Exclusive</b> discovery+ Originals - can’t-miss, exciting new series you won't see anywhere else </div><br><div>- <b>All</b> 55,000+ episodes and 2,500+ shows - more added all the time</div><br><div> - <b>Ad-Free</b> option to enjoy full seasons of current favorites and classic shows, all without commercial interruption </div><br><div>- <b>Award</b> winning collection of the best natural history series from Discovery and BBC - including Planet Earth, Blue Planet and Frozen Planet </div><br><div>- <b>Fresh</b> new series added all the time - from lifestyle and true crime to home improvement, food, adventure and more </div><br><div>- <b>Full</b> access to watch anytime, anywhere on your mobile device, tablet, computer, game console and connected TV</div>";
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsExpApi', "viewDetailsExpApi - Success"));
                logKafka("INFO", "BuildProduct", "viewDetailsExpApi - Success", kafkaPageLogs, "applogs", visitId);
                modalAction.openModalWindow(modalId, dispatch);
                dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: response.data });
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetailsExpApi', "viewDetailsExpApi - Failed"));
                logKafka("ERROR", "BuildProduct", "viewDetailsExpApi - Failed", getErrorLogUrl, "applogs", visitId);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }).catch(error => {
            let errorMsg = `MethodName:viewDetailsExpApi,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            dispatch({ type: 'UPDATE_VIEWDETAILCONTENT', value: '' });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'viewDetailsExpApi', ex);
    }
}

export const getDetailsAdditionalChannels = (prodId, dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "Inside viewDetails"));
        logKafka("INFO", "BuildProduct", "Inside viewDetails", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().viewDetail + '/VID/' + prodId;
        dispatch({ type: "LOADER_FOR_CHANNEL_EQUIPMENTS" })
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "viewDetails - Success"));
                logKafka("INFO", "BuildProduct", "viewDetails - Success", kafkaPageLogs, "applogs", visitId);

                let payload = {
                    prodId,
                    description: response.data
                }
                dispatch({ type: "UPDATE_CHANNEL_DESC", payload })
                dispatch({ type: "LOADER_FOR_CHANNEL_EQUIPMENTS" })

            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'viewDetails', "viewDetails - Failed"));
                logKafka("ERROR", "BuildProduct", "viewDetails - Failed", getErrorLogUrl, "applogs", visitId);
            }

        }).catch(error => {
            let errorMsg = `MethodName:viewDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");

        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'viewDetails', ex);
    }

}

export const tellMeDetails = (prodType, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "Inside tellMeDetails"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        let url = apiUrl().viewDetail + '/DAT/';

        if (prodType.indexOf('HELP') > -1) {
            url += prodType.substring(4);
        } else {
            url += prodType;
        }

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "tellMeDetails - Success"));
                modalAction.openModalWindow(prodType, dispatch);
                //dispatch({ type: 'UPDATE_TELLMECONTENT', value: response.data });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return response.data;
            } else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'tellMeDetails', "tellMeDetails - Failed"));
                //dispatch({ type: 'UPDATE_TELLMECONTENT', value: '' });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return "";
            }
        }).catch(error => {
            let errorMsg = `MethodName:tellMeDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            //dispatch({ type: 'UPDATE_TELLMECONTENT', value: '' });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return "";
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'tellMeDetails', ex);
    }
}

export const seeFcpDetails = (prodType, visitId, dispatch, usocList) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "Inside seeFcpDetails"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        let url = apiUrl().seeFcpDetail + "/" + usocList;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "seeFcpDetails - Success"));
                dispatch({ type: BuildProduct.fcpSeeDetails, value: response.data });
                modalAction.openModalWindow(prodType, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return response.data;
            } else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'seeFcpDetails', "seeFcpDetails - Failed"));
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                return "";
            }
        }).catch(error => {
            let errorMsg = `MethodName:seeFcpDetails,errorMessage:${error.message}`;
            logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "BuildProduct", error.message, "applogs", visitId, dispatch, false, "");
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return "";
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'seeFcpDetails', ex);
    }
}

export const doPrefetch = (action, dispatch, visitId, stateInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart,
    isDCTinCart, isDoFlow, isChecked = false, serviceInCart = null,VecContractServices='') => {
    prefetchAction.prefetch(action, dispatch, visitId, stateInfo, contract, selectedCoreServices, isContractSwitched, isLocalTVInCart,
        isDCTinCart, isDoFlow, isChecked, serviceInCart,VecContractServices);
}

export const setDCTEligibility = (dispatch, state) => {
    let eligible = false;
    if (InHomeUtils.isNotEmpty(state) && state === "MD")
        eligible = true;
    dispatch({
        type: 'SET_DCT_ELIGIBLE',
        value: eligible
    });
}

export const fetchInternetSubProducts = (dispatch, visitId) => {
    //fetchRouter(dispatch, visitId);
    logKafka("INFO", "BuildProduct", "Inside fetchInternetSubProducts", kafkaPageLogs, "applogs", visitId);
    fetchFne(dispatch, visitId);
    fetchTechSure(dispatch, visitId);
}

export const fetchTVSubProducts = (dispatch, visitId, couponFlowType = null, selectedProdId, userState = null) => {
    //fetchRouter(dispatch, visitId);
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchTVSubProducts', "Inside fetchTVSubProducts"));
    logKafka("INFO", "BuildProduct", "Inside fetchTVSubProducts", kafkaPageLogs, "applogs", visitId);
    fetchVRoom(dispatch, visitId);
    fetchRecording(dispatch, visitId, couponFlowType);
    fetchChannel(dispatch, visitId, selectedProdId);
    fetchDCT(dispatch, visitId);
}

export const fetchVoiceSubProducts = (dispatch, visitId, enableMixmatch2) => {
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoiceSubProducts', "Inside fetchVoiceSubProducts"));
    logKafka("INFO", "BuildProduct", "Inside fetchVoiceSubProducts", kafkaPageLogs, "applogs", visitId);
    if(enableMixmatch2) {
        fetchIntlPlans(dispatch, visitId)
    }
    fetchListing(dispatch, visitId);
    fetchBackup(dispatch, visitId);
}

export const fetchExistingVoiceSubProducts = (dispatch, visitId) => {
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchVoiceSubProducts', "Inside fetchVoiceSubProducts"));
    logKafka("INFO", "BuildProduct", "Inside fetchExistingVoiceSubProducts", kafkaPageLogs, "applogs", visitId);
    fetchCallingFeatures(dispatch, visitId);
    fetchIntlPlans(dispatch, visitId);
    // fetchLongDistance(dispatch, visitId);
    fetchWireMaintenance(dispatch, visitId);
    fetchExistingListing(dispatch, visitId);
}

export const updatecontractforSC = (contract, flag, dispatch, couponFlowType = null) => {
    let contractUpdated = {
        contract: contract,
        tileFlag: true,
        isEmpFlow: false
    }
    if (InHomeUtils.isNotEmpty(contract) && contract === "MTM") {
        contractUpdated.tileFlag = false;
        if (InHomeUtils.isNotNull(flag) && flag) {
            contractUpdated.tileFlag = true;
        }
    }
    if (InHomeUtils.isNotEmpty(couponFlowType) && (couponFlowType === "Employee" || couponFlowType === "Retiree")) {
        contractUpdated.isEmpFlow = true;
    }
    dispatch({ type: BuildProduct.contractInSmartCart, value: contractUpdated })
};

export const updateContractAccordionStatus = (dispatch, val) => {
    dispatch({ type: BuildProduct.updateContractAccordionStatus, value: val })
};

export const getofferDisclaimer = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getofferDisclaimer', "Inside getofferDisclaimer"));
        logKafka("INFO", "BuildProduct", "Inside getofferDisclaimer", kafkaPageLogs, "applogs", visitId);
        let getVzIdUrl = apiUrl().getDisclaimer;
        console.log('fragment url', getVzIdUrl)
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                console.log('fragment response', response)
                dispatch({ type: 'DISCLAIMER_CONTENT_FRAGMENTS', value: response });
            }
                
        })
            .catch(error => {
                logKafka("ERROR", "BuildProduct", error.message, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getofferDisclaimer', ex);
    }
}

export const getofferDisclaimerFromAEM = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getofferDisclaimerFromAEM', "Inside getofferDisclaimerFromAEM"));
        logKafka("INFO", "BuildProduct", "Inside getofferDisclaimerFromAEM", kafkaPageLogs, "applogs", visitId);
        let getVzIdUrl = apiUrl().getDisclaimerAEM;
        console.log(getVzIdUrl,'fragment url')
        api(getVzIdUrl, 'GET', '').then(response => {
            if (response && response.items && response.items.length){
                let parsedResponse = {};
                response.items.forEach(item => {
                    let discpromoidentifier = (item.promoid ? item.promoid : '') + '~' + (item.offerid ? item.offerid : '');
                    parsedResponse[discpromoidentifier] = {...item};
                });
                console.log(response,'fragment response')
                dispatch({ type: 'DISCLAIMER_CONTENT_FRAGMENTS_FROM_AEM', value: parsedResponse });
            }
            else {
                getofferDisclaimer(dispatch, visitId);
            }
        })
            .catch(error => {
                logKafka("ERROR", "BuildProduct", error.message, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getofferDisclaimerFromAEM', ex);
    }
}

/*export const getProductsDisclaimer = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getProductsDisclaimer', "Inside getProductsDisclaimer"));
        logKafka("INFO", "BuildProduct", "Inside getProductsDisclaimer", kafkaPageLogs, "applogs", visitId);
        let getVzIdUrl = apiUrl().getDisclaimerProducts;
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'DISCLAIMER_PRODUCTS_FRAGMENTS', value: response });
                checkoutAction.getScreeningInfo(dispatch, visitId, response)
            }
        })
            .catch(error => {
                logKafka("ERROR", "BuildProduct", error.message, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getProductsDisclaimer', ex);
    }
}*/
export const getProductsDisclaimer = (dispatch, visitId,isProductDisclaimerAEM) => {
    try {
        let getVzIdUrl = host.indexOf("preprod")>-1 ?apiUrl().getDisclaimerProducts :apiUrl().getDisclaimerProductsAEM;
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getProductsDisclaimer', "Inside getProductsDisclaimer"));               
        console.log(getVzIdUrl,'fragment url')
            api(getVzIdUrl, 'GET', '').then(response => { 
                    if (InHomeUtils.isNotNull(response)){
                        console.log(response,'fragment url')
                        if (response && response.items && response.items.length) {
                            let productDiscResponse = {};
                            response.items.forEach(item => {
                                let productdiscidentifier = (item.productid ? item.productid : '');
                                productDiscResponse[productdiscidentifier] = {...item};
                            });
                            dispatch({ type: 'DISCLAIMER_PRODUCTS_FRAGMENTS', value: productDiscResponse });  
                            checkoutAction.getScreeningInfo(dispatch, visitId, productDiscResponse)     
                        }
                        else{
                            dispatch({ type: 'DISCLAIMER_PRODUCTS_FRAGMENTS', value: response });  
                            checkoutAction.getScreeningInfo(dispatch, visitId, response)
                        }
                    }
                })
                .catch(error => {
                    errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                });        
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getProductsDisclaimer', ex);
    }
}

export const getCommonDisclaimer = (dispatch, visitId, isDirectAEM) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getCommonDisclaimer', "Inside getCommonDisclaimer"));
        logKafka("INFO", "BuildProduct", "Inside getCommonDisclaimer", kafkaPageLogs, "applogs", visitId);
        let getVzIdUrl = isDirectAEM ? apiUrl().getCommonAEM : apiUrl().getDisclaimerCommon;
        api(getVzIdUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'DISCLAIMER_COMMON_FRAGMENTS', value: response });
            }
        })
        .catch(error => {
            logKafka("ERROR", "BuildProduct", error.message, getErrorLogUrl, "applogs", visitId);
            errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
        });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getCommonDisclaimer', ex);
    }
}

export const getPlansPromo = async (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPlansPromo', "Inside getPlansPromo"));
        logKafka("INFO", "BuildProduct", "Inside getPlansPromo", kafkaPageLogs, "applogs", visitId);
        let getVzIdUrl = apiUrl().getPlansPromo;
        return api(getVzIdUrl, 'GET', '').then(async response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'PLANSPROMO_CONTENT_FRAGMENTS', value: response });
                dispatch({ type: 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG', value: response });
                return response;
            }
            else
                return null;
        })
            .catch(error => {
                logKafka("ERROR", "BuildProduct", error.message, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                return null;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPlansPromo', ex);
        return null;
    }
}

export const getPlansPromoFromAEM = async (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getPlansPromoFromAEM', "Inside getPlansPromoFromAEM"));
        let getPlansPromoUrl = apiUrl().getPlansPromoAEM;
        return api(getPlansPromoUrl, 'GET', '').then(async response => {
            if (response && response.items && response.items.length) {
                let parsedResponse = {};
                response.items.forEach(item => {
                    let planspromoidentifier = (item.promoid ? item.promoid : '') + '~' + (item.offerid ? item.offerid : '');
                    parsedResponse[planspromoidentifier] = { ...item };
                });
                dispatch({ type: 'PLANSPROMO_CONTENT_FRAGMENTS_FROM_AEM', value: parsedResponse });
                dispatch({ type: 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG', value: parsedResponse });
                return parsedResponse;
            }
            else
                return getPlansPromo(dispatch, visitId);
        })
            .catch(error => {
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                return null;
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getPlansPromo', ex);
        return null;
    }
}

export const nsiNewRequest = (dispatch, visitId, addressID, state, firstName, lastName, eMailID, phonenumber) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "Inside nsiNewRequest"));
        logKafka("INFO", "BuildProduct", "Inside nsiNewRequest", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().nsiNotify;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', getNsiRequest(addressID, state, firstName, lastName, eMailID, phonenumber)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logKafka("INFO", "BuildProduct", "nsiNotify - Success", kafkaPageLogs, "applogs", visitId);
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "nsiNotify - Success"));
                dispatch({
                    type: 'NSI_STATUS',
                    value: response.data
                });
                dispatch({
                    type: FutureNotification.validationsucess,
                    value: true
                });
            }
            else if (InHomeUtils.isNull(response) || (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400'))) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'nsiNewRequest', "nsiNotify - Failed"));
                logKafka("ERROR", "BuildProduct", "nsiNotify - Failed", getErrorLogUrl, "applogs", visitId);
                dispatch({
                    type: 'NSI_FAILED',
                    value: true
                });
                if (InHomeUtils.isNull(response)) {
                    dispatch({
                        type: FutureNotification.validationfailure,
                        value: true
                    });
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:nsiNewRequest,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'nsiNewRequest', ex);
    }
};

const getNsiRequest = (addressID, state, firstName, lastName, eMailID, phonenumber) => {
    let request = {
        addressId: addressID,
        programName: 'vzcom',
        inquiryType: 'request',
        nsiID: '',
        state: state,
        firstName: firstName,
        lastName: lastName,
        emailAddress: eMailID,
        contactPhone: phonenumber,
        notifyFios: '',
        notifyFiosTv: 'Y',
        siResponse: ''
    }
    return JSON.stringify(request);
}

export const getProductsFromPlans = (products, prodKey, contract, prodValue) => {
    if (InHomeUtils.isNotNull(contract) && InHomeUtils.isNotNull(products) && InHomeUtils.isNotEmpty(products) && InHomeUtils.isNotNull(products.m2mPlans)) {
        products = contract === 'MTM' ? products.m2mPlans : products.twoYearPlans;
    }
    if (InHomeUtils.isNotNull(products) && InHomeUtils.isNotNull(prodKey) && InHomeUtils.isNotNull(prodValue)) {
        switch (prodKey) {
            case 'id':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].id) && products[count].id === prodValue) {
                        return products[count];
                    }
                }
                break;
            case 'prodTypeValue':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].prodTypeValue) && products[count].prodTypeValue === prodValue) {
                        return products[count];
                    }
                }
                break;
            case 'name':
                for (let count = 0; count < products.length; count++) {
                    if (InHomeUtils.isNotNull(products[count].name) && products[count].name === prodValue) {
                        return products[count];
                    }
                }
                break;
            default:
                return null
        }
    }
    return null;

}

// export const getFaqBuildProduct = (dispatch, visitId, pageName) => {
//     try {
//         logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFaqBuildProduct', "Inside getFaqBuildProduct"));
//         logKafka("INFO", "BuildProduct", "Inside getFaqBuildProduct", kafkaPageLogs, "applogs", visitId);
//         let url = apiUrl().getFaq + '/' + pageName;
//         api(url, 'GET', '').then(response => {
//             if (InHomeUtils.isNotNull(response))
//                 dispatch({ type: 'FAQ_BUILDPRODUCT_CONTENT', value: response });
//         })
//             .catch(error => {
//                 let errorMsg = `MethodName:getFaqBuildProduct,errorMessage:${error.message}`;
//                 logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
//                 errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
//             });
//     }
//     catch (ex) {
//         catchJSException('BuildProduct', visitId, 'getFaqBuildProduct', ex);
//     }
// }
export const getFaqBuildProduct = (dispatch, visitId, pageName,faqaem,hoaFlag="N") => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFaqBuildProduct', "Inside getFaqBuildProduct"));
        let url = faqaem == "Y" ? apiUrl().getFaqAEM : (apiUrl().getFaq + '/' + pageName);
        let sorrtedResponse = [];
        api(url, 'GET', '').then(response => {
                if (faqaem == "Y") {
                        if (InHomeUtils.isNotNull(response) && response.items && response.items.length) {
                            let parsedResponse = [];
                            response.items.forEach(item => {
                                if(hoaFlag === "Y" && item.pagetype == "vecordering"){
                                    parsedResponse.push(item);
                                }
                                if(item.pagetype == "buildproduct" && hoaFlag !== "Y"){
                                    parsedResponse.push(item);
                                }
                                // if(item.pagetype == "buildproduct"){
                                //     parsedResponse.push(item);
                                // }
                            });
                           
                            if(hoaFlag === "Y"){
                            
                                // for (let prodname = 0; prodname < parsedResponse.length; prodname++) {
                                //     if( parsedResponse[prodname].question.indexOf("Who do I reach") >-1){
                                //         sorrtedResponse.push(parsedResponse[prodname]);
                                //     }                                    
                                // }                 
                                
                                parsedResponse.sort((x,y ) => {
                                    if(x.question.indexOf("Who do I reach out to answer my questions?") > -1 ){
                                        return -1;
                                    }else if(x.question.indexOf("Who do I reach out to answer my questions?") > -1 ){
                                        return 0;
                                    }else{
                                        return 1;
                                    }
                                })
                            }  
                            // parsedResponse[0] = sorrtedResponse;
                            // parsedResponse.add(1,sorrtedResponse);
                            // parsedResponse.unshift(sorrtedResponse);
                            // parsedResponse.splice(index, 1, sorrtedResponse);
                            //parsedResponse = [...sorrtedResponse,...parsedResponse];
                            dispatch({ type: 'FAQ_BUILDPRODUCT_CONTENT', value: parsedResponse });
                        }
                }
                else {
                    if (InHomeUtils.isNotNull(response))
                    dispatch({ type: 'FAQ_BUILDPRODUCT_CONTENT', value: response });
                }    
        })
            .catch(error => {
                let errorMsg = `MethodName:getFaqBuildProduct,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                console.log("error",error)
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'getFaqBuildProduct', ex);
    }
}

export const autoPayinCart = (status, dispatch) => {
    dispatch({ type: 'AUTOPAYINCART', value: status });
};

export const laborVisainCart = (status, dispatch) => {
    dispatch({ type: 'LABORVISAINCART', value: status });
};

export const fiosSetupFee = (action, dispatch) => {
    dispatch({ type: 'FIOSSETUPFEE', value: action });
};

export const removeNonSupportedProducts = (dispatch, visitId, request, nonProductIds, nonprods) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "Inside removeNonSupportedProducts"));
        logKafka("INFO", "BuildProduct", "Inside removeNonSupportedProducts", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().updateCartAcc + '/' + visitId;

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "updateCart - Success"));
                dispatch({ type: 'UPDATE_UNSUPPORTED_PRODUCTS', value: updateNonProduct(nonProductIds, nonprods, visitId) });
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.cartTierPricing,
                        cartHeader: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                        cartData: InHomeUtils.isNull(response.data.cartTierPricing) ? null : getCartData(response.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: InHomeUtils.isNull(response.data.cartTierPricing) ? null : response.data.orderDetail
                    }
                });
                dispatch({ type: 'ISCARTUPDATED', value: true });
                dispatch({ type: 'CART_SAVE_ON_UPDATE', value: true });
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'removeNonSupportedProducts', "updateCart - Failed"));
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:removeNonSupportedProducts,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'removeNonSupportedProducts', ex);
    }
}

export const assignUpsellrecommendations = (buildProduct, ProfileCart, newProduct, prodType, dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'assignUpsellrecommendations', "Inside assignUpsellrecommendations"));
        logKafka("INFO", "BuildProduct", "Inside assignUpsellrecommendations", kafkaPageLogs, "applogs", visitId);
        dispatch({ type: 'SET_UPSELL_PRODUCTS', value: {products: [], product: {}, status: false}});
        let profileData;
        let addedSpeed = 0, profileSpeed = 0;
        let addedData = buildProduct.internet.selectedProduct;
        let speedList = [];
        if(buildProduct.internet.m2mPlans.length > 0) {
            speedList = buildProduct.internet.m2mPlans;
        } else if(buildProduct.internet.twoYearPlans.length > 0) {
            speedList = buildProduct.internet.twoYearPlans;
        }
        
        if(InHomeUtils.isNotNull(ProfileCart)&&InHomeUtils.isNotNull(ProfileCart.ProfileDataProduct) && ProfileCart.ProfileDataProduct.length != 0) {
            let onProfileProducts = speedList.filter(e => e.id === ProfileCart.ProfileDataProduct.prodId);
            if(onProfileProducts.length > 0) profileData = onProfileProducts[0];
            if(InHomeUtils.isNull(addedData)) {
                addedData = profileData;
            }
            addedSpeed = InHomeUtils.isNotNull(addedData) ? parseInt(addedData.downSpeed.split('M')[0]) : 0;
            profileSpeed = InHomeUtils.isNotNull(profileData) ? parseInt(profileData.downSpeed.split('M')[0]) : 0;
        } else if(InHomeUtils.isNotNull(addedData)) {
            addedSpeed = parseInt(addedData.downSpeed.split('M')[0]); 
        }
        if(addedSpeed != 0 && addedSpeed >= profileSpeed) {
            let newSpeedList = speedList;
            let suggestions = [], product = {} ;
            for (var i = 0; i < speedList.length; i++) {
                newSpeedList[i].speedKey = parseInt(newSpeedList[i].downSpeed.split('M')[0]);
            }
            newSpeedList.sort(function (a, b) { return (a.speedKey > b.speedKey) ? 1 : ((b.speedKey > a.speedKey) ? -1 : 0); });
            for (var i = 0; i < newSpeedList.length; i++) {
                if (newSpeedList[i].speedKey > addedSpeed)
                    suggestions.push(newSpeedList[i]);
            }
            if(prodType === 'ROUTER') {
                product = newProduct;
            } else if(prodType === 'FNE') {
                product = newProduct;
            } else if(prodType === 'OTTBASIC') {
                product = newProduct;
            }
            if(undefined!= suggestions && null != suggestions && suggestions.length > 0){
            //dispatch({ type: 'SET_UPSELL_STATUS', value: true });
            dispatch({ type: 'SET_UPSELL_PRODUCTS', value: {products: suggestions, product: product, status: true}});
            modalAction.openModalWindow("UPSELL", dispatch);
            }
        } 
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'assignUpsellrecommendations', ex);
    }
}


export const fetchUpsellrecommendations = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "Inside fetchUpsellrecommendations"));
        logKafka("INFO", "BuildProduct", "Inside fetchUpsellrecommendations", kafkaPageLogs, "applogs", visitId);
        dispatch({ type: BuildProduct.upsellCallStatus, value: true })
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "processing...", isLoaderImg: "loader" }
        });
        let url = apiUrl().getProductEc + '/upsell/' + visitId;

        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "fetchUpsellrecommendations - Success"));
                logKafka("INFO", "BuildProduct", "fetchUpsellrecommendations - Success", kafkaPageLogs, "applogs", visitId);

                dispatch({ type: BuildProduct.saveUpsell, value: response.data })
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0)
                    modalAction.openModalWindow("UPSELL", dispatch);
                else
                    dispatch({ type: BuildProduct.checkoutBtnSelection, value: true })
            }
            else {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchUpsellrecommendations', "fetchUpsellrecommendations - Failed"));
                logKafka("INFO", "BuildProduct", "fetchUpsellrecommendations - Failed", kafkaPageLogs, "applogs", visitId);
                dispatch({ type: BuildProduct.checkoutBtnSelection, value: true })
            }
            dispatch({ type: BuildProduct.upsellCallStatus, value: false })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchUpsellrecommendations,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: BuildProduct.checkoutBtnSelection, value: true })
                errorAction("ERROR", "buildProduct", error.message, "applogs", visitId, dispatch, false, "");
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchUpsellrecommendations', ex);
    }
}

export const checkoutBtnSelection = (dispatch, value) => {
    dispatch({ type: BuildProduct.checkoutBtnSelection, value: value })
}

export const upSellCTA = (dispatch, value) => {
    dispatch({ type: BuildProduct.upsellCTA, value: value })
}

export const getServiceType = (prodType) => {
    let serviceType = prodType.indexOf('FTTP') >= 0 ? Service.internet : prodType.indexOf('ROUTER') >= 0 ? Service.router :
        prodType.indexOf('PPP') >= 0 ? Service.techSure : prodType.indexOf('PPPCLOUD') >= 0 ? Service.techsureCloud : prodType.indexOf('OTTBASIC') >= 0 ? Service.streamServ : prodType.indexOf('BASIC') >= 0 ? Service.tv :
            prodType.indexOf('FVPRIMARY') >= 0 ? Service.voice : prodType.indexOf('VROOM') >= 0 ? Service.vRoom :
                prodType.indexOf('VFEATURE') >= 0 ? Service.recording : (prodType.indexOf('FVNONPUB') >= 0 || prodType.indexOf('FVLISTMAIN') >= 0) ? Service.listing :
                    prodType.indexOf('SLABATTERYSHIPMENT') >= 0 || prodType.indexOf('DCELLTRAYSHIPMENT') >= 0 ? Service.batteryshipment :
                        prodType.indexOf('BATTERY') >= 0 || prodType.indexOf('DCELL') >= 0 ? Service.battery : prodType.indexOf('PREMIUM') >= 0 ? Service.channel :
                            prodType.indexOf('WINBACK') >= 0 ? Service.winBack : prodType.indexOf('VCPESTB') >= 0 ? Service.dct :
                                prodType.indexOf('SPLOFFER') >= 0 ? Service.splOffer : prodType.indexOf('OTTEQUIPNRC') >= 0 ? Service.streamDev : prodType.indexOf('STREAMDEVCNT') >= 0 ? Service.streamDevCount : prodType.indexOf('BYOPERK') >= 0 ? Service.perks : prodType.indexOf('VHSBILLER') >= 0 ? Service.vhsBiller : '';

    return serviceType;
}

export const updateRequestTNForFDV = (visitId, tn, dispatch) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRequestTNForFDV', "Inside updateRequestTNForFDV"));
        logKafka("INFO", "BuildProduct", "Inside updateRequestTNForFDV", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().updateintentcartAccEc + '/' + visitId;
        let request = setTNRequestForFDV(tn);
        api(url, 'POST', request).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'updateRequestTNForFDV', "update Cart - Success"));
                logKafka("INFO", "BuildProduct", "update Cart - Success", kafkaPageLogs, "applogs", visitId);
                dispatch({ type: Save.isTNUpdatedForResumeSmartCart, value: true });
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.cartTierPricing) && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent) && InHomeUtils.isNotNull(response.data.orderDetail)) {
                    dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: response.data.cartTierPricing,
                            cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                            cartData: getCartData(response.data.cartTierPricing.tierContent, visitId),
                            cartOrderDetail: response.data.orderDetail
                        }
                    });
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRequestTNForFDV', "updateRequestTNForFDV - Order Detail null", PAGEACTIVITY.UA));
                    logKafka("INFO", "BuildProduct", "updateRequestTNForFDV - Order Detail null", kafkaPageLogs, "applogs", visitId);
                }
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'updateRequestTNForFDV', "update Cart - " + PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                logKafka("ERROR", "BuildProduct", "update Cart for TN-FDV - " + PAGEACTIVITY.MSG.apiResponseFailed, getErrorLogUrl, "applogs", visitId);
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:updateRequestTNForFDV,errorMessage:${error.message}`;
                logKafka("ERROR", "UpdateCart", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateRequestTNForFDV', ex);
    }
}

const setTNRequestForFDV = (tnValue) => {
    let request = {
        key: "UPDATETN",
        value: tnValue,
        action: "add"
    }
    return JSON.stringify(request)
}

export const updateFiosFiveCartReqObj = (request, product) => {
    if (product.fiosFiveSelectedChannels && product.fiosFiveSelectedChannels.length > 0) {
        request.productId = request.productId + ":add," + product.fiosFiveSelectedChannels.map((el) => el.id + ":add").join(',');
        product.fiosFiveSelectedChannels.forEach(() => request.productType += ",BASIC_FF");
        delete product.fiosFiveSelectedChannels;
    }
}

function getPopularffChannel(dispatch, zipCode = '', channelsList, selectedChannels = [],) {
    try {
        let request = {
            "category": "All",
            "acctID": "",
            "SelectChannelList": selectedChannels,
            "lastChannel": "",
            "sessionId": "",
            "zipCode": zipCode
        }
        let url = apiUrl().getProduct + '/popularffchannel';
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.RESULT)) {
                channelsList = channelsList.map((ele) => {
                    if (ele.channelCategory && ele.channelCategory.length) {
                        const index = ele.channelCategory.indexOf('popular');
                        if (index !== -1) {
                            ele.channelCategory.splice(index, 1);
                        }
                    }
                    return ele;
                });
                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelsList }); // clearing popular channels
                // console.log('channelsList without popular::', channelsList);
                if (channelsList && channelsList.length) {
                    channelsList = channelsList.map((ele) => {
                        if (ele.id && response.RESULT.indexOf(ele.id) != -1) {
                            if (ele.channelCategory) {
                                ele.channelCategory.indexOf('popular') == -1 ? ele.channelCategory.push('popular') : ele.channelCategory;
                            }
                        }
                        return ele;
                    });

                    dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelsList }); // updating channels with popular
                    //  console.log('channelsList with popular::', channelsList);
                }
            } else {
                console.log(" getPopularffChannel", response);
            }
        })
            .catch(error => {
                console.log("getPopularffChannel: ", error);
            })
    } catch (ex) {
        console.log("getPopularffChannel: ", ex);
    }
}

export const fetchPopularffChannels = (dispatch, zipCode, channelsList, selectedChannels) => {
    getPopularffChannel(dispatch, zipCode, channelsList, selectedChannels);
}

export const fetchFiosFiveBasicChannels = (dispatch, zipCode, regionId, state) => {
    try {
        //let url = apiUrl().fiosFiveBasicChannels + '?zipCode=' + zipCode;
        let url = apiUrl().getProductEc + '/basicffchannel?zipCode=' + zipCode + '&regionId=' + (regionId || '') + '&state=' + state;
        api(url, 'GET').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')
                && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.basicChannels)) {
                let channelIsocs = {};
                let channelData = response.data.basicChannels.map((el) => {
                    el.id && (channelIsocs[el.id] = el.id);
                    let category = InHomeUtils.isNotNull(el.category) ? el.category.map((cat) => cat.toLowerCase()) : '';
                    let channelTitle = el.name;
                    if (channelTitle.indexOf('(GF)') !== -1) {
                        channelTitle = channelTitle.replace(/\(GF\)/, '').trim();
                    }
                    if (/\(Q\d{4}\)/.test(channelTitle)) {
                        channelTitle = channelTitle.replace(/\(Q\d{4}\)/, '').trim();
                    }

                    return { 'id': el.id, 'name': channelTitle, 'logo': el.id + ".png", 'channelCategory': category, 'packageId': el.packageId, 'packageType': el.packageType, 'isprdOnProfile': el.isprdOnProfile };
                });

                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNELS', value: channelData });
                dispatch({ type: 'SET_FIOSFIVE_BASIC_CHANNEL_ISOCS', value: channelIsocs });

                if (channelData && channelData.length) {
                    let onProfileChannels = channelData.filter(e => e.isprdOnProfile === true);
                    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS_PROFILE', value: onProfileChannels });
                    //dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: onProfileChannels });

                    getPopularffChannel(dispatch, zipCode, channelData);
                }
                let recommendedChannelData = response?.data?.fiosFiveChannels;
                if (Array.isArray(recommendedChannelData) && recommendedChannelData?.length > 0) {
                    let recommendedChannelIsocs = recommendedChannelData?.map(f => f?.fios5channelIosc);
                    if (recommendedChannelIsocs?.length > 5) {
                        recommendedChannelIsocs = recommendedChannelIsocs?.slice(0, 5);
                    }
                    dispatch({ type: 'SET_FIOSFIVE_RECOMMENDED_CHANNELS', value: recommendedChannelData });
                    dispatch({ type: 'SET_FIOSFIVE_RECOMMENDED_CHANNEL_ISOCS', value: recommendedChannelIsocs });
                }
                // console.log("channelData::", channelData);
                console.log('===FF Basic Channels=== ', response.data.basicChannels);
            } else {
                console.log("FF basic channel fetch response error ", response);
            }
        })
            .catch(error => {
                console.log("FF basic channel fetch error: ", error);
            })
    } catch (ex) {
        console.log("FF basic channel fetch exception: ", ex);
    }

}

export const setFiosFiveSelectedChannels = (selectedChannels, dispatch) => {
    console.log("FF: setting channels ", selectedChannels);
    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: selectedChannels });
}

export const setFiosFiveEventType = (isNewChannelsSet, dispatch) => {
    dispatch({ type: 'SET_FIOSFIVE_EVENT_TYPE', value: isNewChannelsSet })
}

export const getFiosFiveChannelMatchForProgramMercury = (dispatch, channelId, regionId, fiosFiveBasicChannels) => {
    try {
        let url = 'https://mercuryha.verizon.com/MercuryServer/FiosFiveChannelSearch/F5Search/GetChannels?RegionId=' + regionId + '&Id=' + channelId + '&Type=TVSeries';
        api(url, 'GET').then(response => {
            console.log("getFiosFiveChannelMatchForProgram response ", response);
        })
            .catch(error => {
                console.log("getFiosFiveChannelMatchForProgram error");
            });
    } catch (ex) {
        console.log("getFiosFiveChannelMatchForProgram exception");
    }
}

export const searchFiosFiveChannelProgram = (dispatch, searchString, lfa, visitId, visitorId) => {

    try {
        let requestObj = {
            appid: 'consumer',
            lfa: lfa,
            programchannelname: searchString.toLowerCase(),
            visitid: visitId,
            visitorid: visitorId
        };

        let url = apiUrl().channelProgramMasterUrl;
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            if (response && response.chanelprogramlist) {
                dispatch({
                    type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS',
                    value: response.chanelprogramlist
                });
            } else {
                console.log("FiosFive channel/program response error", response)
            }
        })
            .catch(error => {
                console.log("FiosFive channel/program search error", error)
            });
    } catch (ex) {
        console.log("FiosFive channel/program search exception", ex);
    }
};

export const searchFiosFiveChannelProgramMercury = (dispatch, regionId, searchString) => {
    try {
        let url = 'https://mercuryha.verizon.com/MercuryServer/FiosFiveChannelSearch/F5Search/GetSuggestions?RegionId=' + regionId + '&SearchString=' + searchString;
        api(url, 'GET').then(response => {
            console.log("FiosFive channel/program search response ", response);
            if (response && response.Status === 'OK' && response.autoSuggestResults) {
                dispatch({
                    type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS',
                    value: response.autoSuggestResults
                });
            }
        })
            .catch(error => {
                console.log("FiosFive channel/program search error", error)
            })
    } catch (ex) {
        console.log("FiosFive channel/program search exception", ex);
    }

};

export const getFiosFiveChannelMatch = (dispatch, selectedItem, visitId, visitorId, lfa, vhoName, fiosFiveBasicChannels, fiosFiveBasicChannelIsocs, searchString) => {

    try {
        let requestObj = {
            appid: 'consumer',
            channelid: selectedItem.channelid,
            elkchannelprogram: selectedItem.elkchannelname,
            lfa: lfa,
            name: selectedItem.name,
            programid: selectedItem.programid,
            type: selectedItem.type,
            vhoname: vhoName,
            visitid: visitId,
            visitorid: visitorId
        };

        let matchedChannelList = [];
        let url = apiUrl().channelProgramSearchUrl;
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            console.log("getFiosFiveChannelMatch response ", response);
            if (response && response.channellistwithpack && response.channellistwithpack.length && response.channellistwithpack[0].packagelist) {
                let packageList = response.channellistwithpack[0].packagelist;
                let packageIdsToSearch = processFiosFiveSearchPackageList(packageList, fiosFiveBasicChannelIsocs);
                if (packageIdsToSearch && packageIdsToSearch.length) {
                    console.log('getFiosFiveChannelMatch found channels for FF search in package list -', packageIdsToSearch);
                    packageIdsToSearch.forEach((el) => {
                        let matchesFound = filterFiosFiveBasicChannels(el, fiosFiveBasicChannels);
                        if (matchesFound && matchesFound.length) {
                            matchedChannelList.push(matchesFound[0]);
                        }
                    })
                } else {
                    console.log('getFiosFiveChannelMatch ', packageIdsToSearch, ' channels for FF search in package list -', packageList);
                }

            } else {
                console.log('getFiosFiveChannelMatch package list not found in response -', response);
            }
            console.log('getFiosFiveChannelMatch matchedChannelList is ', matchedChannelList);
            matchedChannelList.length && matchedChannelList.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1);
            dispatch({
                type: 'SET_FIOSFIVE_SEARCH_MATCHED_CHANNELS',
                value: matchedChannelList
            });
        })
            .catch(error => {
                console.log("getFiosFiveChannelMatch error");
            });
    } catch (ex) {
        console.log("getFiosFiveChannelMatch exception");
    }

}

export const clearFiosFiveSelectedChannels = (channels, dispatch) => {
    dispatch({ type: 'SET_FIOSFIVE_SELECTED_CHANNELS', value: channels });
};

export const clearFiosFiveSearch = (dispatch) => {
    dispatch({ type: 'SET_FIOSFIVE_SEARCH_SUGGESTIONS', value: undefined });
};

export const clearFiosFiveSearchMatchedChannels = (dispatch) => {
    dispatch({
        type: 'SET_FIOSFIVE_SEARCH_MATCHED_CHANNELS',
        value: undefined
    });
}

const processFiosFiveSearchPackageList = (packageList, fiosFiveBasicChannelIsocs) => {

    let packageIdsToSearch = [];
    if (packageList) {
        if (packageList.indexOf('[') !== -1 && packageList.indexOf(']') !== -1) {
            packageList = packageList.replace(/\[/, '').replace(/\]/, '');
        }
        //Temporary fix for MSNBC Isoc change
        if(packageList.indexOf('Q7898') > -1) {
            packageList = packageList.concat(', ').concat('R0686');
        }
        if(packageList.indexOf('Q7896') > -1) {
            packageList = packageList.concat(', ').concat('R0687');
        }
        if(packageList.indexOf('Q7864') > -1) {
            packageList = packageList.concat(', ').concat('R0688');
        }
        let packageListArr = packageList.split(',');

        packageListArr.forEach((el) => {
            let isoc = el.trim();
            fiosFiveBasicChannelIsocs[isoc] && packageIdsToSearch.push(isoc)
        });
    }

    return packageIdsToSearch;
};

const filterFiosFiveBasicChannels = (filterText, fiosFiveBasicChannels) => {
    let matchedChannelList = [];

    if (filterText) {
        filterText = filterText.toUpperCase();
        matchedChannelList = fiosFiveBasicChannels.filter((el) => {
            return (el.id.toUpperCase().indexOf(filterText) !== -1)
        });
    }
    return matchedChannelList;
};

export const setFiosFiveModalDetails = (modalType, selectedChannels, dispatch) => {
    dispatch({
        type: 'SET_FIOS_FIVE_MODAL_DETAILS',
        payload: {
            modalType: modalType,
            selectedChannels: selectedChannels
        }
    })
}

export const setNotification = (visitId, dispatch, signInState, profileCart) => {
    let setMessage = '';
    let flowType = '';
    let ISFCPINCSR = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response)) ? signInState.response.userProfile.isFcpInProfile : false;
    let ISFCPQualified = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response) && InHomeUtils.isNotNull(signInState.response.classicToFcp)) ? signInState.response.classicToFcp : false;
    let isHSIAvailable = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response) && signInState.response.services &&(signInState.response.services.filter(v => v.servicename === 'HSI' && v.qualified === 'Y').length > 0)) ? true : false;
    let isMfrtOnProfile = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response)) ? signInState.response.userProfile.isMfrtOnProfile : false;
    let isStudentDiscOnProfile = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response)) ? signInState.response.userProfile.studentDiscOnProfile : false;

    try {

        if (isMfrtOnProfile) {
            setMessage = "You already have the internet discount on your existing order, but you can still add to or change your order. Thank you for your service.";
        }
        if (isStudentDiscOnProfile) {
            setMessage = "You already have the internet discount on your existing order, but you can still add to or change your order.";
        }

    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSubProductCartonLoad', ex);
    }
    dispatch({ type: 'SET_EC_BANNER_MESSAGE', value: setMessage })
}

export const setPromodrop = (promoDrop,dispatch) => {
  try{
   dispatch({ type: 'EC_PROMO_DROP_ERROR', value: promoDrop })
  }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setPromodrop', ex);
    }
   
}
export const SetMessageForEmpAndAffinityFlow = (visitId, dispatch, signInState, isEmpOnCsr, isAffinityOnCsr, profileCart, discountType) => {
    let setMessage = '';
    let flowType = '';
    let isEmpDiscounInCsr = isEmpOnCsr ? true : false;
    let isAffinityDiscountInCsr = isAffinityOnCsr ? true : false;
    let isEmpQualified = (InHomeUtils.isNotNull(signInState) && (signInState.ecFlowType === 'Employee')) ? true : false;
    let isAffinityQualified = (InHomeUtils.isNotNull(signInState) && (signInState.ecFlowType === 'Affinity')) ? true : false;
    let ISFCPINCSR = (InHomeUtils.isNotNull(signInState)) ? signInState.response.userProfile.isFcpInProfile : false;
    let ISFCPQualified = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response) && InHomeUtils.isNotNull(signInState.response.classicToFcp)) ? signInState.response.classicToFcp : false;
    //let isHSIAvailable = (InHomeUtils.isNotNull(signInState) && InHomeUtils.isNotNull(signInState.response) && (signInState.response.services.filter(v => v.servicename === 'HSI' && v.qualified === 'Y').length > 0)) ? true : false;

    try {
        if (isEmpDiscounInCsr)
            flowType = "EmpDiscountExist";
        else if (isAffinityDiscountInCsr)
            flowType = "AffinityDiscountExist";
        else if (isEmpQualified)
            flowType = "EmployeeQualified";
        else if (isAffinityQualified)
            flowType = "AffinityQualified";


        if ((flowType === "EmpDiscountExist" || flowType == "EmployeeQualified") && ISFCPQualified && !ISFCPINCSR) {
            setMessage = "Thanks for being a part of Verizon. We hope you are enjoying your special deal. Once you order this great deal, any existing discounts will be removed from your account";
        }
        else if (flowType === "EmployeeQualified" && !ISFCPINCSR) {
            setMessage = "You work here. Which means you know Fios better than anyone. Take your work home (in a good way) with the Ultimate Employee Free TV offer. Once you order this great deal, any existing discounts will be removed from your account.";
        }
        else if (flowType === "AffinityDiscountExist" && discountType === '') {
            setMessage = "Congratulations on your Verizon Connections discount.";
        }
        else if (flowType === "EmpDiscountExist" && !ISFCPQualified && !ISFCPINCSR) {
            setMessage = "Thanks for being part of Verizon—we hope you’re enjoying your special deal on Ultimate HD TV. If you want to add or change other services, you can do it here.";
        }
        else if (flowType === "EmpDiscountExist" && ISFCPINCSR) {
            setMessage = "Thanks for being a part of Verizon. We hope you are enjoying your special deal.";
        }
        else if (flowType === "EmployeeQualified" && ISFCPINCSR) {
            setMessage = "Congratulations! You are eligible for the Employee Discount offer.";
        }
        else if (flowType === "AffinityQualified") {
            if (discountType === OfferTypes.Affinity) {
                setMessage = "Congratulations! You are eligible for a Verizon Affinity discount. Select and customize the bundle that's right for you.";
            }
            else if (discountType === OfferTypes.Connection) {
                setMessage = "Congratulations! You are eligible for a Verizon Connections discount. Select and customize the bundle that's right for you.";
            }
            else if (discountType === '') {
                setMessage = "Your account is not eligible for a Verizon Deals at Work discount.";
            }

            if (InHomeUtils.isNotNull(profileCart) && InHomeUtils.isNull(profileCart.ProfileDataProduct)) {
                setMessage = "In order to get the VZ Connections discount, you need to have Internet on your account.";
            }
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSubProductCartonLoad', ex);
    }
    dispatch({ type: 'SET_EC_BANNER_MESSAGE', value: setMessage })
}

export const toggleVzProtectHomeSub = (dispatch) => {
    dispatch({
        type: "TOGGLE_VZ_PROTECTHOME_SUBPRODUCTS"
    })
}

export const referNoChange = (status, dispatch) => {
    dispatch({ type: 'REFER_NO_CHANGE', value: status });
};

export const isAutoPayInCart = (visitId, cartState) => {
    let isAutoPayInCart = false;
    let splitBillTab = cartState && cartState.splitBillTab ? cartState.splitBillTab : 0;
    try {
        if (cartState && cartState.cartData && cartState.cartData[splitBillTab].Promotions && cartState.cartData[splitBillTab].Promotions.promotions && cartState.cartData[splitBillTab].Promotions.promotions.length > 0) {
            cartState.cartData[splitBillTab].Promotions.promotions.map(function (product) {
                if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotEmpty(product.offerAttrValue) && product.offerAttrValue.toLowerCase().indexOf("autopay") > -1 && product.promoText && product.promoText.toLowerCase().indexOf("decline") == -1) {
                    isAutoPayInCart = true;
                }
            })
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'isAutoPayInCart', ex);
    }

    return isAutoPayInCart;
}

export const setFiosTvOneSelected = (dispatch, FiosTvoneSelected) => {
    dispatch({ type: 'FIOSTV_ONE_SELECTED', value: FiosTvoneSelected});
}

export const setVMSProductSelected = (dispatch, VMSProductSelected) => {
    dispatch({ type: 'VMS_PRODUCT_SELECTED', value: VMSProductSelected});
}

export const setStreamTVSelected = (dispatch, value) => {
    dispatch({ type: 'STREAMTV_PRODUCT_SELECTED', value: value});
}

export const fetchFiosTvOneOptions = (dispatch,visitId,QAMStreamTV,QAMStreamTVLQ) => {
    let buildProduct = store.getState().buildProduct
    let fiosTvOneUpgradeOptions = [];
    console.log("checking for fetchFiosTvOneOptions",{QAMStreamTVLQ,QAMStreamTV})
    let QAMEligible = ((QAMStreamTVLQ && InHomeUtils.isNotEmpty(QAMStreamTVLQ) && QAMStreamTVLQ.runtimeKey.QAM === 'Y') && (QAMStreamTV && InHomeUtils.isNotEmpty(QAMStreamTV) && (QAMStreamTV.tv.streamTvEligible || QAMStreamTV.tv.AndriodUpgradeEligible))) ? true: false;
    console.log("QAMEligible",QAMEligible)
    fiosTvOneUpgradeOptions.push({
        "prodType": "fiosTvOne",
        "Type": "N",
        "name": "Set-top box",
        "isprdOnProfile": true,
        "selectedProduct": true,        
        "description":`${buildProduct.tv.vms1100Eligible?"<li>Current equipment is obsolete & can no longer be repaired.</li>":""}`,
        "displayPrice": "",
    });
    if(QAMEligible){
    fiosTvOneUpgradeOptions.push({
        "prodType": "fiosTvOne",
        "Type": "Y",
        "name": "Fios TV+",
        "isprdOnProfile": false,
        "selectedProduct": false,
        "description": "<ul class='margin-bottom-zero'><li>Voice Remote.</li><li>Stunning 4K Ultra HD picture quality</li><li>Wireless mini boxes with no cable required.</li><li>Netflix and Youtube channels built in./li></ul>",
        "displayPrice": ""
    });
     
    }
    else if(buildProduct.tv.vms1100Eligible){
        if(buildProduct.tv.fiosTvOneEligible){
            fiosTvOneUpgradeOptions.push({
                "prodType": "fiosTvOne",
                "Type": "Y",
                "name": "Fios TV One",
                "isprdOnProfile": false,
                "selectedProduct": false,
                "description": "<li>4K viewing</li><li>Voice remote</li><li>Wi-Fi</li>",
                "displayPrice": ""
              }); 
        }
        fiosTvOneUpgradeOptions.push({
            "prodType": "fiosTvOne",
            "Type": "Y",
            "name": "Video Media Server",
            "isprdOnProfile": false,
            "selectedProduct": false,
            "description": "<li>Compact equipment & sleek design</li><li>Renders HD resolution</li><li>Updated channel guide</li><li>Control with Alexa & Google Home</li>",
            "displayPrice": "Your current service charge",
            "id":"VMS1100"
        }); 
   }
   else {
    fiosTvOneUpgradeOptions.push({
        "prodType": "fiosTvOne",
        "Type": "Y",
        "name": "Fios TV One",
        "isprdOnProfile": false,
        "selectedProduct": false,
        "description": "<li>4K viewing</li><li>Voice remote</li><li>Wi-Fi</li>",
        "displayPrice": "Same Price"
      }); 
    }  
    dispatch({ type: 'FIOSTV_ONE_OPTIONS', value: fiosTvOneUpgradeOptions });
    console.log("fiosTvUpgradeOptions",fiosTvOneUpgradeOptions)
    //dispatch({ type: 'FIOSTV_ONE_SELECTED', value: false});
   //dispatch({ type: 'VMS_PRODUCT_SELECTED', value: false});
}

export const sweetnerAction = (product, buildProductState, isChecked, tvDisconnect, dispatch) => {
    try {
        const selectedProduct = product;
        const { prodType } = InHomeUtils.isNotNull(product) && product;
        let sweetnerSelectedProdType = ""
        let returnedEquipment = store.getState().cart.cartData
        let removedFne = returnedEquipment[0]?.removedequipments?.equipment.filter(equip => equip?.prodId === 'R4100')
        let removedAP = returnedEquipment[0]?.removedequipments?.equipment.filter(equip => equip?.prodType === 'ACCESSPOINTBILLER')
        returnedEquipment = returnedEquipment && returnedEquipment[0].returnedEquipment
        returnedEquipment = Array.isArray(returnedEquipment) && returnedEquipment.length == 0?null:returnedEquipment
        
        let vRoomProfileProduct = buildProductState.vRoom.equipments && buildProductState.vRoom.equipments.filter(each => each.isprdOnProfile);
        const isVroomOnProfile = vRoomProfileProduct && vRoomProfileProduct.length > 0 ? true : false;
        let showVroomBanner = false;
        let showFiostvone =  false

        let routerProfileProduct = buildProductState.router.equipments ? buildProductState.router.equipments : [];
        const isRouterOnProfile = routerProfileProduct.filter(each => each.isprdOnProfile).length > 0 ? true : false
        let showRouterBanner = false;
        const isTVOnProfile = [...buildProductState.tv.twoYearPlans, ...buildProductState.tv.m2mPlans].filter(each => each.isprdOnProfile).length > 0 ? true : false
        const isFneOnProfile = buildProductState.fne.equipments && buildProductState.fne.equipments.filter(each => each.isprdOnProfile).length > 0 ? true : false
        const isDvrOnProfile = buildProductState.recording.equipments && buildProductState.recording.equipments.filter(each => each.isprdOnProfile).length > 0 ? true : false

        const profileCart =  store.getState().ecProfileCart;
        let isFreeGigProduct = profileCart && profileCart.ProfileBoltonSpeedProduct ? true : false;

        sweetnerSelectedProdType = prodType && prodType.toLowerCase();
        /**returnEquipment count */
        let returnedEquipmentCount = 0
        if(InHomeUtils.isNotNull(returnedEquipment) && !sweetnerSelectedProdType.includes("vfeature")){
            returnedEquipmentCount = returnedEquipment.equipment.map(each=>each.quantity)
            returnedEquipmentCount = returnedEquipmentCount.reduce((a,b)=>a+b,0)
            dispatch({type:"RETURN_EQUIPMENT_COUNT",value:returnedEquipmentCount})
        }
        // console.log("state",state)
        // console.log("props",props)
        // console.log("prodtype",prodType,product)
        // console.log("tv Disconnect2",tvDisconnect)
        // console.log("tv",isTVOnProfile,sweetnerSelectedProdType)
        //vroom banner shows only for decrease in settop box
        if (isVroomOnProfile && sweetnerSelectedProdType === "vroom" && InHomeUtils.isNotNull(returnedEquipment)) {
            if (returnedEquipment.equipment.filter(each => each.prodType === 'VCPEIP'  ||  each.prodType === 'VCPEVMS' || each.prodType === 'VCPEATV').length > 0) {
                showVroomBanner = product.unitCount < vRoomProfileProduct[0].unitCount ? true : false
                // product.isChecked = InHomeUtils.isNotNull(store.getState().buildProduct.vRoom.selectedProduct)
                // showVroomBanner = product.isChecked ? showVroomBanner : false;
            }
        }
        if (isVroomOnProfile && sweetnerSelectedProdType === "fiostvone" && InHomeUtils.isNotNull(returnedEquipment)) {
            if (returnedEquipment.equipment.filter(each => each.prodType === 'VCPEIP' ||  each.prodType === 'VCPEVMS').length > 0) {               
                showFiostvone = true;
            }
        }

        if((sweetnerSelectedProdType.includes("accesspoint") && removedFne?.length > 0) || (removedAP?.length > 0 && sweetnerSelectedProdType.includes("accesspoint") && product?.prodType === 'ACCESSPOINTNRCBILLER')){
            sweetnerSelectedProdType = "router";
            showRouterBanner = true
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner ,showFiostvone})
        }
     
        //router logic 
        if (isRouterOnProfile && (sweetnerSelectedProdType.includes("router") || sweetnerSelectedProdType.includes("accesspoint") || sweetnerSelectedProdType.includes('fttprtr'))) {
            const olderRouterVersions = InHomeUtils.isNotNull(routerProfileProduct) && !(routerProfileProduct[0]&&routerProfileProduct[0].keyword&&routerProfileProduct[0].keyword.includes("BHRX") ||routerProfileProduct[0].keyword.includes("CHR") || routerProfileProduct[0].keyword.includes("BHR4") || routerProfileProduct[0].keyword.includes("FQGRENTAL") || routerProfileProduct[0].keyword.includes("ROUTERCATEGORY:200")|| routerProfileProduct[0].keyword.includes("DESC:FIOS_QUANTUM_GATEWAY")||routerProfileProduct[0].keyword.includes("|OWNERSHIP:CUSTOMER|"))

            const cartRouterProdType =  product.prodType
            const profileRouterProductType =routerProfileProduct[0].prodType
            const cartRouterCHR = product.keyword && product.keyword.includes('|CHR|')
            const profileRouterCHR = routerProfileProduct[0].keyword && routerProfileProduct[0].keyword.includes('|CHR|')


            const profileRouterIsBHRXOrNot = routerProfileProduct[0].keyword && routerProfileProduct[0].keyword.includes("|BHRX|") 
            const cartProductIsBHRXOrNot = product.keyword && product.keyword.includes("|BHRX|")
            const cartProductCustomerOwnedRouter = product.keyword && product.keyword.includes('CUSTOMER_PROVIDED') || ((product.prodId || product.id) === 'J4396')
            if(olderRouterVersions || routerProfileProduct[0].id === "J4396" || routerProfileProduct[0].prodId === "J4396" ||  routerProfileProduct[0].prodTypeValue.toUpperCase() === "CUSTOMER_PROVIDED_ROUTER" ||  profileRouterProductType ==='ROUTERNRCBILLER'){
                showRouterBanner = false
            }
            else if(profileRouterProductType===cartRouterProdType && !cartProductCustomerOwnedRouter){
                if(cartRouterCHR&& profileRouterCHR ){
                showRouterBanner = false
                }
                if(profileRouterIsBHRXOrNot && cartProductIsBHRXOrNot){
                showRouterBanner = false
                }   
                if(cartRouterCHR!==profileRouterCHR){
                    showRouterBanner = true

                }   
            }
            else if(profileRouterIsBHRXOrNot){/**if bhrx and prodtype ROUTERBILLER to ROUTERBILLERNRC*/
                 if(cartRouterProdType==="ROUTERNRCBILLER" || cartRouterProdType ==='ROUTERBILLERNRC'  || cartProductCustomerOwnedRouter || cartRouterCHR ){
                     showRouterBanner = true
                 }
            }else if((profileRouterProductType === "ROUTERBILLER" || ROUTERNRCBILLER === "ROUTERNRCBILLER") && (cartRouterProdType === "ACCESSPOINTBILLER" || cartRouterProdType === "ACCESSPOINTNRCBILLER")){
                showRouterBanner = true
            }else if(!profileRouterIsBHRXOrNot){
                if(cartProductIsBHRXOrNot || cartProductCustomerOwnedRouter || cartRouterCHR){
                    showRouterBanner = true
                }
            }
    
        }
        if ((sweetnerSelectedProdType.includes("router") || sweetnerSelectedProdType.includes("accesspoint") || sweetnerSelectedProdType.includes('fttprtr')) && showRouterBanner) {
            sweetnerSelectedProdType = "router";
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner ,showFiostvone})
            // tempSCData.pageName = "urc landing page";
            // tempSCData.events = "event5";
            // tempSCData.detailPageName = "ec| services overview| add internet| add router| return equipment in 30 days to avoid charges";
            // updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
            // populteVZDLNotification("return equipment in 30 days to avoid charges");
            // updatecartEvent("pageViewOmni");
        } if (!showRouterBanner && (sweetnerSelectedProdType.includes("router") || sweetnerSelectedProdType.includes("accesspoint") || sweetnerSelectedProdType.includes('fttprtr'))) {
            sweetnerSelectedProdType = "router";
            isChecked = false;
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner,showFiostvone })
            // if (product.id != "R0640") {
            //     tempSCData.pageName = "urc landing page";
            //     tempSCData.events = "event5";
            //     tempSCData.detailPageName = "ec| services overview| add internet| add router| whole-home wi-fi is no longer included";
            //     updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
            //     populteVZDLNotification("whole-home wi-fi is no longer included");
            //     updatecartEvent("pageViewOmni");
            // }
        }
        if (sweetnerSelectedProdType.includes("basic") && !sweetnerSelectedProdType.includes("ott") && isTVOnProfile) {
            sweetnerSelectedProdType = "tv";
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone })

        }
        // if (sweetnerSelectedProdType.includes("network") && isFneOnProfile) {
        //     sweetnerSelectedProdType = "fne";
        //     dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone })
        // }
        if (sweetnerSelectedProdType.includes("vfeature") && isDvrOnProfile) {
            if (InHomeUtils.isNotNull(returnedEquipment)) {
               let returnedEquipmentCountDvr = returnedEquipment.equipment.map(each=>each.quantity)
                returnedEquipmentCountDvr = returnedEquipmentCountDvr.reduce((a,b)=>a+b,0)
                if(returnedEquipmentCountDvr!==buildProductState.returnedEquipmentCount){
                if (returnedEquipment.equipment.filter(each => each.prodType === 'VCPEIP' ||  each.prodType === 'VCPEVMS').length > 0) {
                    sweetnerSelectedProdType = "dvr";
                    dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone });
                }
            }
            }
        }

        if ((sweetnerSelectedProdType === 'fttpd') && isFreeGigProduct) {
            sweetnerSelectedProdType = "fttpd_bolton";
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone });    
        }
        if (sweetnerSelectedProdType === 'fttpd') {
            const buildProduct = store.getState().buildProduct;
            let isGig2point0OnProfile = [...buildProduct.internet.twoYearPlans, ...buildProduct.internet.m2mPlans].filter(each => each.isprdOnProfile)
            isGig2point0OnProfile = isGig2point0OnProfile.length > 0 && isGig2point0OnProfile[0].productKeyword.includes('|MM2|')
            let is2GorcompletepackageOnProfile = [...buildProduct.internet.twoYearPlans, ...buildProduct.internet.m2mPlans].filter(each => each.isprdOnProfile)
            is2GorcompletepackageOnProfile = is2GorcompletepackageOnProfile.length > 0 && is2GorcompletepackageOnProfile[0].productKeyword.includes('|MM3|') && is2GorcompletepackageOnProfile[0].planPerks.length > 0 && is2GorcompletepackageOnProfile[0].planPerks.filter(each => each.isprdOnProfile)						
			is2GorcompletepackageOnProfile = is2GorcompletepackageOnProfile.length > 0 && (is2GorcompletepackageOnProfile[0].productKeyword.includes('|2G|') || (is2GorcompletepackageOnProfile[0].prodTypeValue != null && is2GorcompletepackageOnProfile[0].prodTypeValue === "COMPLETE"))  
            let whwOnProfile = buildProduct?.router?.equipments?.filter(each => each.isprdOnProfile)
            whwOnProfile = whwOnProfile.length > 0 && whwOnProfile[0].id === 'R0640'
            let whwplusOnProfile = buildProduct.router.equipments.filter(each => each.isprdOnProfile)
            whwplusOnProfile = whwplusOnProfile.length > 0 && (whwplusOnProfile[0].id === 'R1739' || whwplusOnProfile[0].id === 'R1749')
            let discVasOnProfile = buildProductState.profileCloudProduct ? buildProductState.profileCloudProduct : null;
            discVasOnProfile = discVasOnProfile && (discVasOnProfile.contentId === 'VDRIVEW-2TB-MM2')

            var showWhWbanner
            var showCloudbanner
            var showWhWplusbanner
            if (product.id !== 'R0553' && !product.productKeyword.includes('|2G|') && isGig2point0OnProfile && (whwOnProfile || discVasOnProfile)) {
                if (whwOnProfile && discVasOnProfile) {
                    showWhWbanner = true
                    showCloudbanner = true
                }
                else if (whwOnProfile) {
                    showWhWbanner = true
                    showCloudbanner = false
                }
                else {
                    showWhWbanner = true
                    showCloudbanner = true
                }

                dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, showVroomBanner, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone })
                // tempSCData.pageName = "urc landing page";
                // tempSCData.events = "event5";
                // tempSCData.detailPageName = "ec| services overview| add internet| gigabit included features will incur charges";
                // updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                // setTimeout(()=>{
                //     populteVZDLNotification("gigabit included features will incur charges");
                //     updatecartEvent("pageViewOmni");
                // },500);                                 
                // tempSCData.detailPageName = "ec| services overview| add internet| add router| whole-home wi-fi is no longer included";
                // updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                // setTimeout(()=>{
                //     populteVZDLNotification("whole-home wi-fi is no longer included");
                //     updatecartEvent("pageViewOmni");
                // },1000);                                
            } 
            else if (product.id !== 'R1654' && product.id !== 'R1657' && !product.productKeyword.includes('|2G|') && is2GorcompletepackageOnProfile && (whwplusOnProfile || discVasOnProfile)) {
                if (whwplusOnProfile && discVasOnProfile) {
                    showCloudbanner = true
                    showWhWplusbanner = true
                }
                else if (whwplusOnProfile) {
                    showWhWplusbanner = true
                    showCloudbanner = false
                }
                else {
                    showWhWplusbanner = false
                    showCloudbanner = true
                }

                dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, showVroomBanner, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showWhWplusbanner, showCloudbanner, showFiostvone })                                
            } 
            else {
                // if (product.id == 'R0553') {
                //     tempSCData.pageName = "urc landing page";
                //     tempSCData.events = "event5";
                //     tempSCData.detailPageName = "ec| services overview| add internet| add router| you are now entitled to whole-home wi-fi on us";
                //     updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                //     populteVZDLNotification("You are now entitled to Whole Home Wi-Fi on us");
                //     updatecartEvent("pageViewOmni");
                // }
                // else {
                //     tempSCData.pageName = "urc landing page";
                //     tempSCData.events = "event5";
                //     tempSCData.detailPageName = "ec| services overview| add internet| add router| ensure Fios Router/Fios Quantum Gateway Router";
                //     updateSCcustomEvent("IntelPackLoad", "ddAddToCartEvent", "detailPageName,pageName,events");
                //     populteVZDLNotification("ensure Fios Router/Fios Quantum Gateway Router");
                //     updatecartEvent("pageViewOmni");
                // }
                showWhWbanner = false
                showWhWplusbanner = false
                showCloudbanner = false
                dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, showVroomBanner, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showWhWplusbanner, showCloudbanner, showFiostvone })
            }
        }

        if (showVroomBanner) {
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, showVroomBanner, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone })

        }
        else {
            const classicAccountCheckValidate = store.getState()?.buildProduct?.isClassicAccount || false;
            dispatch({ type: "SWEETNER_UPDATE", value: sweetnerSelectedProdType, showVroomBanner, isChecked, tvDisconnect, product, showRouterBanner, autoAdd: false, showWhWbanner, showCloudbanner, showFiostvone })
            dispatch({type:"CLASSIC_ACCOUNT_CHECK", value: { classicAccount: classicAccountCheckValidate }})
        }

    }
    catch (ex) {
        console.log('error', ex)
        // catchJSException('buildProductState','sweetnerAction', ex);
    }
}

export const checkNewProductAddedOrNot=(dispatch)=>{
    /** show get new equipment based on shopping cart's shipping fee */
    try{
    const cart  =  store.getState().cart
            let isCartDataEmpty = (cart.cartData !== null && cart.cartData.length !== 0) ? true : false
            let splitBillTab=0
            if (isCartDataEmpty && cart.cartData[splitBillTab].oneTimeCharge !== undefined && cart.cartData[splitBillTab].oneTimeCharge.onetimecharge !== undefined
                && cart.cartData[splitBillTab].oneTimeCharge.onetimecharge !== null && cart.cartData[splitBillTab].oneTimeCharge.onetimecharge.length > 0) {
                let shippingFee = cart.cartData[splitBillTab].oneTimeCharge.onetimecharge.filter(p => p.prodType === "SHFEE" || p.prodType=== "VCPEDELIVERY")
                if (shippingFee !== null && shippingFee.length > 0 && shippingFee[0].price !== null) {
                    cartActions.isShippingFee(true,dispatch)
                    if(shippingFee?.filter(each => each.prodType === "SHFEE" || each.prodName?.indexOf("Shipping") > -1)?.length>0){
                        dispatch({type:"STORE_DELIVERY_METHOD",value:"STANDARD_SHIPPING"})
                    }else{
                        dispatch({type:"STORE_DELIVERY_METHOD",value:"STOREPICKUP"})
                    }
    
                }else{
                    cartActions.isShippingFee(false,dispatch)
                }
            }
            else{
                cartActions.isShippingFee(false,dispatch)
            }
}catch(error){
    console.log("error",error)
}

}

export const classicAccountCheck = (classicAccountBool,dispatch) => {
    try {
        dispatch({type:"CLASSIC_ACCOUNT_CHECK",value: { classicAccount: classicAccountBool }})
    }
    catch (ex) {
        catchJSException('buildProductState','classicAccountCheck', ex);
    }
}

export const updateIntlPackageCartReqObj = (request, product) => {
    if (product && product.internationalPackages && product.internationalPackages.length) {
        let count = product.internationalPackages.split(',').length;
        request.productId = product.internationalPackages;
        for(let i=0;i<=count-2;i++) {
            request.productType += ",INTLPREMIUM";
        }
        request.serviceType = Service.video;
        delete product.internationalPackages;
    }
}

export const fetchIntrChannel = (dispatch, visitId, selectedProductId, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntrChannel', "Inside fetchIntrChannel"));
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        //loaderActive({ isLoaderActive: true, isLoaderText: "Fetching Products", isLoaderImg: "loader" }, dispatch);
        api(url, 'POST', getPremiumChannelRequest(visitId, Contract.monthToMonth, 'INTLPKG', '', selectedProductId)).then(response => {
            //   loaderActive({ isLoaderActive: false, isLoaderText: "" }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchChannel', "International Channel Products Found"));
                let value = {}
                let language = '';
                response.data.products.map(p => {
                    if(p.language && p.category && p.category !== 'SPECIALITY') {
                        if (p.productKeyword && p.productKeyword.includes('|LANGUAGE:')) {
                          language = p.productKeyword.split('|').filter(k => k.includes('LANGUAGE:'))[0].split(':')[1];
                        }
                        else 
                        {
                            language = p.language;
                        }
                        
                        if(language) {
                            language = language.toLowerCase();
                            if(Object.keys(value).length && Object.keys(value).includes(language)) {
                                value[language].push(p);
                            }
                            else{
                                value[language] = [];
                                value[language].push(p);
                            }
                        }
                    }
                })
                dispatch({
                    type: 'FETCH_INTERNATIONAL_CHANNEL',
                    value: value
                });
                if (Object.keys(value).length) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { InternationalChannel: true} });
                   // dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { InternationalChannel: true } });
                }
                let onProfileChannels = response.data.products.filter(v=>v.isprdOnProfile);
                if (onProfileChannels && onProfileChannels.length>0) {
                    dispatch({
                        type: 'FETCH_PROFILE_INTERNATIONAL_CHANNEL',
                        value: onProfileChannels
                    });
                }
                if(flowRouteValue ==  "VECREVIEWPLAN"){
                    dispatch({
                        type: 'FETCH_INTERNATIONAL_CHANNEL',
                        value: onProfileChannels.map(p=>p)
                    });
                }
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchIntrChannel', "International Channel " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                fetchIntrChannel(dispatch, visitId, selectedProductId,(reAttemptCount + 1))
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchIntrChannel', "Exception is: " + error.message));
                logKafka("ERROR", "BuildProduct", "Exception is: " + error.message, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('buildProductState','fetchChannel', ex);
        
    }
};

export const handleECHeader = (payload,dispatch) => {

    try {
      dispatch({type:"HANDLE_EC_HEADER",payload})
    }
    catch (ex) {
        catchJSException('buildProductState','handleEcHeader', ex);
    }
}

export const fetchCeapps = (dispatch, visitId, couponFlowType, vRoomCount = null, reAttemptCount = 0) => {
    try {
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchCeapps', "Inside fetchCeapps"));
        logKafka("INFO", "BuildProduct", "Inside fetchCeapps", kafkaPageLogs, "applogs", visitId);
        let flowRouteValue = store.getState().signIn && store.getState().signIn.response && store.getState().signIn.response.flowRoute;
        if(flowRouteValue == 'FULLDISCONNECT'){
          return;
        }
        let url = apiUrl().getProductEc + '/equipments';  
        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
            url = url + '?isMnFlow=Y';
        }
        const retryCountFromAEM = store && store.getState() && store.getState().loopQual?.runtimeKey?.productRetryCount ? parseInt(store.getState().loopQual?.runtimeKey?.productRetryCount) : 0;
        if(reAttemptCount > 0 && reAttemptCount < retryCountFromAEM) {
            url = url + `?retry=${reAttemptCount}`;
        }
        let isTvProductSelected = store.getState().buildProduct && store.getState().buildProduct.tv && InHomeUtils.isNotNull(store.getState().buildProduct.tv.selectedProduct) && store.getState().signIn.response.classicToFcp ? true : false;
        let ceappsTVOnProfile = store.getState().ecProfileCart && store.getState().ecProfileCart.ProfileTVProduct ? store.getState().ecProfileCart.ProfileTVProduct: null;
        api(url, 'POST', getRequest(visitId, Contract.monthToMonth, 'ceapps', couponFlowType)).then(response => {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Fetching Streaming Products", isLoaderImg: "loader" } });
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.products) && response.data.products.length > 0) {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'fetchceapps', "Connected TV Apps"));
               // response.data.products.forEach((prod) => setHtmlSymbols(prod));
            //    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "Fetching Streaming Products", isLoaderImg: "loader" } });
               if(response.data.products.length) {
                    dispatch({
                        type: 'FETCH_CEAPPS',
                        value: response.data.products
                    })
                }
                let productOnProfile = response.data.products.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile);
                if (productOnProfile.length > 0) {
                    let filteredProducts = [];
                    dispatch({ type: 'IS_CEAPPS_ONCSR', value: true });
                    connectionChoicesRequired(true, dispatch); 
                    if (productOnProfile[0] && productOnProfile[0].prodType === Service.ceAppsBundle) {
                        filteredProducts = response.data.products.filter(v=>v.prodType === 'CEDEVICEAPPBNDL');
                    }
                    else {
                        filteredProducts = response.data.products;
                    }
                    let  cloneCEApps = JSON.parse(JSON.stringify(filteredProducts));                    
                    let displayCEAppProducts = cloneCEApps.map(p => {
                        if(p.prodType === Service.ceAppsParity) {
                            let profileQuantity = p.quantity? p.quantity : "1";
                            p.name = `${profileQuantity} ${p.name}${profileQuantity > 1 && (!p.name.toUpperCase().includes('DEVICES') && !p.name.toUpperCase().includes('(S)')) ? 's' : ''}`;                            
                            p.unitCount = p.quantity ? p.quantity.toString(): "1";
                            p['description']  = `<ul><li>Watch on ${p.quantity? p.quantity : 1} of your streaming devices only</li><li>Device Authorization required</li><li> 2 Authorizations allowed per month per device</li></ul>`;
                        }
                        else if(p.prodType === Service.ceAppsBundle) {
                            p.unitCount = '1';
                            p['description']  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to 2 devices at once</li><li>Device authorization not required</li></ul>`;
                        }
                        return p;
                    })
                    dispatch({ type: 'UPDATE_CEAPPS', value: displayCEAppProducts });
                }
                else if ((vRoomCount && vRoomCount.indexOf('1') > -1) || (isTvProductSelected|| ceappsTVOnProfile !== null )) {
                    let displayCEAppProducts = [];
                    let displayAccorCEAppProducts = [];
                    let cloneCEApps = JSON.parse(JSON.stringify(response.data.products));
                    let bundleCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle);
                    if(bundleCEApps && bundleCEApps.length) {
                        bundleCEApps = bundleCEApps[0];
                        let noCEApps = { ...bundleCEApps,
                                            id: 'NOCEAPPS',
                                            name: 'I don\'t want to use a Connected TV Device',
                                            accordionTitle: 'I don\'t want to use a Connected TV Device',
                                            originalPrice: '0',
                                            displayPrice: '$0.00',
                                            isprdOnProfile: false
                                        };                        
                                        bundleCEApps["unitCount"] = '1';
                                        bundleCEApps["description"]  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to 2 devices at once</li><li>Device authorization not required</li></ul>`;
                        displayAccorCEAppProducts.push(bundleCEApps);
                        displayAccorCEAppProducts.push(noCEApps);
                    } 
                    dispatch({ type: 'UPDATE_ACCOR_CEAPPS', value: displayAccorCEAppProducts });

                }

                connectedTvSectionStatus(true, dispatch);
                
                if (InHomeUtils.isNotNull(response.data.products.map(p => p)) && response.data.products.map(p => p).length > 0) {
                    dispatch({ type: 'EQUIPMENT_LOAD_STATUS', value: { Ceapps: true } });
                }

                                    
                InHomeUtils.isNotNull(response.data.products) && response.data.products.map((p) =>{
                    if(p.prodType === "CEDEVICEAPPBNDL" && p.offerRemainingDays > -1){
                        let displayCEAppProducts = [];
                        let displayAccorCEAppProducts = [];
                        let cloneCEApps = JSON.parse(JSON.stringify(response.data.products));
                        let bundleCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle);
                        if(bundleCEApps && bundleCEApps.length) {
                            bundleCEApps = bundleCEApps[0];
                                let optIn =     {
                                                    id: 'optIn',
                                                    name: 'I would like to select individual streaming device connection.',
                                                    accordionTitle: 'I would like to select individual streaming device connection.',
                                                    originalPrice: '',
                                                    displayPrice: '',
                                                    isprdOnProfile: false,
                                                    prodTypeValue : null,
                                                    isChecked : true
                                                };  
                                let optOut =    {      
                                                    id: 'optOut',
                                                    name: `I don't want to use a streaming device.`,
                                                    accordionTitle: `I don't want to use a streaming device.`,
                                                    originalPrice: '',
                                                    displayPrice: '',
                                                    isprdOnProfile: false,
                                                    prodTypeValue : null,
                                                    isChecked : true

                                                };
                                    bundleCEApps["unitCount"] = '1';
                                    bundleCEApps["description"]  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to 2 devices at once</li><li>Device authorization not required</li></ul>`;                      
                                    
                                displayAccorCEAppProducts.push(bundleCEApps);
                                displayAccorCEAppProducts.push(optIn);
                                displayAccorCEAppProducts.push(optOut);
                            }    
                            dispatch({ type: 'UPDATE_ACCOR_CEAPPS', value: displayAccorCEAppProducts });     
                    }
                    else if (p.prodType === "CEDEVICEAPPBNDL" && p.offerRemainingDays == -1){
                        let noOfferDisplayAccorCEAppProducts = [];
                        let noOfferCloneCEApps = JSON.parse(JSON.stringify(response.data.products));
                        let noOfferBundleCEApps = noOfferCloneCEApps.filter(p => p.prodType === Service.ceAppsBundle);
                        if(noOfferBundleCEApps && noOfferBundleCEApps.length) {
                            noOfferBundleCEApps = noOfferBundleCEApps[0];
                        
                                let noOfferOptOut =    {    
                                                    ...noOfferBundleCEApps,  
                                                    id: 'NOCEAPPS',
                                                    name: `I don't want to use a streaming device.`,
                                                    accordionTitle: `I don't want to use a streaming device.`,
                                                    originalPrice: '0',
                                                    displayPrice: '$0.00',
                                                    isprdOnProfile: false,
                                                    
                                                };
                                    noOfferBundleCEApps["unitCount"] = '1';
                                    noOfferBundleCEApps["description"]  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to 2 devices at once</li><li>Device authorization not required</li></ul>`;                      
                                    
                                noOfferDisplayAccorCEAppProducts.push(noOfferBundleCEApps);
                                noOfferDisplayAccorCEAppProducts.push(noOfferOptOut);
                            }    
                            dispatch({ type: 'UPDATE_ACCOR_CEAPPS', value: noOfferDisplayAccorCEAppProducts });     
                    }

                    
                })
            }
            else if (reAttemptCount < retryCountFromAEM) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchceapps', "ceapps " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, PAGEACTIVITY.UA));
                logKafka("INFO", "BuildProduct", "ceapps " + PAGEACTIVITY.MSG.productNotFound + " - Attempt " + reAttemptCount, kafkaPageLogs, "applogs", visitId);
                fetchCeapps(dispatch, visitId, couponFlowType, vRoomCount, (reAttemptCount + 1))
            }
            else {

                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'fetchceapps', "ceapps " + PAGEACTIVITY.MSG.productNotFound + " - ReAttempt", PAGEACTIVITY.UA));
                // errorAction("LBO", "BuildProduct", "ProductNotReturned-ceApps", "", visitId, dispatch, true, "ProductNotReturned-ceApps");
                let errorMsg = `MethodName:fetchceapps,errorMessage:ProductNotReturned`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);

            }
        })
            .catch(error => {                
                let errorMsg = `MethodName:fetchceapps,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'fetchceapps', ex);
    }
};

const setTVConnectionsView = (vRoom, profilestbCount, tvConnections, isChecked, visitId, dispatch) => {
    try {
        let displayTVConnectionsProducts = [];
        let vRoomCount = vRoom && vRoom.unitCount ? parseInt(vRoom.unitCount) : 0;  
        let profileVRoom = profilestbCount ?  parseInt(profilestbCount) : 0;
        let profileDummyVRoom = tvConnections.equipments && tvConnections.equipments.length ? tvConnections.equipments.filter(v=>v.isprdOnProfile) : '';
        let profileDummyVRoomCount = profileDummyVRoom && profileDummyVRoom.length ? profileDummyVRoom[0].unitCount: 0;
        // if (vRoomCount > profileVRoom) {
        //     vRoomCount = vRoomCount - profileVRoom;
        // }
        // else {
        //     vRoomCount = profileVRoom - vRoomCount;
        // }
        if (vRoomCount === 0 && profileVRoom > 0) {
            vRoomCount =  profileVRoom;
        }

        if(!isChecked && vRoomCount && tvConnections && tvConnections.equipments && tvConnections.equipments.length) {
            if (profileDummyVRoomCount > 0 && (vRoomCount < profileDummyVRoomCount) ) {
                displayTVConnectionsProducts = tvConnections.equipments.filter(p => (p => p && p.unitCount && parseInt(p.unitCount) <= vRoomCount && parseInt(p.unitCount) >= vRoomCount - 2) || p.isprdOnProfile);
                displayTVConnectionsProducts = displayTVConnectionsProducts.map(p => {
                  if(p.isprdOnProfile) {
                      p.isDisable = true;                        
                    }
                    return p;
                })

            }            
            else
            {
                displayTVConnectionsProducts = tvConnections.equipments.filter(p => (p && p.unitCount && parseInt(p.unitCount) <= vRoomCount && parseInt(p.unitCount) >= vRoomCount - 2) || p.isprdOnProfile );
                displayTVConnectionsProducts = displayTVConnectionsProducts.map(p => {                  
                        p.isDisable = false;                     
                        return p;
                  })
            }
            
        }
        dispatch({ type: 'UPDATE_TVCONNECTIONS', value: displayTVConnectionsProducts });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setTVConnectionsView', ex);
    }
}

const setCEAppsView = (tvConnections, ceApps, vRoom, recording, isChecked, visitId, dispatch, currentVRoom) => {
    try {
        let displayCEAppProducts = [];
        let displayAccorCEAppProducts = [];
        const tvConnectionsCount = tvConnections && tvConnections.unitCount ? parseInt(tvConnections.unitCount) : 0;
        let prdOnProfileConnection =  tvConnections && tvConnections.isprdOnProfile? true: false;
        let selectedvRoomProd = [];
        if(currentVRoom) {
            selectedvRoomProd.push(currentVRoom);
        }
        else{
            selectedvRoomProd = vRoom && vRoom.selectedProduct && (vRoom.selectedProduct.prodId || vRoom.selectedProduct.id) && vRoom.equipments && vRoom.equipments.filter(p => p && (p.id === vRoom.selectedProduct.prodId || p.id === vRoom.selectedProduct.id));
            if (InHomeUtils.isNull(selectedvRoomProd)) {
                selectedvRoomProd = vRoom && vRoom.equipments ? vRoom.equipments.filter(v=> v.isprdOnProfile) : null;
            }
        }
        // selectedvRoomProd = vRoom && vRoom.selectedProduct && (vRoom.selectedProduct.prodId || vRoom.selectedProduct.id) && vRoom.equipments && vRoom.equipments.filter(p => p && (p.id === vRoom.selectedProduct.prodId || p.id === vRoom.selectedProduct.id));
        let profileVRoomProduct = vRoom.equipments.filter(v=> v.isprdOnProfile);
        let vRoomCount = selectedvRoomProd && selectedvRoomProd.length && selectedvRoomProd[0].unitCount ? parseInt(selectedvRoomProd[0].unitCount) : 0;
        let profilevRoomCount = profileVRoomProduct && profileVRoomProduct.length && profileVRoomProduct[0].unitCount ? parseInt(profileVRoomProduct[0].unitCount) : 0;
        let selectedDvr = recording && recording.selectedProduct;
        let profileDVR = null;
        if (selectedDvr && selectedDvr.length === 0) {
            profileDVR = recording.equipments.filter(v=> v.isprdOnProfile);
        }
        let ispremiumDVR = ((selectedDvr && selectedDvr.prodTypeValue === 'PM-DVR')) ? true: false;
        if (profileDVR && profileDVR[0] && profileDVR[0].prodTypeValue === 'PM-DVR' && !ispremiumDVR) {
            ispremiumDVR = true;
        } 
        // if (selectedvRoomProd && selectedvRoomProd[0] && selectedvRoomProd[0].unitCount > 1) {
        //     if (vRoomCount > profilevRoomCount) {
        //         vRoomCount = vRoomCount - profilevRoomCount;
        //     }
        //     else {
        //         vRoomCount = profilevRoomCount - vRoomCount;
        //     }
        // }
        if(vRoomCount && ceApps && ceApps.equipments && ceApps.equipments.length) {
            let productOnProfile = ceApps.equipments.filter(e => e.isprdOnProfile !== undefined && e.isprdOnProfile); 
            if (prdOnProfileConnection && ceApps.equipments.filter(v=>v.isprdOnProfile).length > 0) {                
                    let filteredProducts = [];
                    if (productOnProfile[0] && productOnProfile[0].prodType === Service.ceAppsBundle) {
                        filteredProducts = ceApps.equipments.filter(v=>v.prodType === 'CEDEVICEAPPBNDL');
                    }
                    else {
                        filteredProducts = ceApps.equipments;
                    }
                    let  cloneCEApps = JSON.parse(JSON.stringify(filteredProducts));                    
                       displayCEAppProducts = cloneCEApps.map(p => {
                        if(p.prodType === Service.ceAppsParity) {
                            let profileQuantity = p.quantity? p.quantity : "1";
                            p.name = `${profileQuantity} ${p.name}${profileQuantity > 1 && (!p.name.toUpperCase().includes('DEVICES') && !p.name.toUpperCase().includes('(S)')) ? 's' : ''}`;                            
                            p.unitCount = p.quantity ? p.quantity.toString(): "1";
                            p['description']  = `<ul><li>Watch on ${p.quantity? p.quantity : 1} of your streaming devices only</li><li>Device Authorization required</li><li> 2 Authorizations allowed per month per device</li></ul>`;
                        }
                        else if(p.prodType === Service.ceAppsBundle) {
                            p.unitCount = '1';
                            p['description']  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to 2 devices at once</li><li>Device authorization not required</li></ul>`;
                        }
                        return p;
                    })


            }
            else if((vRoomCount) || (tvConnectionsCount && !prdOnProfileConnection && tvConnectionsCount === vRoomCount)) {                
                    displayCEAppProducts = [];
                    let cloneCEApps = JSON.parse(JSON.stringify(ceApps.equipments));
                    let bundleCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle);
                    if(bundleCEApps && bundleCEApps.length) {
                        bundleCEApps = bundleCEApps[0];
                        let noCEApps = { ...bundleCEApps,
                                            id: 'NOCEAPPS',
                                            name: 'I don\'t want to use a Connected TV Device',
                                            accordionTitle: 'I don\'t want to use a Connected TV Device',
                                            originalPrice: '0',
                                            displayPrice: '$0.00',
                                            isprdOnProfile: false
                                        };
                        const vRoomprice =  selectedvRoomProd[0].displayPrice ? parseInt(selectedvRoomProd[0].displayPrice.replace('$','')) : 0;
                        const stbPrice = tvConnections && tvConnections.displayPrice ? parseInt(tvConnections.displayPrice.replace('$','')) : 0;
                        const ceBundlePrice = bundleCEApps.displayPrice ? parseInt(bundleCEApps.displayPrice.replace('$','')) : 0;
                        const dynamicPrice = stbPrice + ceBundlePrice - vRoomprice;
                        let displayPrice = dynamicPrice ? dynamicPrice < 0 ? `$${dynamicPrice*-1} less/mo` : `$${dynamicPrice} more/mo` : 'same price';
                        bundleCEApps["displayPrice"] = ceBundlePrice > 0 ? `$${ceBundlePrice} more/mo` : ceBundlePrice;
                        bundleCEApps["unitCount"] = '1';
                        bundleCEApps["description"]  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to ${vRoomCount > 5 || ispremiumDVR ? '4' : '2'} devices at once</li><li>Device authorization not required</li></ul>`;
                        displayAccorCEAppProducts.push(bundleCEApps);
                        displayAccorCEAppProducts.push(noCEApps);
                    }
            }
            else if(isChecked || vRoomCount === tvConnectionsCount) {
                displayCEAppProducts = [];
            }
            else if(tvConnectionsCount < vRoomCount) {
                const diff = vRoomCount - tvConnectionsCount;
                let qualifiedParityProduct = diff === 1 || diff === 2 ? diff : 0
                let profileParityProduct = productOnProfile && productOnProfile[0] && productOnProfile[0].prodType === Service.ceAppsParity? productOnProfile[0].quantity : 0;
                // if (profileParityProduct === 2 && qualifiedParityProduct === 1) {
                //     dispatch({ type: 'SHOW_REMOVAL_PARITY_OVERLAY', value: true });
                // }
                let cloneCEApps = JSON.parse(JSON.stringify(ceApps.equipments));
                cloneCEApps = cloneCEApps.filter(p => p.prodType === Service.ceAppsBundle || (qualifiedParityProduct && p.prodType === Service.ceAppsParity));
                displayCEAppProducts = cloneCEApps.map(p => {
                    if(p.prodType === Service.ceAppsParity) {
                        p.name = `${diff} ${p.name}${diff > 1 && (!p.name.toUpperCase().includes('DEVICES') && !p.name.toUpperCase().includes('(S)')) ? 's' : ''}`;
                        p.unitCount = diff.toString();
                        p['description']  = `<ul><li>Watch on ${diff} of your streaming devices only</li><li>Device Authorization required</li><li> 2 Authorizations allowed per month per device</li></ul>`;
                    }
                    else if(p.prodType === Service.ceAppsBundle) {
                        const vRoomprice =  selectedvRoomProd && selectedvRoomProd.length && selectedvRoomProd[0].displayPrice ? parseInt(selectedvRoomProd[0].displayPrice.replace('$','')) : 0;
                        const stbPrice = tvConnections && tvConnections.displayPrice ? parseInt(tvConnections.displayPrice.replace('$','')) : 0;
                        const ceBundlePrice = p.displayPrice ? parseInt(p.displayPrice.replace('$','')) : 0;
                        const dynamicPrice = stbPrice + ceBundlePrice - vRoomprice;
                        let displayPrice = dynamicPrice ? dynamicPrice < 0 ? `$${dynamicPrice*-1} less/mo` : `$${dynamicPrice} more/mo` : 'same price';
                        p.displayPrice = displayPrice;
                        p.unitCount = '1';
                        p['description']  = `<ul><li>Watch on all of your streaming devices</li><li>Streaming up to <br/>${vRoomCount > 4 ? '4' : '2'} devices at <br/>once</li><li>Device authorization not required</li></ul>`;
                    }
                    return p;
                })
            }
        }
        dispatch({ type: 'UPDATE_CEAPPS', value: displayCEAppProducts });
        dispatch({ type: 'UPDATE_ACCOR_CEAPPS', value: displayAccorCEAppProducts });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'setCEAppsView', ex);
    }
}

export const vasProductsViewInTile=(dispatch,vasip)=>{
    try{
    let techsureProducts = store.getState().buildProduct.techsure.techsureProducts || vasip;
   
    let modTechSureProducts=[]
    if(techsureProducts && techsureProducts.filter(each=>each.isprdOnProfile).length>0){
        if(techsureProducts.filter(each=>each.isprdOnProfile&&each.id==="7486943"||each.isprdOnProfile&&each.id==="7487040").length>0){
            modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486399")

        }
        else if(techsureProducts.filter(each=>each.isprdOnProfile&&each.id==="7486399")){
            modTechSureProducts=techsureProducts
        
        }else{
            modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486399")

        }

    }else{
        /**new connct vas */
        if(techsureProducts.filter(each=>each.id==="7487729"&& each.isChecked || each.isprdOnProfile)){
            modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486399")
        }else{
            modTechSureProducts=techsureProducts.filter(each=>each.id!=="7486966")
        }        
    }
    /* let checkvasip = false;
    for(let product in vasip){
        if (vasip[product].isChecked)
            checkvasip = true
    }
   if(!checkvasip){
        dispatch({type:"EC_TECHSURE_SELECTEDPROD",modTechSureProducts,value:null})
    }*/
    return modTechSureProducts
}catch(error){
    console.log("error",error)
    catchJSException('vasProductsViewInTile', 'failedToGetVasProducts');
}
}
export const addVasDisconnectKeys=(dispatch,product,vasip)=>{
    try{
    let disconnectedProducts = []

    if( product && product.prodType==='PPP' && !product.isprdOnProfile){
        let buildProductRedcuer = store.getState().buildProduct.techsure
        disconnectedProducts = buildProductRedcuer.techsureProducts.filter(each=>each.isprdOnProfile===true)
        var exclusionList=product.exclusionList
        disconnectedProducts && disconnectedProducts.map(each=>{
            if(exclusionList && exclusionList.includes(each.id || each.prodId)){
                if(each.disconnect === undefined){
                    each.disconnect =  false
                }
                if(!product.isChecked){
                    each.disconnect = true
                }else{
                    each.disconnect = false                    
                }
            }   
        })       
        dispatch({type:"UPDATE_VAS_PRODS_WITH_KEY",value:disconnectedProducts})
    }
    else if(product && product.prodType==='PPP' && product.isprdOnProfile){
           disconnectedProducts=store.getState().buildProduct.techsure.disconnectedProducts ? store.getState().buildProduct.techsure.disconnectedProducts :[]
           
            if(disconnectedProducts.filter(each=>each.id==product.id || each.prodId === product.id).length === 0){
            disconnectedProducts.push(product)
            }
            if(disconnectedProducts.length > 0){
            disconnectedProducts.filter(each=>each.id===product.id || each.prodId===product.id)[0].disconnect 
            = !disconnectedProducts.filter(each=>each.id===product.id || each.prodId===product.id)[0].disconnect
            // console.log("disconnected",disconnectedProducts)
            dispatch({type:"UPDATE_VAS_PRODS_WITH_KEY",value:disconnectedProducts})
            }
        }
            
    }catch(error){
        console.log("error",error)
    }
}

//Smartcart changes for EC flow
export const setCEAppsForSC = (cart,buildProduct,dispatch,visitId) => {
    try {
        let hasFiosConnectedTVProducts = false;
        let cartProducts = getCartProducts(cart,visitId);
        if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
            let vRoom = null;
            let dummyvRoom = null;
            let ceApps = null;
            if (cartProducts.CartSubProduct.Equipment.equipment) {
                cartProducts.CartSubProduct.Equipment.equipment.forEach(function (prod) {
                    if ((prod.prodType === 'VROOM' || prod.prodType === 'DUMMYVROOM' || prod.prodType === 'CEDEVICEAPP' || prod.prodType === 'CEDEVICEAPPBNDL')) {
                        hasFiosConnectedTVProducts = true;
                    }
                });
                if (hasFiosConnectedTVProducts) {
                    vRoom = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.vRoom);
                    ceApps = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.ceAppsParity || p.prodType === Service.ceAppsBundle);
                    dummyvRoom = cartProducts.CartSubProduct.Equipment.equipment.filter(p => p.prodType === Service.dummyvRoom);
                    vRoom = vRoom && vRoom.length ? vRoom[0] : null;
                    ceApps = ceApps && ceApps.length ? ceApps[0] : null;
                    dummyvRoom = dummyvRoom && dummyvRoom.length ? dummyvRoom[0] : null;

                    if (vRoom.unitCount !== buildProduct.vRoom.unitCount) {
                        if (buildProduct.showConnectedApps) {
                            dispatch({ type: Service.vRoom + '_SELECTEDPROD_CEAPPS', value: { vRoom, ceApps, dummyvRoom } });
                        }
                        else {
                            dispatch({ type: Service.vRoom + '_SELECTEDPROD', value: vRoom });
                        }
                    }
                    dispatch({ type: Service.ceAppsParity + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                    dispatch({ type: Service.dummyvRoom + '_SELECTEDPROD', value: { vRoom, ceApps, dummyvRoom } });
                    connectionChoicesRequired(true, dispatch);
                    let profileStbCount = null;
                    let onProfileSetUpBox = InHomeUtils.isNotNull(buildProduct) && InHomeUtils.isNotNull(buildProduct.vRoom) && InHomeUtils.isNotNull(buildProduct.vRoom.equipments) ? buildProduct.vRoom.equipments.filter(v => v.isprdOnProfile === true) : null;
                    if (onProfileSetUpBox && onProfileSetUpBox.length > 0) {
                        profileStbCount = onProfileSetUpBox && onProfileSetUpBox[0].unitCount ? parseInt(onProfileSetUpBox[0].unitCount) : 0;
                    }
                    else {
                        profileStbCount = 0;
                    }
                    setTVConnectionsView(vRoom, profileStbCount, buildProduct.tvConnections, false, visitId, dispatch);
                    setCEAppsView(dummyvRoom, buildProduct.ceApps, buildProduct.vRoom, buildProduct.recording, false, visitId, dispatch, vRoom);
                    console.log("setCEAppsForSC method called");
                }
            }            
        }
     } 
      catch (ex) {
        catchJSException('BuildProduct', visitId, 'setCEAppsForSC', ex);
        console.log("setCEAppsForSC"+ ex);
    } 
}

export const enableMixMatch2Acc = (dispatch) => {
    dispatch({ type: 'ENABLE_MIXMATCH2_ACC' });
};

export const getCoreDataProductFromPlanPerks = (products, prodValue, visitId) => {
    try {
        if (InHomeUtils.isNotNull(products) && InHomeUtils.isNotNull(prodValue)) {
            for (let count = 0; count < products.length; count++) {
                for (let len = 0; len < products[count].planPerks.length; len++) {                    
                    if (InHomeUtils.isNotNull(products[count].id) && products[count].planPerks[len].id === prodValue) {
                        return products[count];
                    }
                }
            }
        }
        return null;
    }
    catch (err) {
        catchJSException('BuildProduct', visitId, 'getCoreDataProductFromPlanPerks', err);
    }
}


export const setDataPerksForSC_ECFlows = (cart, buildProductState, flowtype, visitId, dispatch, isPega, flag=false) => {
    try {
        let internetProduct = null;
        let dataPerkProduct = null;
        let cartProducts = getCartProducts(cart, visitId);
    
        if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
            cartProducts.DataProduct.dataProd.forEach(function (prod) {
                if ((prod.prodTypeVal === 'STREAMING' || prod.prodTypeVal === 'GAMING' || prod.prodTypeVal === 'COMPLETE')) {
                    dataPerkProduct = prod;
                    let vas = '';
                            setTimeout(() => {
                                !isPega && fetchRouter(dispatch, visitId, flowtype);
                                fetchTechSure(dispatch, visitId, flowtype);
                                let vasProducts = [];

                                vas = cart?.tierContent[0]?.sections?.section[0]?.subSections?.subSection.filter(p => p.sectionType === Service.vasstandalone);
                                if (InHomeUtils.isNotNull(vas) && vas.length > 0 && InHomeUtils.isNotNull(vas[0]) && InHomeUtils.isNotNull(vas[0].products)) {
                                    vasProducts = vas[0].products;
                                }
                                const cloudProd = vasProducts.filter(p => p.isVCloudProd && p.isVCloudProd === 'Yes');
                                dispatch({ type: 'TECHSURECLOUD_SELECTEDPROD', value: cloudProd.length > 0 ? cloudProd : null });

                            }, 3000) 
                }
            });
        }        
        if (InHomeUtils.isNotNull(dataPerkProduct)) {
            internetProduct = getCoreDataProductFromPlanPerks(buildProductState.internet.m2mPlans, dataPerkProduct.prodId, visitId);
            if (InHomeUtils.isNotNull(internetProduct)) {
                dispatch({ type: 'INTERNET_SELECTEDPROD', value: internetProduct });
                dispatch({ type: 'MM3INTERNETSUBPROD', value: internetProduct.planPerks });
                dispatch({ type: 'FETCH_DATASUBPROD', value: internetProduct.planPerks })
                dispatch({ type: "MM3_SELECTEDPROD", value: dataPerkProduct, flag: flag })
                buildProductState.mm3internetsub.subAccordionStatus = "added"
                buildProductState.isDataPerksSetForSCFlow = true;
                dispatch({ type: "PERKS_FOR_SCFLOWS", value: true });
            }
        }

    }
    catch (err) {
        catchJSException('BuildProduct', visitId, 'setDataPerksForSCFlows', err);
    }
}

export const addEquipment = (discount, addonProduct, isChecked, buildProduct) => {
    let freeProduct = [];
    switch(discount) {        
        case EquipmentDiscounts.vRoom :
        case EquipmentDiscounts.vRoomEmp :
            if(InHomeUtils.isNotNull(buildProduct.vRoom.equipments)) {
                freeProduct = buildProduct.vRoom.equipments.filter(p => p.unitCount === '1')[0];
                if (freeProduct && (InHomeUtils.isNull(buildProduct.vRoom.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.vRoom.selectedProduct) && buildProduct.vRoom.selectedProduct.id !== freeProduct.id))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.vRoom);  
                    addonProduct.isRemoved.push(isChecked);
                }
            }
            break;
        case EquipmentDiscounts.recording :
        case EquipmentDiscounts.recordingEmp :
            if(InHomeUtils.isNotNull(buildProduct.recording.equipments)) {
                freeProduct = buildProduct.recording.equipments.filter(p => p.prodTypeValue === 'HD-DVR')[0];
                if(freeProduct && (InHomeUtils.isNull(buildProduct.recording.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.recording.selectedProduct) && buildProduct.recording.selectedProduct.id !== freeProduct.id))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.recording);  
                    addonProduct.isRemoved.push(isChecked);
                }
            }
            break;
        case EquipmentDiscounts.recordingEmpMM2 :
            if(InHomeUtils.isNotNull(buildProduct.recording.equipments)) {
                freeProduct = buildProduct.recording.equipments.filter(p => p.prodTypeValue === 'EM-DVR')[0];
                if(freeProduct && (InHomeUtils.isNull(buildProduct.recording.selectedProduct) || (InHomeUtils.isNotNull(buildProduct.recording.selectedProduct) && buildProduct.recording.selectedProduct.id !== freeProduct.id))) {
                    addonProduct.productInCart.push(freeProduct);
                    addonProduct.prodType.push(Service.recording);  
                    addonProduct.isRemoved.push(isChecked);
                }
            }
            break;
        default: break;
    }
}

export const checkMnhOfferEligible = (dispatch)=>{
    try{
        const profileCart = store.getState().ecProfileCart
        let isMnhOfferElligble = false
        const mnhOfferAttr =["ADVBSOFRT1", "ADVBSOFRT2", "ADVBSOFRT3", "ADVWSOFRT1", "ADVWSOFRT2", "ADVWSOFRT3","ADVBSMRKT1", "MF2DISCF25",'MF2DISCF10','MF2ACTRG5','MF2ACTRG10','MF3DISCF25','MF3DISCF15','MF2MRKF10','MF2MRKF15']
        let promotions =  profileCart.cartData && profileCart.cartData[0] && 
        InHomeUtils.isNotEmpty(profileCart.cartData[0].Promotions) && profileCart.cartData[0].Promotions
        && profileCart.cartData[0].Promotions.promotions
        if(promotions && promotions.length > 0){
        isMnhOfferElligble = promotions.filter(each=>each.OfferAttrValue && mnhOfferAttr.includes(each.OfferAttrValue)).length > 0
        }
        dispatch({type:"MNH_OFFER_CHECK",value:isMnhOfferElligble})


    }catch(error){
        console.log("error",error)
    }
}

export const setMessageForMixedAccounts = (visitId, dispatch, buildProductState) => {
    let setMessage = buildProductState && buildProductState.ecbannerMessage !== undefined && buildProductState.ecbannerMessage !== '' ? buildProductState.ecbannerMessage : '';
    try {
        if (setMessage === '') {
            setMessage = "Your account has both Traditional and Mix & Match products. Your account will need to be fully changed to Mix & Match in order to continue with your order.";   
        }
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'updateSubProductCartonLoad', ex);
    }
    dispatch({ type: 'SET_EC_BANNER_MESSAGE', value: setMessage })
}

export const toggleDataVoiceMultigig= (dispatch) =>{
    try{
       const qamless = store.getState().changeApp.qamless
       if(qamless!=='y'){
 
      let profileMultigigFromPlans = store.getState().buildProduct.internet.m2mPlans.filter(each=>each.isprdOnProfile)
      profileMultigigFromPlans = profileMultigigFromPlans.length > 0 && profileMultigigFromPlans[0].productKeyword.includes("|2G|")
      let profileMultigigFromCart =  store.getState().ecProfileCart.ProfileDataProduct
      profileMultigigFromCart = profileMultigigFromCart && profileMultigigFromCart.prodId === "R0722"
      let cartNewSpeed = store.getState().buildProduct.internet.selectedProduct
      let isMultiGigAdded = cartNewSpeed && cartNewSpeed.downSpeed ==="2048M" && cartNewSpeed.productKeyword.includes('|2G');
      cartNewSpeed = cartNewSpeed && (cartNewSpeed.prodId || cartNewSpeed.id) !== "R0722"
      let profileRouterCHR =  store.getState().buildProduct.router.equipments && store.getState().buildProduct.router.equipments.filter(each=>each.isprdOnProfile)
      profileRouterCHR = profileRouterCHR && profileRouterCHR.length > 0 && profileRouterCHR[0].keyword.includes('|CHR|')
      if(profileMultigigFromCart || profileMultigigFromPlans){
            dispatch({type:"DISABLE_TV_VOICE",value:true})
       
      }
      else if(isMultiGigAdded) {
        dispatch({type:"DISABLE_TV_VOICE",value:true})    
      }
      else {
        dispatch({type:"DISABLE_TV_VOICE",value:false})    
      }
    }

    }catch(error){
        console.log("error",error)
    }
}

export const disableVoiceForSpecficVisionId= (dispatch) =>{
    try{
       const qamless = store.getState().changeApp.qamless
       if(qamless!=='y'){
 
      let profileMultigigFromPlans = store.getState().buildProduct.internet.m2mPlans.filter(each=>each.isprdOnProfile)
      profileMultigigFromPlans = profileMultigigFromPlans.length > 0 && profileMultigigFromPlans[0].productKeyword.includes("|2G|")
      let profileMultigigFromCart =  store.getState().ecProfileCart.ProfileDataProduct
      profileMultigigFromCart = profileMultigigFromCart && profileMultigigFromCart.prodId === "R0722"
      let cartNewSpeed = store.getState().buildProduct.internet.selectedProduct
      let isMultiGigAdded = cartNewSpeed && cartNewSpeed.downSpeed ==="2048M" && cartNewSpeed.productKeyword.includes('|2G');
      cartNewSpeed = cartNewSpeed && (cartNewSpeed.prodId || cartNewSpeed.id) !== "R0722"
      let profileRouterCHR =  store.getState().buildProduct.router.equipments && store.getState().buildProduct.router.equipments.filter(each=>each.isprdOnProfile)
      profileRouterCHR = profileRouterCHR && profileRouterCHR.length > 0 && profileRouterCHR[0].keyword.includes('|CHR|')
      if(profileMultigigFromCart || profileMultigigFromPlans){
            dispatch({type:"DISABLE_VOICE",value:true})
       
      }
      else if(isMultiGigAdded) {
        dispatch({type:"DISABLE_VOICE",value:true})    
      }
      else {
        dispatch({type:"DISABLE_TV_VOICE",value:false})    
      }
    }

    }catch(error){
        console.log("error",error)
    }
}

export const servicesQualified = (dispatch)=>{
    try{
        const signIn  =  store.getState().signIn
        let ecQualifiedServices = signIn.response && signIn.response.services
        && signIn.response.services
        dispatch({type:"QUALFIED_SERVICES",value:ecQualifiedServices})

    }catch(error){
        console.log("error",error)
    }
}

export const fetchRegionId = (dispatch, zip, city, visitId, visitorId, state) => {
    //temp
    let vhoParams = {};
    if (window.location.host.indexOf('localhost') !== -1) {
        vhoParams = {
            regionId: "91905",
            lfa: "PHILADELPHIACITY",
            lfaName: "PHILADELPHIA CITY",
            vhoName: "PHILADELPHIA PA"
        };
    }
    try {
        let url = apiUrl().channelLineupVhoUrl;
        //temp - regionid only on NTE1 for now

        let requestObj = {
            visitid: visitId,
            visitorid: visitorId,
            zip: zip,
            appid: "consumer",
            tarcode: ""
        };
        api(url, 'POST', JSON.stringify(requestObj)).then(response => {
            if (response && response.vhoregionlist && response.vhoregionlist.length) {
                let { vhoregionlist } = response;
                // city = city.toUpperCase();
                // let regionIdCityMatchArr = [];

                //Temp Fix added by Santhosh to avoid city check
                // regionIdCityMatchArr = vhoregionlist;
                ////////////regionIdCityMatchArr = vhoregionlist.filter((el) => {
                ////////////    /* hold          
                ////////////    let elCity = el.vhoname.substr(0, el.vhoname.lastIndexOf(' '));
                ////////////    return elCity === city;
                ////////////    */
                ////////////   return (el.lfaname.indexOf(city) !== -1)
                ////////////});        
                vhoParams = {
                    regionId: InHomeUtils.isNotNull(vhoregionlist[0].regionid) ? vhoregionlist[0].regionid : "",
                    lfa: vhoregionlist[0].lfa,
                    lfaName: vhoregionlist[0].lfaname,
                    vhoName: vhoregionlist[0].vhoname
                };
            } else {
                console.log('fetchRegionId response error ', response);
            }
            dispatch({
                type: 'SET_FIOSFIVE_SEARCH_VHO_PARAMS',
                value: vhoParams
            });
            fetchFiosFiveBasicChannels(dispatch, zip, vhoParams.regionId, state);
        })
            .catch(error => {
                //vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
                console.log('fetchRegionId call error ', error);
            });

    } catch (ex) {
        console.log('fetchRegionId exception ', ex);
    }
};

export const updateEmergServ = (updatedValue,dispatch)=>{
    let selectedProductObject = {
        value: updatedValue,
        prodType:'EmergencyServ'
    }
    dispatch({ type: "EMERGENCY_SERVICES_SELECTEDPROD", value: selectedProductObject, option:updatedValue })
}

export const getFireAlarm = (visitId, dispatch) => {
    try {
        let url = apiUrl().getFireAlarm;
        api(url, 'GET').then(response => {
            if (response) {
               dispatch({
                   type: "SELECTED_FIRE_ALARM_DETAILS", value: response
               })
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'getFireAlarm', "Exception is: " + error.message));
                logKafka("ERROR", "BuildProduct", "Exception is: " + error.message, getErrorLogUrl, "applogs", visitId);
            })
    } catch (ex) {
        catchJSException('BuildProduct', visitId, 'getFireAlarm', ex);
    }
};

export const FiosKeywordSearch = (visitId, dispatch, keywordsearch) => {
    try {
        let url = apiUrl().getKeywordSearch;
        let keywordSearchRequest = JSON.stringify({
            "searchedKeyWords": keywordsearch
          })
        api(url, 'POST', keywordSearchRequest).then(response => {
            if (response) {
               console.log('keyword search', response);
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'FiosKeywordSearch', "Exception is: " + error.message));
                logKafka("ERROR", "BuildProduct", "Exception is: " + error.message, getErrorLogUrl, "applogs", visitId);
            })
    } catch (ex) {
        catchJSException('BuildProduct', visitId, 'FiosKeywordSearch', ex);
    }
};

export const resetBuildProductState = (dispatch) => {
    dispatch({ type: 'RESET_BUILD_PRODUCT_STATE', value: {} });
};

export const FCCLabelData = (dispatch,isocInfo, currentPlanCode)=>{
    try {
        const url = apiUrl().getFccLabel;
        return new Promise((resolve) => {
            api(url, 'GET', '').then((response) => {
             let isocData=[]
             let isGrandFatherPlan=true;
             response.plans?.filter((item)=>{
                if(isocInfo?.includes(item.planCode)){
                    isocData.push(item)
                }
                if(currentPlanCode===item.planCode && isGrandFatherPlan ){
                    isGrandFatherPlan=false
                }
            })
              dispatch({ type: 'FCC_LABEL_INFO', value: isocData});
              if (isGrandFatherPlan && currentPlanCode) {
                FCCGrandFatheredLabelData(dispatch,currentPlanCode)
              }
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:FCCLabelData,errorMessage:${error.message}`;
              logKafka('ERROR', 'FCCLabelData_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('FCCLabelData', 'FCCLabelData', error);
    }
}
export const FCCGrandFatheredLabelData = (dispatch, planCode)=>{
    try {
        const url = apiUrl().getFccLabel+'?planCode='+planCode;
        return new Promise((resolve) => {
            api(url, 'GET', '').then((response) => {
             let isocData=[]
             response.plans?.filter((item)=>{
                    isocData.push(item)
                }) 
              dispatch({ type: 'FCC_GRAND_FATHERED_LABEL_INFO', value: isocData});
              resolve(true);
            })
            .catch((error) => {
              const errorMsg = `MethodName:FCCGrandFatheredLabelData,errorMessage:${error.message}`;
              logKafka('ERROR', 'FCCGrandFatheredLabelData_Failure', errorMsg, getErrorLogUrl, 'applogs');
              resolve(true);
            });
        });
    } catch (error) {
        catchJSException('FCCGrandFatheredLabelData', 'FCCGrandFatheredLabelData', error);
    }
}

export const classicFullDisconnect = (visitId, dispatch) => {
    try {
        let profileCart = store.getState().ecProfileCart 
        logOtherInfo(detailsInfo('BuildProduct', visitId, 'classicFullDisconnect', "Inside classicFullDisconnect"));
        logKafka("INFO", "BuildProduct", "Inside classicFullDisconnect", kafkaPageLogs, "applogs", visitId);
        let url = apiUrl().clearCart + '/' + visitId;
        let request = {
            serviceType: 'ALL',
            productType: 'All',
            disconnect: 'Y',
        }

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response)) {
                if (InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    logOtherInfo(detailsInfo('BuildProduct', visitId, 'classicFullDisconnect', "Response Success"));
                    logKafka("INFO", "BuildProduct", "Response Success", kafkaPageLogs, "applogs", visitId);
                    if (InHomeUtils.isNotNull(response.data)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing)
                        && InHomeUtils.isNotNull(response.data.cartTierPricing.tierContent)
                        && response.data.cartTierPricing.tierContent.length > 0) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'classicFullDisconnect', "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART PRICE : " + response.data.cartTierPricing.tierContent[0].monthlyRcPrice, kafkaPageLogs, "applogs", visitId);
                    }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'classicFullDisconnect', "CART EMPTY", PAGEACTIVITY.UA));
                        logKafka("INFO", "BuildProduct", "CART EMPTY", kafkaPageLogs, "applogs", visitId);
                    }
                    /*dispatch({
                        type: "UPDATE_CART",
                        value: {
                            cartResponse: InHomeUtils.isNull(response?.data?.cartTierPricing) ? null : response?.data?.cartTierPricing,
                            cartHeader: InHomeUtils.isNull(response?.data?.cartTierPricing) ? null : getCartHeader(response?.data?.cartTierPricing.tierContent, visitId),
                            cartData: InHomeUtils.isNull(response?.data?.cartTierPricing) ? null : getCartData(response?.data?.cartTierPricing?.tierContent, visitId),
                            cartOrderDetail: InHomeUtils.isNull(response?.data?.cartTierPricing) ? null : response.data.orderDetail
                        }
                    });
                    profileCart?.ProfileDataProduct && dispatch({ type: 'UPDATEDISCONNECTINTERNET', value: true });
                    profileCart?.ProfileTVProduct && dispatch({ type: 'UPDATEDISCONNECTTV', value: true });
                    profileCart?.ProfileVoiceProduct && dispatch({ type: 'UPDATEDISCONNECTVOICE', value: true });*/
                    }
                else { //error while updating cart
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, visitId, 'classicFullDisconnect', PAGEACTIVITY.MSG.apiResponseFailed, PAGEACTIVITY.UA));
                    let errorMsg = `MethodName:classicFullDisconnect,errorMessage:API Error while updating cart`;
                    logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProduct', visitId, 'classicFullDisconnect', "Exception is: " + error.message));
                let errorMsg = `MethodName:classicFullDisconnect,errorMessage:${error.message}`;
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('BuildProduct', visitId, 'classicFullDisconnect', ex);
    }
}
export const updateNFloffer = (visitid ,dispatch,bundledetails,IDOFNFL,NFLPromo)=>{
    console.log(bundledetails+'bundledetails11111');
    var offerIDOFNFL = '';
    if(IDOFNFL != ''){
        offerIDOFNFL = IDOFNFL;
    } 
    if(NFLPromo != ''){
        NFLPromo = NFLPromo
    }
    var ISOCID = '';
    if(NFLPromo == 'PR10009101'){
        ISOCID =  'R3872';
    } else if (NFLPromo == 'PR10009103'){
        ISOCID =  'R3874';
    } else if (NFLPromo == 'PR10009104'){
        ISOCID =  'R3875';
    } else if (NFLPromo == 'PR10009105'){
        ISOCID =  'R3876';
    } else if (NFLPromo == 'PR10009106'){
        ISOCID =  'R3877';
    } else if (NFLPromo == 'PR10009107'){
        ISOCID =  'R3878';
    } else if (NFLPromo == 'PR10009107'){
        ISOCID =  'R3878';
    } else if (NFLPromo == 'PR10009116'){
        ISOCID =  'R3894';
    } else if (NFLPromo == 'PR10009117'){
        ISOCID =  'R3895';
    } else if (NFLPromo == 'PR10009118'){
        ISOCID =  'R3896';
    } else if (NFLPromo == 'PR10009119'){
        ISOCID =  'R3897';
    } else if (NFLPromo == 'PR10009120'){
        ISOCID =  'R3898';
    } else if (NFLPromo == 'PR10009121'){
        ISOCID =  'R3899';
    } else if (NFLPromo == 'PR10008368'){
        ISOCID =  'R1921';
    } else if (NFLPromo == 'PR10008369'){
        ISOCID =  'R1921';
    } else if (NFLPromo == 'PR10009079'){
        ISOCID =  'R3813';
    }
    console.log('function hitting');
    var splofferrequest = JSON.stringify({ 
        productId:'SPCLDISCOUNT',
        offerId: offerIDOFNFL, //'36272';
        promoId: ISOCID, //'Q4645';
        productType: "OFFER",
        serviceType: 'OFFER',
        quantity: '1',
        contract: 'MTM',
        status: 'add',
        isMnHAuthenticated:'' });
        let splurl =  url = apiUrl().updateCartAcc + '/' + visitid;
        api(splurl, 'POST', splofferrequest).then(response => {
            console.log('hitting URL');
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                console.log('responsespl'+response);
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: response.data.cartTierPricing,
                        cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitid),
                        cartData: getCartData(response.data.cartTierPricing.tierContent, visitid),
                        cartOrderDetail: response.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                    }
                });
            }
        })
}

export const emberInfo = (visitId,dispatch) => {
    try {
      function findNestedObj(entireObj, keyToFind, valToFind) {
        let foundObj;
        JSON.stringify(entireObj, (_, nestedValue) => {
          if (nestedValue && nestedValue[keyToFind] === valToFind) {
            foundObj = nestedValue;
          }
          return nestedValue;
        });
        return foundObj;
      }
      if (
        store &&
        store.getState &&
        store.getState()?.buildProduct &&
        store.getState()?.buildProduct?.internet?.m2mPlans?.length > 0
      ) {
        let m2mPlans = store.getState()?.buildProduct?.internet?.m2mPlans;
  
        let isEmberMrkrInOffer = findNestedObj(
          m2mPlans,
          "BsOfferAttrValue",
          "MF4MRKF15"                                     
        );
        let isEmberDiscInOffer = findNestedObj(
          m2mPlans,
          "BsOfferAttrValue",
          "MF4DISCF15"
        );
          
          let isEmberFlowAEM =
            store &&
            store.getState() &&
            store.getState()?.loopQual &&
            store.getState()?.loopQual?.runtimeKey &&
            store.getState()?.loopQual?.runtimeKey?.isEmberFlow == "Y"
              ? true
              : false;
  
          let isEmberMrkrAEM =
            store &&
            store.getState() &&
            store.getState()?.loopQual &&
            store.getState()?.loopQual?.runtimeKey &&
            store.getState()?.loopQual?.runtimeKey?.isMF4MRKF15 == "Y"
              ? true
              : false;
  
        if (store?.getState()?.ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.length > 0) {
          let promotions = store.getState()?.ecProfileCart?.cartData?.[0]?.Promotions?.promotions;
          isEmberMrkrInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4MRKF15")
            ? true : isEmberMrkrInOffer;
          isEmberDiscInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4DISCF15")
            ? true : isEmberDiscInOffer;
        }
  
        if (store?.getState()?.profileCart?.cartData?.[0]?.Promotions?.promotions?.length > 0) {
          let promotions = store.getState()?.profileCart?.cartData?.[0]?.Promotions?.promotions;
          isEmberMrkrInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4MRKF15")
            ? true : isEmberMrkrInOffer;
          isEmberDiscInOffer = findNestedObj(promotions, "OfferAttrValue", "MF4DISCF15")
            ? true : isEmberDiscInOffer;
        }
  
        let emberVal = {};
        if (isEmberMrkrInOffer !== undefined || isEmberMrkrAEM) {
          emberVal.isMF4MRKF15 = true;
        }
  
        if (isEmberDiscInOffer !== undefined) {
          emberVal.isMF4DISC15 = true;
        }
  
        if (isEmberFlowAEM || isEmberMrkrInOffer !== undefined || isEmberDiscInOffer !== undefined) {
          emberVal.isEmberFlow = true;
        }
  
          dispatch({ type: "SET_EMBER_INFO", value: emberVal });
      }
    } catch (ex) {
      catchJSException("BuildProduct", visitId, "emberInfo", ex);
    }
  };